function Pif (dataPif, default_filters, educationsRelToJob, routes, years, educations) {
    this.id = dataPif.id;
    this.name = dataPif.name;
    this.base = dataPif.base;
    this.base_year = dataPif.base_year;
    this.top = dataPif.top;
    this.educationsId = dataPif.educations;
    this.first_year_order = dataPif.first_year_order;
    this.last_year_order = dataPif.last_year_order;
    this.gateways = dataPif.gateways;
    this.design = dataPif.design;
    this.jobs_existing = dataPif.jobs_existing;
    this.jobs = dataPif.jobs;

    this.default_filters = default_filters;
    this.years = years;
    this.educationsObj = educations;
    this.educationsRelToJob = educationsRelToJob;
    this.routes = routes;

    this.selectedEducation = 0;
    this.filteredEducationsArray = new Array();
}


/*******************************************************************************************************************************************
*                                     Cette fonction va retourner tous les ids des années du pif
********************************************************************************************************************************************/
Pif.prototype.get_years_id = function() {
    var pif = this;
    var years = new Array();
    for (var e = 0; e < pif.educationsId.length; e++) {
        var education = pif.educationsObj[pif.educationsId[e]];
        for (var y = 0; y < education.years.length; y++) {
            var year = education.years[y];
            years.push(year);
        }
    }
    return years;
}

/*****************************************************************************************************************************************************
*                                 Fonction qui va dire si une année fait partie du pif
******************************************************************************************************************************************************/
Pif.prototype.got_year = function (year_id) {
    var pif = this;
    if ('undefined' == typeof this || 'undefined' == typeof year_id) { return false; }
    var years_pif = new Array();
    for (var e = 0; e < pif.educationsId.length; e++) {
        for (var y = 0; y < pif.educationsObj[pif.educationsId[e]].years.length; y++) {
            years_pif.push('' + pif.educationsObj[pif.educationsId[e]].years[y]);
        }
    }
    return -1 < $.inArray('' + year_id, years_pif);
};

/********************************************************************************************************************************************
*                         Cette fonction va retourner le nombre le plus grand obtenu par le résultat de ces 2 fonctions
**********************************************************************************************************************************************/
Pif.prototype.year_width = function (year) {
    pif = this;
    if ('void_up' == year.name) {
        return pif.root_count(year);
    } else if ('void_down' == year.name) {
        return 1;
    } else {
        return Math.max(pif.leaf_count(year), pif.root_count(year));
    }
}

/***********************************************************************************************************************************************
*                                        Cette fonction va retourner le nb d'années suivantes max
*************************************************************************************************************************************************/
Pif.prototype.leaf_count = function (year) {
    pif = this;
    var count = 0;
    if (year.next_years.length) {
        for (var y = 0; y < year.next_years.length; y++) {
            count += pif.leaf_count(pif.years[year.next_years[y]]);
        }
    } else {
        count = 1;
    }
    return count;
};

/***********************************************************************************************************************************************
*                                             Cette fonction va retourner le nombre d'années précédentes
*************************************************************************************************************************************************/
Pif.prototype.root_count = function (year) {
    var count = 0;
    if (year && year.previous_years && year.previous_years.length) {
        for (var y = 0; y<year.previous_years.length; y++) {
            count += pif.root_count(pif.years[year.previous_years[y][0]]);
        }
    } else {
        count = 1;
    }
    return count;
};

/************************************************************************************************************************************
* Fonction pour récupérer le prochain id disponible
************************************************************************************************************************************/
var next_id = 0;
Pif.prototype.get_next_id = function() {
    var years = this.years
    for (year_id in years) {
        next_id = Math.max(years[year_id].id, next_id);
    }
    return next_id + 1;
};

/*******************************************************************************************************************************************************
*                                         Fonction qui va récupérer le background color d'une année
******************************************************************************************************************************************************/
function get_year_background_color (year_id) {
    if (years[year_id]) {
        return years[year_id].education ? educations[years[year_id].education].background_color : 'none';
    }
    return 'none';
}

/*******************************************************************************************************************************************************
*                                         Fonction qui va récupérer le text color d'une année
******************************************************************************************************************************************************/
Pif.prototype.get_year_text_color = function(year_id) {
    var pif = this;
    var text_color = '#ffffff';

    if (pif.years[year_id].education) {
        if (pif.educationsObj[pif.years[year_id].education].text_color) {
            text_color = pif.educationsObj[pif.years[year_id].education].text_color;
        }
    }

    return text_color;
};


/*****************************************************************************************************************************************************
*                 Fonction qui va calculer toutes les annéees suivantes d'une série d'années donnée et va éviter de répéter les doublons
*********************************************************************************************************************************************************/
Pif.prototype.get_next_years_list = function(years_array) {
    var pif = this;
    var years_next = new Array();
    var years_next_ordered = new Array();
    var n = 0;
    for (var i = 0; i < years_array.length; i++) {
        /* Si l'année n'existe pas */
        if ('undefined' == typeof pif.years[years_array[i]]) {
            return false;
        }

        /* Si l'année n'a pas de suivantes */
        if (!pif.years[years_array[i]].next_years.length) {

            var next_id = pif.get_next_id();
            var new_year = {id: next_id, name: 'void_up', diploma: '', previous_years: [[years_array[i],'Aucune']], next_years: [next_id/*au dessus d'une vide, c'est toujours vide*/], order: '', real: false, selectivity: false};
            pif.years[new_year.id] = new_year;
            years_next.push(new_year.id);

        /* Si l'année a des suivantes */
        } else {
            for (var j = 0; j < pif.years[years_array[i]].next_years.length; j++) {
                years_next.push(pif.years[years_array[i]].next_years[j] );
            }
        }
    }

        /* Ici, nous allons insérer dans le tableau final d'abord les années suivantes ayant
         * une seule et unique précédente après bien avoir vérifié si elle n'existait pas*/

    for (var y = 0; y < years_next.length; y++) {

        if (1 >= pif.years[years_next[y]].previous_years.length) {
            if (-1 == $.inArray(years_next[y], years_next_ordered)) {
                years_next_ordered.push(years_next[y]);
            }
        /* Puis, nous insérons dans le tableau final les années suivantes ayant plusieurs précédentes après avoir vérifié si elles ne sont pas déja dans le tableau
        , du coup pas de doublons ! :)*/
        } else if (1 < pif.years[years_next[y]].previous_years.length) {
            if (-1 == $.inArray(years_next[y], years_next_ordered)) {
                years_next_ordered.push(years_next[y]);
            }
        }
    }
    return years_next_ordered;
};


/******************************************************************************************************************************************************
*                                                     Fonction qui va calculer les années de base
*********************************************************************************************************************************************************/

Pif.prototype.get_base_years_id_list = function() {
    var pif = this;
    var base_years = new Array();
    var next_id = pif.get_next_id();

    for (var e = 0; e < pif.educationsId.length; e++) {
        for (var y = 0; y < pif.educationsObj[pif.educationsId[e]].years.length; y++) {
            /* Si une année a le meme ordre que l'ordre le plus bas */
            if (pif.years[pif.educationsObj[pif.educationsId[e]].years[y]].order === pif.first_year_order) {

                /* Si une année a des années précedentes */
                if (pif.years[pif.educationsObj[pif.educationsId[e]].years[y]].previous_years.length) {
                    /* On vide le tableau des années précédentes puis on push */
                    pif.years[pif.educationsObj[pif.educationsId[e]].years[y]].previous_years.length = 0;
                    base_years.push(pif.educationsObj[pif.educationsId[e]].years[y]);

                /* Si une année n'a pas d'années précédentes on push*/
                } else {
                    base_years.push(pif.educationsObj[pif.educationsId[e]].years[y]);
                }

            /* Si une année n'a pas le meme ordre que l'ordre le plus bas mais n'a pas de précédente */
            } else {
                if (!pif.years[pif.educationsObj[pif.educationsId[e]].years[y]].previous_years.length) {
                    var n = pif.years[pif.educationsObj[pif.educationsId[e]].years[y]].order - pif.first_year_order;

                    /* Ajouter n années en fonction de l'écart d'ordre */
                    if (1 == n) {
                        var next_id = pif.get_next_id();
                        var new_year = {id: next_id, name:'void_down', diploma: '', previous_years: [], next_years: [pif.educationsObj[pif.educationsId[e]].years[y]], order: '', real: false, selectivity: false};
                        pif.years[new_year.id] = new_year;
                        base_years.push(new_year.id);
                    } else if (2 == n) {
                        for (var t = 0; t < n; t++) {
                            if (0 == t) {
                                var next_id = pif.get_next_id();
                                var new_year = {id: next_id, name: 'void_down', diploma: '', previous_years: [], next_years: [next_id+1], order: '', real: false, selectivity: false};
                                pif.years[new_year.id] = new_year;
                                base_years.push(new_year.id);
                            } else /*if (n-1 == t)*/ {
                                var next_id = pif.get_next_id();
                                var new_year2 = {id: next_id, name: 'void_down', diploma: '', previous_years: [[new_year.id, 'Aucune']], next_years: [pif.educationsObj[pif.educationsId[e]].years[y]], order: '',real: false, selectivity: false};
                                new_year.next_years.push(next_id);
                                pif.years[new_year2.id] = new_year2;
                            }
                        }
                    } else if (3 <= n) {
                        for (var t = 0; t < n; t++) {
                            if (!t) {
                                var next_id = pif.get_next_id();
                                var new_year = {id: next_id, name: 'void_down', diploma: '', previous_years: [], next_years: [next_id+1], order: '', real: false, selectivity: false};
                                pif.years[new_year.id] = new_year;
                                base_years.push(new_year.id);
                            } else if (t && n-1 > t) {
                                var next_id = pif.get_next_id();

                                var new_year2 = {id: next_id, name: 'void_down', diploma: '', previous_years: [[next_id-1, 'Aucune']], next_years: [next_id+1], order: '', real: false,selectivity: false};
                                pif.years[new_year2.id] = new_year2;
                            } else /*if (n-1 == t)*/ {
                                var next_id = pif.get_next_id();

                                var new_year3 = {id: next_id, name: 'void_down', diploma: '', previous_years: [[new_year2.id, 'Aucune']], next_years: [pif.educationsObj[pif.educationsId[e]].years[y]], order: '', real: false, selectivity: false};
                                new_year2.next_years.push(next_id);
                                pif.years[new_year3.id] = new_year3;
                            }
                        }
                    }
                }
            }
        }
    }
    return base_years;
};


/******************************************************************************************************************************************************
*                                     Fonction qui va créer la matrice contenant les années du pif dans le bon ordre
*******************************************************************************************************************************************************/

Pif.prototype.create_lines_pif = function() {
    var pif = this;
    var base_years = pif.get_base_years_id_list();
    var years_pif = new Array();
    var nb_lines = 1 + Math.abs(pif.last_year_order - pif.first_year_order);
    years_pif.push(base_years);
    if (1 < nb_lines) {
        for (var i = 0; i < nb_lines; i++) {
            var year_line = years_pif[i];
            years_pif.push(pif.get_next_years_list(year_line));
        }
    }
    return years_pif.reverse();
};


/*******************************************************************************************************************************************************
*                                     Fonction qui va retourner toutes les autres années d'une formation à partir d'une année
********************************************************************************************************************************************************/

Pif.prototype.get_others_years = function(year) {
    var pif = this;
    for (var e = 0; e < pif.educationsId.length; e++) {
        if (-1 != $.inArray(year, pif.educationsObj[pif.educationsId[e]].years)) {
            return(pif.educationsObj[pif.educationsId[e]].years);
        }
    }
};


/********************************************************************************************************************************************************
 *                     Fonction qui va retourner la formation d'une année
 *******************************************************************************************************************************************************/

Pif.prototype.get_education = function(year_id) {
    var pif = this;
    if ('undefined' != typeof pif) {
        for (var e = 0; e < pif.educationsId.length; e++) {
            if (-1 != $.inArray(year_id, pif.educationsObj[pif.educationsId[e]].years)) {
                return(pif.educationsId[e]);
            }
        }
    }
};


/*********************************************************************************************************************************
 *                 Fonction qui va dire si une année est la 1ere de sa formation
 **********************************************************************************************************************************/

Pif.prototype.isFirstYear = function(year_id) {
    var pif = this;
    var education = pif.get_education(year_id);
    if (pif.educationsObj[education].years.length) {
        var min_order = Math.min(pif.years[pif.educationsObj[education].years[0]].order, 100);
        return min_order === pif.years[year_id].order;
    } else {
        return null;
    }
};


/***************************************************************************************************************************
 *                         Fonction qui va retourner tous les types de selectivité existants dans un pif
 ***************************************************************************************************************************/

Pif.prototype.get_types_sel_list = function() {
    var pif = this;
    var sel_array = new Array();
    for (var y = 0; y < pif.get_years_id().length; y++) {
        var year = pif.get_years_id()[y];
        for (var p = 0; p < pif.years[year].previous_years.length; p++) {
            if (-1 == $.inArray(pif.years[year].previous_years[p][1], sel_array)) {
                if (pif.years[year].previous_years[p][1] != 'Aucune') {
                    sel_array.push(pif.years[year].previous_years[p][1]);
                }
            }
        }
    }
    return sel_array;
};


/************************************************************************************************************************
 *  Fonction qui calcule la hauteur créé par le pif sans prendre en compte le rectangle de base
************************************************************************************************************************/

Pif.prototype.get_height_max = function(dataset) {
    for (var i = 0; i < dataset.length; i++) {
        var max = 0;
        max += (i * (h_rect + row_padding));
    }
    return max ;
};

Pif.prototype.get_height_max_zoom = function(dataset, doubleColumn) {
    var pif = this;
    for (var i = 0; i < dataset.length; i++) {
        var max = 0;
        max += (i * (h_rect_zoom + row_padding_zoom));
    }

    if (1 == doubleColumn) {
        max = max + pif.get_width_max(dataset) * 0.07 * 2 + row_padding_zoom;
    } else {
        max = max + pif.get_width_max(dataset) * 0.07 + row_padding_zoom;
    }
    return max ;
};


/***************************************************************************************************************************
 * Fonction qui calcule la largeur créé par le pif sans prendre en compte la colonne des ordres
 ************************************************************************************************************************/

Pif.prototype.get_width_max = function(dataset) {
    var pif = this;
    switch (design) {
        case 0 : return pif.get_x(dataset[dataset.length - 1])[pif.get_x(dataset[dataset.length - 1]).length - 1];
        case 1 : return (pif.get_x(dataset[dataset.length - 1])[pif.get_x(dataset[dataset.length - 1]).length - 1]);
    }
    return pif.get_x(dataset[dataset.length - 1])[pif.get_x(dataset[dataset.length - 1]).length - 1];
};


/***************************************************************************************************************************
 * Cette fonction va calculer l'abscisse d'un bloc
 ***************************************************************************************************************************/

Pif.prototype.get_x = function (years_array) {
    var pif = this;
    var x = 0;
    var x_array = new Array()
    var count = 0;
    x_array.push(0);
    for (var y = 0; y < years_array.length; y++) {
        var year = years_array[y];
        if (0 == pif.design) {
            x += pif.year_width(pif.years[year]) * w_rect + pif.year_width(pif.years[year]) * rect_padding;
        } else if (1 == pif.design) {
            x += pif.year_width(pif.years[year]) * w_rect_zoom + pif.year_width(pif.years[year]) * rect_padding_zoom;
        }
        x_array.push(x);
    }
    return x_array;
};


/***************************************************************************************************************************
 * Cette fonction va retourner le titre d'année cropé s'il dépasse des rectangles
 ***************************************************************************************************************************/

Pif.prototype.get_final_year_title = function (year_id, title, double_column, w_curr_rect) {
    var pif = this;
    // largeur de la chaine de caractère en px
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    ctx.font = '13 px';
    var str_width = ctx.measureText(title).width;

    if ('undefined' != typeof title) {
        if (str_width > w_rect * pif.year_width(pif.years[year_id]) - (pif.year_width(pif.years[year_id]) - 1) * rect_padding) {
           if (1 == double_column) {
               return title.substring(0, 26*pif.year_width(pif.years[year_id]) - 8) + '...';
           }
           return title.substring(0, 13*pif.year_width(pif.years[year_id]) - 4) + '...';
        }
    } else {
        //title = pif.years[year_id].name;
        title = pif.educationsObj[pif.get_education(year_id)].name;
    }
    return title;
};

// À supprimer si plus utilisé
/***************************************************************************************************************************
 * Fonction qui découpe le titre de diplome sur plusieurs ligne
 ***************************************************************************************************************************/

Pif.prototype.multiLinesFormation = function (year_id, width, current_formation, w_curr_rect) {

    var pif = this;

    var regex = '.{1,' +width+ '}(\\s|$)|\\S+?(\\s|$)';
    var formation_title_array = pif.educationsObj[pif.get_education(year_id)].name.match( RegExp(regex, 'g') );

    $('#'+current_formation.id).attr('y', -2 - (formation_title_array.length-1)*10);

    var formationTitle = '';
    for (var i = 0; i < formation_title_array.length; i++) {
        if (i) {
            formationTitle += '<tspan x="'+w_curr_rect/2+'" dy="15">';
        }
        formationTitle += formation_title_array[i];
        if (i) {
            formationTitle += '</tspan>';
        }
    }
    return formationTitle;
};

/***************************************************************************************************************************
 * Fonction qui retourne le nom de la formation
 ***************************************************************************************************************************/

Pif.prototype.getFormationTitle = function (year_id, tabid) {
    var pif = this;
    var cpt=0;

    if ((pif.educationsObj[pif.get_education(year_id)].name)) {
        var formation=pif.educationsObj[pif.get_education(year_id)].name;
    }

    var year_count=pif.educationsObj[pif.get_education(year_id)].years.length;


    if (0 > tabid.indexOf(pif.educationsObj[pif.get_education(year_id)].id)) {

        if (0 == year_count || 1 == year_count) {
            var formation_title = formation;
        } else if (2 == year_count) {
            cpt=2;
        } else if (3 == year_count) {
            cpt=1;
        } else {
            cpt=0;
        }
        tabid.push(pif.educationsObj[pif.get_education(year_id)].id);
        tabid[pif.educationsObj[pif.get_education(year_id)].id]=[formation,year_count,cpt,true];
    } else {
        if ((tabid[pif.educationsObj[pif.get_education(year_id)].id][1]-(tabid[pif.educationsObj[pif.get_education(year_id)].id][1]/2) ) <= tabid[pif.educationsObj[pif.get_education(year_id)].id][2]) {

            if (tabid[pif.educationsObj[pif.get_education(year_id)].id][3]) {
                tabid[pif.educationsObj[pif.get_education(year_id)].id][3] = false;
                var formation_title = tabid[pif.educationsObj[pif.get_education(year_id)].id][0];
            }
        }
        tabid[pif.educationsObj[pif.get_education(year_id)].id][2]=tabid[pif.educationsObj[pif.get_education(year_id)].id][2]+1;
    }

    return formation_title;
};


/***********************************************************************************************************************
 * Déclaration de variables globales
 **********************************************************************************************************************/

var w_rect = 70;
var h_rect = 40;
var w_rect_zoom = 90;
var h_rect_zoom = 50;
var w_order_rect = 60;
var h_order_rect = 40;
var zoom_value = 1;

var rect_padding = 17;
var rect_padding_zoom = 20;
var row_padding = 17;
var row_padding_zoom = 25;

var design = -1;

var years = false;
var educations = false;
var zoom = new Array();
var allPif = new Array();
var tabid=[]; /* tableau des formations*/
var formations_tabid_alignement=[];
var formations_tabid_title=[];

/*************************************************************************************************************************
 * Instance le PIF avec les données passées depuis le tpl
 *************************************************************************************************************************/

global.initPif = function (dataPif) {
    tabid=[]; // reset in case if there are several pif in the page
    var pif = new Pif (dataPif.pif, dataPif.default_filters, dataPif.educationsRelToJob, dataPif.routes, dataPif.years, dataPif.educations);

    //permet d'accéder aux bon PIF lorsqu'il y en a plusieurs dans la page
    allPif[pif.id] = pif;

    // utilisé pour la route isolée pour la fonction get_year_background_color
    if (years) {// S'il y a plusieurs pif dans la même page
        $.extend(true, years, dataPif.years);
    } else {
        years = dataPif.years;
    }

    if (educations) {// S'il y a plusieurs pif dans la même page
        $.extend(true, educations, dataPif.educations);
    } else {
        educations = dataPif.educations;
    }

    design = parseInt(pif.design);
    switch (design) {
        case 0 : pif.draw_pif (pif);
            break;
        case 1 : pif.draw_pif_zoom();
            break;
        default: pif.draw_pif (pif);
    }
}


/*************************************************************************************************************************
 * Permet le translate du PIF
 *************************************************************************************************************************/

function zoomed() {
    pifId = $(this).attr('pif');
    var tooltip = d3.select('tooltip_' + pifId);
    var tooltipL = d3.select('tooltipL_' + pifId);
    var pos_init = d3.select('#pif_' + pifId + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];
    var movable_area_w = $('#pif_' + pifId + '_container .pif_years_group_' + pifId)[0].getBoundingClientRect().width;
    var pif_width = $('#pif_' + pifId + '_container').outerWidth();
    var svg = d3.select('#pif_' + pifId + '_area');

    // décalage en fonction des panels
    var shift_left = 0;
    var shift_right = 0;

    if ('full' == view_type) {
        if (($('#left_pan_' + pifId).hasClass('visible') && (480 < $(window).width())) || 1024 < $(window).width()) {
            shift_left += parseInt($('#left_pan_' + pifId).css('width'));
            if ($('#portraits_pan_' + pifId).hasClass('visible') && 768 < parseInt($('#pif_' + pifId + '_container').css('width'))) {
                shift_left += parseInt($('#portraits_pan_' + pifId).css('width'));
            }
        }
    } else {
        if ($('#left_pan_' + pifId).hasClass('visible')) {
            shift_left += parseInt($('#left_pan_' + pifId).css('width'));
        }
    }

    if ((($('#right_pan_' + pifId).hasClass('visible') && (480 < $(window).width())) || (1024 < $(window).width())) && 'full' == view_type) {
        shift_right += parseInt($('#right_pan_' + pifId).css('width'));
    }

    //si le PIF dépasse de la zone visible
    if (movable_area_w + shift_left + shift_right > $('#svg_area_' + pifId)[0].getBoundingClientRect().width) {
        //s'il peut être translaté (s'il est entre les valeurs maxi et mini de translate)
        if (zoom[pifId].translate()[0] > pif_width - shift_right - movable_area_w && zoom[pifId].translate()[0] < shift_left) {
            $('#oni-ico-fleche4_left_pif_' + pifId).css('visibility', 'visible');
            $('#oni-ico-fleche4_right_pif_' + pifId).css('visibility', 'visible');
            $('#half-circle-right_pif_' + pifId).css('visibility', 'visible');
            $('#half-circle-left_pif_' + pifId).css('visibility', 'visible');
            $('#svg_area_' + pifId).css('padding-right', '0px');
            var t = zoom[pifId].translate();
            tx = t[0];
            tx = Math.min(tx, shift_left + 80);
            tx = Math.max(tx, -(movable_area_w - pif_width + shift_right + 80));
            //les toFixed permettent de ne pas avoir de problème avec les match s'il y a une valeur exponentielle
            svg.attr('transform', 'translate(' + tx.toFixed(2) + ', 0) scale(' + zoom_value + ')');
        } else if (zoom[pifId].translate()[0] > shift_left) { // limite gauche
            $('#oni-ico-fleche4_left_pif_' + pifId).css('visibility', 'hidden');
            $('#half-circle-left_pif_' + pifId).css('visibility', 'hidden');

            $('#oni-ico-fleche4_right_pif_' + pifId).css('visibility', 'visible');
            $('#half-circle-right_pif_' + pifId).css('visibility', 'visible');

            // permet de ne pas bloquer le scroll vertical lorsqu'on est sur le bord gauche du pif
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                zoom[pifId].translate([(shift_left).toFixed(2), zoom[pifId].translate()[1]]);
            } else {
                zoom[pifId].translate([(shift_left).toFixed(2), 0]);
            }
            svg.attr('transform', 'translate(' + (shift_left).toFixed(2) + ',0) scale(' + zoom_value + ')');
        } else if (zoom[pifId].translate()[0] < pif_width - shift_right - movable_area_w) { // limite droite
            $('#oni-ico-fleche4_right_pif_' + pifId).css('visibility', 'hidden');
            $('#half-circle-right_pif_' + pifId).css('visibility', 'hidden');

            $('#svg_area_' + pifId).css('padding-right', function() {
               if ('full' == view_type && $('#right_pan_'+ pifId).is(':visible')) {
                   return ($('#right_pan_' + pifId).width() + 40 ) + 'px';
               }
               return '20px';
            });

            $('#oni-ico-fleche4_left_pif_' + pifId).css('visibility', 'visible');
            $('#half-circle-left_pif_' + pifId).css('visibility', 'visible');

            // permet de ne pas bloquer le scroll vertical lorsqu'on est sur le bord droit du pif
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                zoom[pifId].translate([(pif_width - shift_right - movable_area_w).toFixed(2), zoom[pifId].translate()[1]]);
            } else {
                zoom[pifId].translate([(pif_width - shift_right - movable_area_w).toFixed(2), 0]);
            }
            svg.attr('transform', 'translate(' + (pif_width - shift_right - movable_area_w).toFixed(2) + ',0) scale(' + zoom_value + ')');
        }
    } else {
        //si le PIF n'a pas besoin d'être translaté, on met a jour le déplacement vertical, pour la version mobile
        zoom[pifId].translate([pos_init,zoom[pifId].translate()[1]]);
    }

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        tooltip.style('visibility', 'hidden');
        tooltipL.style('visibility', 'hidden');
        //permet de scroller verticalement pour ne pas bloquer l'utilisateur si le pif s'affiche en pleine page
        window.scrollBy(0, -(zoom[pifId].translate()[1])/10);
        zoom[pifId].translate([zoom[pifId].translate()[0], 0]);
    }
}


/*************************************************************************************************************************
 * Fonction qui va dessiner juste le pif
 *************************************************************************************************************************/

Pif.prototype.draw_pif = function() {
    var pif = this;
    var dataset = pif.create_lines_pif ();
    zoom[pif.id] = d3.behavior.zoom().on('zoom', zoomed);

    var container = d3.select('#pif_' + pif.id + '_container');

    // propriétés du PIF
    var pif_width = $('#pif_' + pif.id + '_container').outerWidth();
    var pif_height = $('#pif_' + pif.id + '_container').outerHeight();

    var final_group = container.append('div')
            .attr('class', function () {
                if (pif.top != '') {
                    return 'final_group';
                } else {
                    return 'void_year';
                }
            });

    var rect_final_pif = final_group.append('div').attr('class', 'rect_final_pif');

    var text_final_pif = rect_final_pif.append('div')
            .attr('id', 'text_final_pif')
            .attr('x', (pif.get_width_max(dataset) - rect_padding) / 2 - pif.base.length * 3.5 )
            .attr('y', 15)
            .attr('font-size', 15)
            .text(pif.top);

    /**********************************************************************************************************************
    * On ajoute des caractéristiques à la div qui va wrap le svg principal pour gérer l'affichage d'une infobulle
    ************************************************************************************************************************/
    var svg_principal_area = d3.select('#svg_principal_area_' + pif.id);

    d3.select('#title_pif_' + pif.id).text(pif.name);

    /**********************************************************************************************************************
     * fermer la popin on cliquant dehors
     ************************************************************************************************************************/

    d3.select("body").on("mouseup",function() {
        if (!nodeParentsIdMatch(d3.event.target, 'information_pif_' + pif.id)) {
             $('#information_pif_' + pif.id).removeClass('active');
             $('#information_pif_' + pif.id).css('visibility', 'hidden');
             $('#education_information_pif_' + pif.id).css('display', 'none');
        }
    });

    function nodeParentsIdMatch(node, id) {
        for (var n=node; n.parentNode; n=n.parentNode) {
            if (id == n.id) {
                return true;
            }
        }
        return false;
    }
    /************************************************************************************************************************
    * Création du groupe d'ordre qui va contenir les rectangles et les textes qui contienent les ordres des années par ligne
    ***********************************************************************************************************************/

    var hide_base_pif = 0;

    var svg = svg_principal_area.append('svg')
                                .attr('class', 'svg_area')
                                .attr('id', 'svg_area_' + pif.id)
                                .attr('pif', pif.id)
                                .attr('width', pif_width - 10)
                                .attr('height', '100%')
                                .call(zoom[pif.id])
                                .on('mousewheel.zoom', null)
                                .on('DOMMouseScroll.zoom', null)
                                .on('wheel.zoom', null)
                                .append('g')
                                .attr('id', 'pif_' + pif.id + '_area')
                                .attr('class', 'pif_area')
                                .attr('pif', pif.id);


    /******************************************************************************************************************
    * Création des années du pif en elles memes
    ******************************************************************************************************************/

    /* Création du groupe qui va accueillir toutes les années */

    var pif_years_group = svg.append('g')
                            .attr('id', 'pif_years_group_id' + pif.id)
                            .attr('class', function() {
                                if (pif.get_width_max(dataset) * 2 < $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                                    return 'pif_years_group_' + pif.id + ' double_column';
                                } else {
                                     return 'pif_years_group_' + pif.id;
                                }
                            });

    /* Création d'un groupe pour chaque ligne du pif */

    var line_years = pif_years_group.selectAll('g')
                                    .data(dataset)
                                    .enter()
                                    .append('g')
                                    .attr('class', 'line_year' + pif.id)
                                    .attr('data-order', function(year_ids, i) {
                                        for (var year_id of year_ids) {
                                            if (pif.years[year_id].real) {
                                                if (0 == pif.years[year_id].order) {
                                                   return ' ';
                                                } else if (0 < pif.years[year_id].order) {
                                                   return '+' + pif.years[year_id].order;
                                                }
                                                return pif.years[year_id].order;
                                            }
                                        }
                                        // chaque colone de la ligne n'est pas reel
                                        //console.log(year_ids);
                                        for (var year_id of year_ids) {
                                          var pif_years_id_gived = pif.years[year_id];
                                          var cpt = 0;
                                          var stop = false;
                                          //console.log('Start: ' + year_id );
                                          while (!pif_years_id_gived.real && !stop) {
                                             cpt++;
                                             //console.log(pif_years_id_gived);
                                             if (pif_years_id_gived.previous_years.length > 0) {
                                                 //console.log(pif.years[pif_years_id_gived.previous_years[0][0]]);
                                                 pif_years_id_gived = pif.years[pif_years_id_gived.previous_years[0][0]];
                                             } else {
                                                  stop = true;
                                             }
                                          }
                                          if (!pif_years_id_gived.real) {
                                              if ('Après le bac' == pif.base) {
                                                  return ' +' + cpt;
                                              } else if ('Après la 3e' == pif.base) {
                                                  switch (cpt) {
                                                      case 1:
                                                          return '-2';
                                                          break;
                                                      case 2:
                                                          return '-1';
                                                          break;
                                                      case 3:
                                                          return '';//level bac
                                                          break;
                                                      default:
                                                          return '+' + (cpt-3);
                                                  }
                                              }
                                          }
                                        }
                                        return 'none';
                                    })
                                    .attr('transform', function (year_id_list, i) {return 'translate(0,' + i*(h_rect + row_padding) + ')';});


    /* Création des infobulles pour afficher le chapo */
    var tooltip = svg_principal_area
            .append('div')
            .attr('id', 'tooltip_' + pif.id)
            .attr('class', 'tooltip');
    var tooltipL = svg_principal_area
            .append('div')
            .attr('id', 'tooltipL_' + pif.id)
            .attr('class', 'tooltipL');

    //var height_pif_title = $('#title_pif_' + pif.id).height();

    /* Création d'un groupe pour chaque année */
    var year_cell = line_years.selectAll('g')
            .data(function(year_id_list) {return year_id_list;})
            .enter()
            .append('g')
            .attr('pif', pif.id)
            .attr('class',  function(year_id, i) {
                if (pif.years[year_id].real) {
                    return 'pif_' + pif.id + 'year' + year_id + ' pif_' + pif.id;
                } else {
                    return 'void_year '+ pif.years[year_id].name;
                }
            })
            .attr('data-order', function(year_id) {
                if (pif.years[year_id].real) {
                    $(this).parent().attr('data-order', function() {
                        if ( 0 == pif.years[year_id].order ) {
                            return ' ';
                        } else if ( 0 < pif.years[year_id].order) {
                            return ' +' + pif.years[year_id].order;
                        }
                        return pif.years[year_id].order;
                    });
                } else {
                    return 'void_order ';
                }
            })
            .attr('transform',function (year_id, i) {
                var years_array = this.parentNode.__data__;
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    var x = pif.get_x(years_array)[i]*2;
                } else {
                    var x = pif.get_x(years_array)[i];
                }
                return 'translate(' + x + ',20)';
            })
            .attr('absciss', function(year_id, i) {
                var years_array = this.parentNode.__data__;
                var x = pif.get_x(years_array)[i];
                return x;
            })
            .attr('cell_width', function(year_id) {
                return w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding;
            })
            .style('cursor', function(year_id) {
                if (pif.get_education(year_id)) {
                    if ('Formations' == pif.educationsObj[pif.get_education(year_id)].target) {
                        if ('' != pif.educationsObj[pif.get_education(year_id)].description) {
                            return 'pointer';
                        } else {
                            return 'default';
                        }
                    } else if ('Années' == pif.educationsObj[pif.get_education(year_id)].target) {
                        if ('' != pif.years[year_id].description) {
                            return 'pointer';
                        } else {
                            return 'default';
                        }
                    }
                } else {
                    return 'default';
                }
            })
            .on('mouseover',function(year_id) {
                if (0 > d3.select('.pif_' + pif.id + 'rect_year_' + year_id).attr('class').indexOf('notVisible') && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    /* Si la cible de la formation est la formation, afficher le chapo de la formation dans une infobulle */
                    if (pif.educationsObj[pif.get_education(year_id)].target == 'Formations') {
                        if (pif.educationsObj[pif.get_education(year_id)].chapo != '') {
                            tooltipL.html(pif.educationsObj[pif.get_education(year_id)].chapo);
                            tooltip.html(pif.educationsObj[pif.get_education(year_id)].chapo);
                        }

                        if (diploma_over && '' != pif.years[year_id].diploma && pif.years[year_id].overrider_diploma && 1 == pif.years[year_id].overrider_diploma) {
                            tooltipL.html(pif.years[year_id].diploma);
                            tooltip.html(pif.years[year_id].diploma);

                            var tooltipBB = $('#tooltip_' + pif.id)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltipL
                                .style('visibility', 'visible')
                                .attr("class", "tooltipDL")
                                .style("background-color", "#000000")
                                .style("border-right", "30px solid #000000");
                                tooltip
                                .style('visibility', 'hidden');
                            } else {
                                tooltip
                                .style('visibility', 'visible')
                                .attr("class", "tooltipD")
                                .style("background-color", "#000000")
                                .style("border-right", "30px solid #000000");
                                tooltipL
                                .style('visibility', 'hidden');
                            }
                        } else if (!diploma_over && '' != pif.educationsObj[pif.get_education(year_id)].chapo) {
                            var tooltipBB = $('#tooltip_' + pif.id)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltipL
                                .style('visibility', 'visible')
                                .attr("class", "tooltipL")
                                .style("background-color", "#003243")
                                .style("border-right", "30px solid #003243");
                                tooltip
                                .style('visibility', 'hidden');
                            } else {
                                tooltip
                                .style('visibility', 'visible')
                                .attr("class", "tooltip")
                                .style("background-color", "#003243")
                                .style("border-right", "30px solid #003243");
                                tooltipL
                                .style('visibility', 'hidden');
                            }
                        }

                        if (!diploma_over) {
                            /* Cela va selectionner toutes les autres années du pif et modifier leur opacité */
                            for (var i = 0; i < pif.get_others_years(year_id).length; i++) {
                                d3.select('.pif_' + pif.id + 'rect_year_' + pif.get_others_years(year_id)[i])
                                .attr('opacity', 0.6);
                            }
                        }

                    /* Si la cible de la formation est année, afficher le chapo de l'année dans une infobulle */
                    } else if (pif.educationsObj[pif.get_education(year_id)].target != 'Inactif' && pif.educationsObj[pif.get_education(year_id)].target != '') {
                        if (pif.educationsObj[pif.get_education(year_id)].target != 'Pas de clic') {
                            d3.select('.pif_' + pif.id + 'rect_year_' + year_id).attr('opacity', 0.6);
                        }
                        if (pif.years[year_id].chapo != '') {
                            tooltipL.html(pif.years[year_id].chapo);
                            tooltip.html(pif.years[year_id].chapo);
                        }

                        if (diploma_over && '' != pif.years[year_id].diploma && pif.years[year_id].overrider_diploma && 1 == pif.years[year_id].overrider_diploma) {
                            tooltipL.html(pif.years[year_id].diploma);
                            tooltip.html(pif.years[year_id].diploma);

                            var tooltipBB = $('#tooltip_' + pif.id)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltipL
                                .style('visibility', 'visible')
                                .attr("class", "tooltipDL")
                                .style("background-color", "#000000")
                                .style("border-right", "30px solid #000000");
                                tooltip
                                .style('visibility', 'hidden');
                            } else {
                                tooltip
                                .style('visibility', 'visible')
                                .attr("class", "tooltipD")
                                .style("background-color", "#000000")
                                .style("border-right", "30px solid #000000");
                                tooltipL
                                .style('visibility', 'hidden');
                            }
                        } else if (!diploma_over && '' != pif.years[year_id].chapo) {
                            d3.select('.pif_' + pif.id + 'rect_year_' + year_id).attr('opacity', 0.6);
                            var tooltipBB = $('#tooltip_' + pif.id)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltipL
                                .style('visibility', 'visible')
                                .attr("class", "tooltipL")
                                .style("background-color", "#003243")
                                .style("border-right", "30px solid #003243");
                                tooltip
                                .style('visibility', 'hidden');
                            } else {
                                tooltip
                                .style('visibility', 'visible')
                                .attr("class", "tooltip")
                                .style("background-color", "#003243")
                                .style("border-right", "30px solid #003243");
                                tooltipL
                                .style('visibility', 'hidden');
                            }
                        }
                    } else {
                        if (diploma_over && '' != pif.years[year_id].diploma && pif.years[year_id].overrider_diploma && 1 == pif.years[year_id].overrider_diploma) {

                            tooltipL.html(pif.years[year_id].diploma);
                            tooltip.html(pif.years[year_id].diploma);

                            d3.select("circle#circle_info_icon_"+year_id)
                            .attr('fill', 'white');

                            d3.select("text#info_icon_"+year_id)
                            .attr('fill', 'black');

                            var tooltipBB = $('#tooltip_' + pif.id)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltipL
                                .style('visibility', 'visible')
                                .attr("class", "tooltipDL")
                                .style("background-color", "#000000")
                                .style("border-right", "30px solid #000000");
                                tooltip
                                .style('visibility', 'hidden');
                            } else {
                                tooltip
                                .style('visibility', 'visible')
                                .attr("class", "tooltipD")
                                .style("background-color", "#000000")
                                .style("border-right", "30px solid #000000");
                                tooltipL
                                .style('visibility', 'hidden');
                            }
                        }
                    }
                }
            })
            .on('mousemove', function(year_id) {
                if (-1 == d3.select('.pif_' + pif.id + 'rect_year_' + year_id).attr('class').indexOf('notVisible') && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    if (pif.educationsObj[pif.get_education(year_id)].target != 'Inactif') {
                        if (diploma_over  && '' != pif.years[year_id].diploma && pif.years[year_id].overrider_diploma && 1 == pif.years[year_id].overrider_diploma) {

                            d3.select("circle#circle_info_icon_"+year_id)
                            .attr('fill', 'white');

                            d3.select("text#info_icon_"+year_id)
                            .attr('fill', 'black');

                            var mouse = d3.mouse($(this).closest('#svg_principal_area_' + pif.id).get(0));
                            var tooltipLObj = document.getElementById("tooltipL_" + pif.id);
                            var tooltipLBb = tooltipLObj.getBoundingClientRect();
                            var tooltipBB = $('#tooltip_' + pif.id)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltip
                                .style('visibility', 'hidden')
                                .style('left', mouse[0] + 60 + 'px')
                                .style('top', mouse[1] + 'px');
                                tooltipL
                                .style('visibility', 'visible')
                                .attr("class", "tooltipDL")
                                .style("background-color", "#000000")
                                .style("border-right", "30px solid #000000")
                                .style('left', mouse[0] - (40 + tooltipLBb.width) + 'px')
                                .style('top', mouse[1] + 'px');
                                if (0 > $('#tooltipL_' + pif.id)[0].getBoundingClientRect().left) {
                                    tooltipL.style('left', '0px')
                                    .style('max-width', mouse[0] + 'px')
                                    .style('top', mouse[1] + 'px');
                                } else {
                                    tooltipL.style('max-width', '250px');
                                }
                            } else {
                                tooltip
                                .style('visibility', 'visible')
                                .attr("class", "tooltipD")
                                .style("background-color", "#000000")
                                .style("border-right", "30px solid #000000")
                                .style('left', mouse[0] + 60 + 'px')
                                .style('top', mouse[1] + 'px');
                                tooltipL
                                .style('visibility', 'hidden')
                                .style('left', mouse[0] - (40 + tooltipLBb.width) + 'px')
                                .style('top', mouse[1] + 'px');
                            }
                        } else if (!diploma_over &&
                                ('Formations' == pif.educationsObj[pif.get_education(year_id)].target && '' != pif.educationsObj[pif.get_education(year_id)].chapo
                                ||
                                'Années' == pif.educationsObj[pif.get_education(year_id)].target && pif.years[year_id].chapo != '')
                        ) {
                            var mouse = d3.mouse($(this).closest('#svg_principal_area_' + pif.id).get(0));
                            var tooltipLObj = document.getElementById("tooltipL_" + pif.id);
                            var tooltipLBb = tooltipLObj.getBoundingClientRect();
                            var tooltipBB = $('#tooltip_' + pif.id)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltip
                                .style('visibility', 'hidden')
                                .style('left', mouse[0] + 60 + 'px')
                                .style('top', mouse[1] + 'px');
                                tooltipL
                                .style('visibility', 'visible')
                                .attr("class", "tooltipL")
                                .style("background-color", "#003243")
                                .style("border-right", "30px solid #003243")
                                .style('left', mouse[0] - (40 + tooltipLBb.width) + 'px')
                                .style('top', mouse[1] + 'px');
                                if (0 > $('#tooltipL_' + pif.id)[0].getBoundingClientRect().left) {
                                    tooltipL.style('left', '0px')
                                    .style('max-width', mouse[0] + 'px')
                                    .style('top', mouse[1] + 'px');
                                } else {
                                    tooltipL.style('max-width', '250px');
                                }
                            } else {
                                tooltip
                                .style('visibility', 'visible')
                                .attr("class", "tooltip")
                                .style("background-color", "#003243")
                                .style("border-right", "30px solid #003243")
                                .style('left', mouse[0] + 60 + 'px')
                                .style('top', mouse[1] + 'px');
                                tooltipL
                                .style('visibility', 'hidden')
                                .style('left', mouse[0] - (40 + tooltipLBb.width) + 'px')
                                .style('top', mouse[1] + 'px');
                            }
                            if (pif.educationsObj[pif.get_education(year_id)].target == 'Formations' && pif.educationsObj[pif.get_education(year_id)].chapo == '') {
                                tooltip.style('visibility', 'hidden');
                                tooltipL.style('visibility', 'hidden');
                            }

                            if (pif.educationsObj[pif.get_education(year_id)].target == 'Années' && pif.years[year_id].chapo == '') {
                                tooltip.style('visibility', 'hidden');
                                tooltipL.style('visibility', 'hidden');
                            }

                            if (pif.educationsObj[pif.get_education(year_id)].target == 'Pas de clic' && pif.years[year_id].chapo == '') {
                                tooltip.style('visibility', 'hidden');
                                tooltipL.style('visibility', 'hidden');
                            }
                        } else {
                            tooltip.style('visibility', 'hidden');
                            tooltipL.style('visibility', 'hidden');
                        }
                    }
                }
            })
            .on('mouseout', function(year_id) {
                if (0 > d3.select('.pif_' + pif.id + 'rect_year_' + year_id).attr('class').indexOf('notVisible') && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    d3.select("circle#circle_info_icon_"+year_id)
                    .attr('fill', 'black');

                    d3.select("text#info_icon_"+year_id)
                    .attr('fill', 'white');

                    d3.select(this).attr('opacity', 1)
                    for (var i = 0; i < pif.get_others_years(year_id).length; i++) {
                    d3.select('.pif_' + pif.id + 'rect_year_' + pif.get_others_years(year_id)[i])
                        .attr('opacity', 1)
                    }
                    tooltip.style('visibility', 'hidden');
                    tooltipL.style('visibility', 'hidden');
                }
            })
            .on('click', function(year_id) {
                if (pif.educationsObj[pif.get_education(year_id)].target == 'Inactif' || pif.educationsObj[pif.get_education(year_id)].target == 'Pas de clic') {
                    return false;
                }
                var pifId = $(this).attr('pif');
                if (0 > d3.select('.pif_' + pifId + 'rect_year_' + year_id).attr('class').indexOf('notVisible') && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    var mouse = d3.mouse($(this).closest('#svg_principal_area_' + pifId).get(0));
                    if (pif.educationsObj[pif.get_education(year_id)].target != '') {
                        $('#information_pif_' + pifId).css('height', ''); // pour éviter que la zone d'info soit toujours de la même height
                        var tooltipBB = $('#tooltip_' + pifId)[0].getBoundingClientRect();
                        var tooltipLBB = $('#tooltipL_' + pifId)[0].getBoundingClientRect();
                        var svgBB = $('#svg_area_' + pifId)[0].getBoundingClientRect();
                        tooltipL.style('left', mouse[0] - (40 + tooltipLBB.width) + 'px');
                        if (svgBB.right < tooltipBB.right) {

                            tooltipL.style('visibility', 'visible');
                            tooltip.style('visibility', 'hidden');

                            if (0 > $('#tooltipL_' + pifId)[0].getBoundingClientRect().left) {
                                tooltipL.style('left', '0px')
                                .style('max-width', mouse[0] + 'px')
                                .style('top', mouse[1] + 'px');
                            } else {
                                tooltipL.style('max-width', '250px');
                            }
                        } else {
                            tooltip
                            .style('visibility', 'visible');
                            tooltipL
                            .style('visibility', 'hidden');

                        }
                        if (pif.educationsObj[pif.get_education(year_id)].target == 'Formations' && pif.educationsObj[pif.get_education(year_id)].chapo == '') {
                            tooltip.style('visibility', 'hidden');
                            tooltipL.style('visibility', 'hidden');
                        }

                        if (pif.educationsObj[pif.get_education(year_id)].target == 'Années' && pif.years[year_id].chapo == '') {
                            tooltip.style('visibility', 'hidden');
                            tooltipL.style('visibility', 'hidden');
                        }
                    }
                }

                if (0 > d3.select('.pif_' + pifId + 'rect_year_' + year_id).attr('class').indexOf('notVisible')) {
                    d3.selectAll('.pif_' + pifId).classed('current_opacity', false);

                    if ('Années' == pif.educationsObj[pif.get_education(year_id)].target) {
                        d3.select(this).classed('current_opacity', true);
                        var background_color_formation = $('.current_opacity .rect_year').attr('fill');
                    } else if ('Formations' == pif.educationsObj[pif.get_education(year_id)].target) {
                        //Garde l'opacité au clic
                        for (var i = 0; i < pif.get_others_years(year_id).length; i++) {
                            d3.select('.pif_' + pifId + 'rect_year_' + pif.get_others_years(year_id)[i])
                            .classed('current_opacity', true);
                        }
                        var background_color_formation = $('.current_opacity').attr('fill');
                    }

                    if ($('#information_ref_' + pifId ).length) {
                        $('#information_ref_' + pifId ).remove();
                    }

                    if ('' != pif.years[year_id].diploma
                        && pif.years[year_id].overrider_diploma
                        && 1 == pif.years[year_id].overrider_diploma
                        || !diploma_over
                    ) {
                        if (pif.default_filters || pif.educationsRelToJob) {
                            // on supprime le contenu précédent
                            $('.education_list ul').remove();
                            for(var i in pif.educationsObj[pif.get_education(year_id)].education_type) {
                                pif.display_description_box(pif.educationsObj[pif.get_education(year_id)].education_type[i], background_color_formation, '', diploma_over, year_id);
                                if (pif.educationsRelToJob) {
                                    var list = $('<ul></ul>').appendTo('.education_list_content');
                                    for (var j in pif.educationsRelToJob) {
                                        // on ne récupère que les formations qui sont en relation avec le type de formation correspondant à l'année cliquée
                                        if (pif.educationsObj[pif.get_education(year_id)].education_type[i].id == pif.educationsRelToJob[j].type_formation) {
                                            if ('undefined' !== typeof __rootUrl) {
                                                list.append('<a href=' + __rootUrl + allPif[pifId].educationsRelToJob[j].url + '><li class="education_list_element"> - ' + allPif[pifId].educationsRelToJob[j].libelle_complet + '</li></a>');
                                            } else {
                                                list.append('<a href=' + allPif[pifId].educationsRelToJob[j].url + '><li class="education_list_element"> - ' + allPif[pifId].educationsRelToJob[j].libelle_complet + '</li></a>');
                                            }
                                        }
                                    }
                                    // s'il n'y a pas de formation correspondante, le plier/déplier n'est pas affiché
                                    if ($('.education_list ul li').length) {
                                        $('.education_list').css('visibility', 'visible');
                                        $('#education_information_pif_' + pifId).css('display', 'block');
                                    } else {
                                        $('.education_list').css('visibility', 'hidden');
                                        $('#education_information_pif_' + pifId).css('display', 'none');
                                    }
                                }
                            }
                        } else {
                            if (pif.educationsObj[pif.get_education(year_id)].target == 'Formations') {
                                pif.display_description_box(pif.educationsObj[pif.get_education(year_id)], background_color_formation, 'formation', diploma_over, year_id);
                            } else {
                                pif.display_description_box(pif.years[year_id], background_color_formation, 'formation', diploma_over, year_id);
                            }
                        }
                        //}

                        if (!$('#information_pif_' + pifId).hasClass('active')) {
                            $('#information_pif_' + pifId).addClass('active');
                            $('#information_pif_' + pifId).css('visibility', 'visible');
                        }
                    }
                }
            });


    var g_between_lines = year_cell.append('g')
            .attr('class', function(year_id) {
                if (pif.years[year_id].previous_years.length && pif.educationsObj[pif.get_education(year_id)]) {
                    for (var i = 0; i < pif.educationsObj[pif.get_education(year_id)].years.length; i++) {
                        if (pif.educationsObj[pif.get_education(year_id)].years[i] == pif.years[year_id].previous_years[0][0]) {
                            return 'between_lines between_lines_' + pif.id + ' education_' + pif.get_education(year_id);
                        }
                    }
                }
                return 'between_lines_null';
            });

    var between_lines = g_between_lines.append('rect')
            .attr('x', 0)
            .attr('y', 40)
            .attr('width', function(year_id) {
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding) * 2;
                } else {
                    return w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding;
                }
            })
            .attr('height', row_padding)
            .attr('fill', function(year_id) {
                if (pif.years[year_id].previous_years.length && pif.educationsObj[pif.get_education(year_id)]) {
                    for (var i= 0; i < pif.educationsObj[pif.get_education(year_id)].years.length; i++) {
                        if (pif.educationsObj[pif.get_education(year_id)].years[i] == pif.years[year_id].previous_years[0][0]) {
                            return get_year_background_color(year_id);
                        }
                    }
                }
                return "none";
            })
            .attr('opacity', '0.5');

    /* Création d'un groupe pour chaque année sans artifice */
    var g_year_without_artifice = year_cell.append('g')
                             .attr('class', 'year_without_artifice');

    /* Création d'un rectangle pour définir l'année */
    var rect_year = g_year_without_artifice.append('rect')
            .attr('class', function(year_id) {return 'pif_' + pif.id + 'rect_year_' + year_id + ' rect_year education_' + pif.get_education(year_id) + ' pif_' + pif.id})
            .attr('pif', pif.id)
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', function(year_id) {
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding) * 2;
                } else {
                    return w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding;
                }
            })
            .attr('data-order', function(year_id) {
                try {
                   return pif.years[year_id].order;
                } catch(e) {
                   return '0';
                }
            })
            .attr('height', h_rect)
            .attr('fill', function(year_id) {
                return get_year_background_color(year_id);
            });

    /* Création du titre de l'année */
    var year_title = g_year_without_artifice.append('text')
            .style('cursor', function(year_id) {
                if (pif.get_education(year_id)) {
                    if (pif.educationsObj[pif.get_education(year_id)].target == 'Formations' && pif.educationsObj[pif.get_education(year_id)].description != '') {
                        return 'pointer';
                    } else if (pif.educationsObj[pif.get_education(year_id)].target == 'Années' && pif.years[year_id].description != '') {
                        return 'pointer';
                    }

                    return 'default';
                }
            })
            .attr('text-anchor', function(year_id) {
                return "middle";
            })
            .attr('class', function(year_id) {
                if (pif.get_education(year_id)) {
                    if (pif.educationsObj[pif.get_education(year_id)].target) {
                        return 'year_title education_' + pif.get_education(year_id) + ' year_title_' + pif.id + ' pif_' + pif.id;
                    }
                    return 'year_title disabled education_' + pif.get_education(year_id) + ' year_title_' + pif.id + ' pif_' + pif.id;
                }
            })
            .attr('x', function(year_id) {
                var w_curr_rect = this.parentNode.parentNode.getAttribute('cell_width');
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return w_curr_rect
                } else {
                    return w_curr_rect/2;
                }
            })
            .attr('y', function(year_id) {
                if (pif.years[year_id].real && 'Formations' == pif.educationsObj[pif.get_education(year_id)].display_titles) {
                    var year_count = pif.educationsObj[pif.get_education(year_id)].years.length;
                    if ($.isNumeric(year_count) && year_count > 1) {
                        if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr( 'class' ).indexOf('double_column') > -1) {
                            var width = 26;
                        } else {
                            var width = 13;
                        }

                        var regex = '.{1,' +width+ '}(\\s|$)|\\S+?(\\s|$)';
                        var formation_title_array = pif.educationsObj[pif.get_education(year_id)].name.match( RegExp(regex, 'g') );
                        var childrenNbr = formation_title_array.length;
                        var padding_offset = (childrenNbr < 2 ? 3 : 4);

                        return ( h_rect - ((((year_count*h_rect) + ((year_count - 1)*rect_padding))/2)-7)) - (padding_offset*childrenNbr);
                    }
                }
                return h_rect / 2 + 7;
            })
            .attr('fill', function(year_id) {
                return pif.get_year_text_color(year_id);
            })
            .attr('font-size',13)
            .text(function(year_id) {

                /** formation affiche le text du libelle de la formation en fonction du nbr d'année de cette derniére */
                if (pif.years[year_id].real && 'Formations' == pif.educationsObj[pif.get_education(year_id)].display_titles) {
                    var formation_title = pif.getFormationTitle(year_id, tabid);
                    var w_curr_rect = this.parentNode.parentNode.getAttribute('cell_width');

                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr( 'class' ).indexOf('double_column') > -1) {
                        return  pif.get_final_year_title(year_id, formation_title, 1, w_curr_rect);
                    }
                    return  pif.get_final_year_title(year_id, formation_title, 0, w_curr_rect);
                }
                /** fin formation */
                else if (pif.years[year_id].real && 'Pas de texte' == pif.educationsObj[pif.get_education(year_id)].display_titles) {
                    return '';
                } else if (!pif.years[year_id].real || 'Années' != pif.educationsObj[pif.get_education(year_id)].display_titles) {
                    return '';
                } else if ('Années' == pif.educationsObj[pif.get_education(year_id)].display_titles) {
                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr( 'class' ).indexOf('double_column') > -1) {
                        return pif.get_final_year_title(year_id, pif.years[year_id].name, 1);
                    } else {
                        return pif.get_final_year_title(year_id, pif.years[year_id].name, 0);
                    }
                }
            })
            .append('title')
            .text(function(year_id) {
                if (pif.year_width(pif.years[year_id]) == 1 && pif.years[year_id].name.length > 5 || pif.year_width(pif.years[year_id]) == 2 && pif.years[year_id].name.length > 27 || pif.year_width(pif.years[year_id]) == 3 && pif.years[year_id].name.length > 39) {
                    var year_name = pif.years[year_id].name;

                    if (pif.years[year_id].real && 'Formations' == pif.educationsObj[pif.get_education(year_id)].display_titles){
                        var year_name = pif.getFormationTitle(year_id, formations_tabid_title);
                    }
                    return year_name;
                }
             });

    var diploma_over = false;
    /* Création d'un groupe qui va créer le diplome */
    var g_year_diploma = year_cell.append('g')
                                .attr('class', 'year_diploma');

    /* Création d'un rectangle pour chaque groupe */
    var rect_diploma = g_year_diploma.append('rect')
            .attr('id', function(year_id) {
                if ('' != pif.years[year_id].diploma) {
                    return 'rect_title_diploma_' + pif.id;
                } else if ('void_down' == pif.years[year_id].name
                        && pif.years[year_id].next_years[0]
                        && pif.years[(pif.years[year_id].next_years[0])].order
                        && 1 == pif.years[(pif.years[year_id].next_years[0])].order
                    ) {
                    return 'rect_title_diploma_' + pif.id;
                }
                return 'rect_null_diploma_' + pif.id;
            })
            .attr('class', function(year_id) {
                if ('' != pif.years[year_id].diploma) {
                    return 'rect_title_diploma education_' + pif.get_education(year_id) + ' pif_' + pif.id;
                } else if ('void_down' == pif.years[year_id].name
                        && pif.years[year_id].next_years[0]
                        && pif.years[(pif.years[year_id].next_years[0])].order
                        && 1 == pif.years[(pif.years[year_id].next_years[0])].order
                    ) {
                        return 'rect_title_diploma education_' + pif.get_education(year_id) + ' pif_' + pif.id;
                }
                return 'rect_null_diploma';
            })
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', function(year_id) {
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding) * 2;
                } else {
                    return w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding;
                }
            })
            .attr('height', 6)
            .attr('fill', 'black');

    /* Création d'un titre de diplome au dessus de chaque rectangle */
    var title_diploma = g_year_diploma.append('text')
            .style('cursor', 'default')
            .attr('class', function(year_id) {
                if ('' != pif.years[year_id].diploma) {
                    return 'rect_title_diploma education_' + pif.get_education(year_id) + ' pif_' + pif.id;
                } else if ('void_down' == pif.years[year_id].name
                        && pif.years[year_id].next_years[0]
                        && pif.years[(pif.years[year_id].next_years[0])].order
                        && 1 == pif.years[(pif.years[year_id].next_years[0])].order
                    ) {
                    return 'rect_title_diploma education_' + pif.get_education(year_id) + ' pif_' + pif.id;
                }
                return 'rect_null_diploma';
            })
            .attr('id', function(year_id) {
                return 'title_year_' + year_id;
            })
            .attr('y', -2)
            .attr('x', '50%')
            .attr('fill', 'black')
            .attr('font-weight', 'bold')
            .attr('font-size', 13)
            .text(function(year_id) {
                if (pif.years[year_id].overrider_diploma && 1 == pif.years[year_id].overrider_diploma) {
                    info_circle(year_id, this);
                }
                if ('void_down' == pif.years[year_id].name
                    && pif.years[year_id].next_years[0]
                    && pif.years[(pif.years[year_id].next_years[0])].order
                    && 1 == pif.years[(pif.years[year_id].next_years[0])].order
                ) {
                    return 'Bac';
                }
                return pif.years[year_id].diploma;
            })
            .call(wrapTitleDiploma, year_id);

    g_year_diploma.on('mouseover',function(year_id) {
        if (pif.years[year_id].overrider_diploma && 1 == pif.years[year_id].overrider_diploma) {
            d3.select(this).style('cursor', 'pointer')
        }
        diploma_over = true;
    })
    .on('mouseout', function(year_id) {
        diploma_over = false;
    });

    function info_circle(year_id, current) {

        var circle_info_icon = d3.select(current.parentNode).append('circle')
        .attr('id', "circle_info_icon_"+year_id)
        .attr('fill', 'black')
        .attr('r', '7')
        .attr('cx', function(year_id) {
            if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                return (w_rect*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id])-1) * rect_padding) * 2;
            } else {
                return (w_rect*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id])-1) * rect_padding);
            }
        })
        .attr('cy', -8);

        var info_icon = d3.select(current.parentNode).append('text')
        .attr('id', "info_icon_"+year_id)
        .attr('font-size', "9")
        .attr('fill', 'white')
        .attr('x', function(year_id) {
            if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                return (w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding) * 2 - 5;
            } else {
                return (w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding) - 5;
            }
        })
        .attr('y', -5)

        .text(function(d) { return '\ue611' });
    }


    //permet de centrer les titres des blocs correctement
    title_diploma.attr('x', function(year_id) {
        var title_width = $('#title_year_' + year_id)[0].getBoundingClientRect().width;

        //si on est en mode double colonne
        if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
            if (1 == pif.year_width(pif.years[year_id])) {
                var shift = ((w_rect * 2) - title_width)/2;
            } else {
                var shift = (((w_rect + rect_padding) * pif.year_width(pif.years[year_id])*2) - title_width)/2;
            }
            //si le titre est trop grand et qu'il dépasse, on le met en x = 0
            if (0 > shift) {
                var shift = 0;
            }
            return shift;
        }

        //si on est en mode normal
        if (1 == pif.year_width(pif.years[year_id])) {
            var shift = (w_rect - title_width)/2;
        } else {
            var shift = ((w_rect + rect_padding) * pif.year_width(pif.years[year_id]) - rect_padding - title_width)/2;
        }
        //si le titre est trop grand et qu'il dépasse, on le met en x = 0
        if (0 > shift) {
            var shift = 0;
        }
        return shift;
    });

    /* Création d'un groupe de séléctivitité pour chaque année */
    var g_year_selectivity = year_cell.append('g')
                                    .attr('class', 'year_selectivity_' + pif.id);

    /* On crée un groupe pour toute les années ayant une seule selectivité et pas de précédentes */
    var year_without_previous_selectivity = g_year_selectivity.append('g')
            .attr('class', function(year_id) {
                return 'year_without_previous_selectivity education_' + pif.get_education(year_id) + ' year_without_previous_selectivity_' + pif.id + ' pif_' + pif.id;
            });

    /* On crée un rectangle pour chaque année */
    var year_without_previous_selective_rect = year_without_previous_selectivity
            .append('rect')
            .attr('class', function(year_id) {
                if (pif.years[year_id].unique_selectivity != 'Aucune' && !pif.years[year_id].previous_years.length && pif.years[year_id].unique_selectivity != 'Admission controle continu') {
                    return 'rect_sel_year';
                } else {
                    return 'non_sel_year';
                }
            })
            .attr('x',0)
            .attr('y', h_rect)
            .attr('width', function(year_id) {
                if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding) * 2;
                } else {
                    return w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding;
                }
            })
            .attr('height', 2)
            .attr('fill', 'red');

    /* Création d'un groupe qui va contenir les signes de selectivité */
    var year_without_previous_selective_sign = year_without_previous_selectivity
            .append('circle')
            .attr('class', function(year_id) { if ( pif.years[year_id].unique_selectivity != 'Aucune' && !pif.years[year_id].previous_years.length) { return 'rect_sel_year';} else {return 'non_sel_year';}})
            .attr('cx', function(year_id) {
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id])-1) *rect_padding);
                } else {
                    return (w_rect*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id])-1) *rect_padding)/2;
                }
            })
            .attr('cy', h_rect)
            .attr('r', 6)
            .attr('fill', 'red');

    /* Création d'un groupe qui va contenir touts les symboles de selectivité */
    var year_without_previous_selective_text = year_without_previous_selectivity
            .append('text')
            .attr('class', function(year_id) {
                if ( pif.years[year_id].unique_selectivity != 'Aucune' && !pif.years[year_id].previous_years.length && pif.years[year_id].unique_selectivity != 'Admission controle continu') {
                    return 'rect_sel_year';
                } else {
                    return 'non_sel_year';
                }
            })
            .attr('x', function(year_id) {
                if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1)*rect_padding) - 3.5;
                } else {
                    return (w_rect*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id])  -1)*rect_padding)/2 - 3.5;
                }
            })
            .attr('y', h_rect + 4)
            .attr('font-size', 11)
            .attr('font-weight', 'bold')
            .attr('fill', 'white')
            .text(function(year_id) {
                if ('Sélectif sur concours, dossier, test' == pif.years[year_id].unique_selectivity) {
                    return 'S';
                } else if ('Selectif sur concours' == pif.years[year_id].unique_selectivity) {
                    return 'C';
                } else if ('Selectif par admission parallèle' == pif.years[year_id].unique_selectivity) {
                    return 'A';
                }

            });

    /* On crée un groupe pour toutes les années ayant des précédentes, donc plusieurs séléctivités */
    var year_with_previous_selectivity = g_year_selectivity.append('g')
            .attr('class', function(year_id) {
                return 'year_with_previous_selectivity education_' + pif.get_education(year_id) + ' year_with_previous_selectivity_' + pif.id + ' pif_' + pif.id;
            });

    /* On crée un rectangle pour chaque année précédente */
    var year_with_previous_selective_rect = year_with_previous_selectivity.selectAll('rect')
            .data(function(year_id) {
                var all_previous_years = new Array();
                if (pif.years[year_id].previous_years) {
                    for (var p = 0; p < pif.years[year_id].previous_years.length; p++) {
                        all_previous_years.push(pif.years[year_id].previous_years[p]);
                    }
                    return all_previous_years;
                }
            })
            .enter()
            .append('rect')
            .attr('id', function(year_id_sel_list) {
                if (year_id_sel_list[1] == 'Sélectif sur concours, dossier, test') {
                    return 'rect_sel_year_selection_' + pif.id;
                } else if (year_id_sel_list[1] == 'Selectif sur concours') {
                    return 'rect_sel_year_examination_' + pif.id;
                } else {
                    return 'non_sel_year_' + pif.id;
                }
            })
            .attr('class', function(year_id_sel_list) {
                if (year_id_sel_list[1] == 'Sélectif sur concours, dossier, test') {
                    return 'rect_sel_year rect_sel_year_selection';
                } else if (year_id_sel_list[1] == 'Selectif sur concours') {
                    return 'rect_sel_year rect_sel_year_examination';
                } else if (year_id_sel_list[1] != 'Aucune' && year_id_sel_list[1] != 'Admission controle continu') {
                    return 'rect_sel_year';
                } else {
                    return 'non_sel_year';
                }
            })
            .attr('x', function(year_id_sel_list) {
                // Si l'année a une seule précédente, l'absice est égale à 0
                if (pif.years[this.parentNode.__data__].previous_years.length == 1) {
                    return 0;
                } else {
                    // Si l'année a plusieurs précédentes
                    for (var c = 0; c < this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes.length; c++) {
                        var target_element = this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes[c];
                        if (year_id_sel_list[0] == target_element.__data__) {
                            // Si l'abscisse de l'année en cours est inférieure a celle de sa precedente
                            if (parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) <= parseInt(target_element.getAttribute('absciss'))) {
                                if (parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) < 0) {
                                    return 0;
                                } else {
                                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
                                        return (parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')))*2;
                                    } else {
                                        return parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'));
                                    }
                                }
                            } else {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
                                    return (parseInt(target_element.getAttribute('absciss')))*2;
                                } else {
                                    return parseInt(target_element.getAttribute('absciss'));
                                }
                            }
                        }
                    }
                }
            })
            .attr('y', h_rect)
            .attr('width', function(year_id_sel_list) {
                var rect_width = 0;
                rect_width = w_rect*pif.year_width(pif.years[this.parentNode.__data__]) + (pif.year_width(pif.years[this.parentNode.__data__]) - 1)*rect_padding;

                /* S'il n'y a pas ou qu'une année précédente */
                if (pif.years[this.parentNode.__data__].previous_years.length <= 1) {
                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr( 'class' ).indexOf('double_column') > -1) {
                        return rect_width*2;
                    } else {
                        return rect_width;
                    }
                } else {
                    // On récupère le tableau de la ligne suivante
                    for (var c = 0; c < this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes.length; c++) {
                        var target_element = this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes[c];
                        if (year_id_sel_list[0] == target_element.__data__) {
                            var xfinal1 = parseInt(target_element.getAttribute('absciss')) + parseInt(target_element.getAttribute('cell_width'));
                            var xfinal2 = parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));

                            // Si l'absciss de l'année en cours est inférieure a celle de sa precedente
                            if (parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) <0 || parseInt(target_element.getAttribute('absciss')) < parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'))) {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                    return parseInt(target_element.getAttribute('cell_width'))*2;
                                } else {
                                    return parseInt(target_element.getAttribute('cell_width'));
                                }

                            } else if (xfinal1 > xfinal2) {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                    return (xfinal2 - parseInt(target_element.getAttribute('absciss')))*2;
                                } else {
                                    return xfinal2 - parseInt(target_element.getAttribute('absciss'));
                                }
                            } else {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                    return target_element.getAttribute('cell_width')*2;
                                } else {
                                    return target_element.getAttribute('cell_width');
                                }
                            }
                        }
                    }
                }
            })
            .attr('height', 2)
            .attr('fill', 'red');


    /* Création d'un groupe qui va contenir tous les symboles de séléctivité */
    var year_with_previous_selective_sign = year_with_previous_selectivity
            .selectAll('circle')
            .data(function(year_id) {
                var all_previous_years = new Array();
                if (pif.years[year_id].previous_years) {
                    for (var p = 0; p < pif.years[year_id].previous_years.length; p++) {
                        all_previous_years.push(pif.years[year_id].previous_years[p]);
                    }
                    return all_previous_years;
                }
            })
            .enter()
            .append('circle')
            .attr('class', function(year_id_sel_list) {
                if (year_id_sel_list[1] == 'Aucune' || year_id_sel_list[1] == 'Admission controle continu') {
                    return 'non_sel_year';
                } else {
                    return 'rect_sel_year';
                }
            })
            .attr('cx', function(year_id_sel_list) {
                var rect_width = 0;
                rect_width = w_rect*pif.year_width(pif.years[this.parentNode.__data__]) + (pif.year_width(pif.years[this.parentNode.__data__])-1) *rect_padding;
                if (pif.years[this.parentNode.__data__].previous_years.length == 1) {
                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                        return rect_width;
                    } else {
                        return rect_width/2;
                    }
                } else {
                    for (var c = 0; c < this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes.length; c++) {
                        var target_element = this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes[c],
                        xfinal1 = parseInt(target_element.getAttribute('absciss')) + parseInt(target_element.getAttribute('cell_width')),
                        xfinal2 = parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));

                        if (year_id_sel_list[0] == target_element.__data__) {
                            // Si l'absciss de l'année en cours est inférieure a celle de sa precedente
                            if (parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) <= parseInt(target_element.getAttribute('absciss')) ) {
                                if (target_element.getAttribute('absciss') - this.parentNode.parentNode.parentNode.getAttribute('absciss') < 0) {
                                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                        return ((xfinal1) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')));
                                    } else {
                                        return ((xfinal1) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'))) /2;
                                    }
                                } else if (xfinal1 > xfinal2) {
                                    var abs_rect = parseInt(target_element.getAttribute('absciss'));
                                    var wid_rect = parseInt((parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'))) - target_element.getAttribute('absciss'));
                                    /* On récupère l'abscisse max du rectangle */
                                    var finalAbs = parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));

                                    /* permet de centrer le cercle */
                                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                        return (finalAbs - (wid_rect/2))*2;
                                    } else {
                                        return finalAbs - (wid_rect/2);
                                    }
                                } else {
                                    var abs_rect = parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'));
                                    var wid_rect = parseInt(target_element.getAttribute('cell_width'));
                                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                        return (abs_rect + (wid_rect/2))*2;
                                    } else {
                                        return abs_rect + (wid_rect/2);
                                    }
                                }
                            } else {
                                if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                    return 30;
                                } else {
                                    return 15;
                                }
                            }
                        }
                    }
                }
            })
            .attr('cy', h_rect)
            .attr('r', 6)
            .attr('fill', 'red');

    /* Création d'un groupe qui va contenir tous les signes de séléctivité */
    var year_with_previous_selective_text = year_with_previous_selectivity
            .selectAll('text')
            .data(function(year_id) {
                var all_previous_years = new Array();
                if (pif.years[year_id].previous_years) {
                    for (var p=0; p<pif.years[year_id].previous_years.length; p++) {
                        all_previous_years.push(pif.years[year_id].previous_years[p]);
                    }
                    return all_previous_years;
                }
            })
            .enter()
            .append('text')
            .attr('class', function(year_id_sel_list) {
                if (year_id_sel_list[1] == 'Aucune' || year_id_sel_list[1] == 'Admission controle continu') {
                    return 'non_sel_year';
                } else {
                    return 'rect_sel_year';
                }
            })
            .attr('x', function(year_id_sel_list) {
                var rect_width = 0;
                rect_width = w_rect*pif.year_width(pif.years[this.parentNode.__data__]) + (pif.year_width(pif.years[this.parentNode.__data__])-1)*rect_padding;

                if (pif.years[this.parentNode.__data__].previous_years.length == 1) {
                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                        return rect_width - 3;
                    } else {
                        return rect_width/2 - 3;
                    }
                } else {
                    for (var c=0; c<this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes.length; c++) {
                        var target_element = this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes[c];
                        var xfinal1 = parseInt(target_element.getAttribute('absciss')) + parseInt(target_element.getAttribute('cell_width'));
                        var xfinal2 = parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));
                        if (year_id_sel_list[0] == target_element.__data__) {
                            // Si l'absciss de l'année en cours est inférieure a celle de sa precedente
                            if (parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) <= parseInt(target_element.getAttribute('absciss')) ) {
                                if (parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) < 0) {
                                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr('class').indexOf('double_column') > -1) {
                                        return ((xfinal1) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'))) - 3;
                                    } else {
                                        return ((xfinal1) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')))/2 - 3;
                                    }
                                } else if (xfinal1 > xfinal2) {
                                    var abs_rect = parseInt(target_element.getAttribute('absciss'));
                                    var wid_rect = parseInt((parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'))) - target_element.getAttribute('absciss'));
                                    /* On récupère l'abscisse max du rectangle */
                                    var finalAbs = parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));
                                    /* on retourne l'abscisse max de l'année courante - la moitié de la largeur du rectangle de l'année précédente */
                                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                        return (finalAbs - (wid_rect/2))*2 -3;
                                    } else {
                                        return finalAbs - (wid_rect/2) -3;
                                    }
                                } else {
                                    var abs_rect = target_element.getAttribute('absciss') - this.parentNode.parentNode.parentNode.getAttribute('absciss');
                                    var wid_rect = target_element.getAttribute('cell_width');
                                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
                                        return (abs_rect +(wid_rect/2))*2 -3;
                                    } else {
                                        return abs_rect + (wid_rect/2) -3;
                                    }
                                }
                            } else {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
                                    return 30;
                                } else {
                                    return 15;
                                }
                            }
                        }
                    }
                }
            })
            .attr('y', h_rect + 4)
            .attr('font-size', 11)
            .attr('font-weight', 'bold')
            .attr('fill', 'white')
            .text(function(year_id_sel_list) {
                switch(year_id_sel_list[1]) {
                case 'Sélectif sur concours, dossier, test':
                    return 'S';
                    break;
                case 'Selectif sur concours':
                    return 'C';
                    break;
                case 'Selectif par admission parallèle':
                    return 'A';
                    break;
                }
            });

    /*********************************************************************************************************************
    * Création du groupe  qui va afficher la base du pif
    *******************************************************************************************************************/
    /* Création du groupe qui va tout accueillir */

    /* Calcul position de la base du pif */
    if ( 'full' == view_type || $('.pif_years_group_' + pif.id).parents('.fiche-pif').length ) {
        var y = $('.pif_years_group_' + pif.id)[0].getBoundingClientRect().height + 60;
    } else {
        var mysvg = document.getElementById('pif_years_group_id' + pif.id);
        if (mysvg.lastChild.firstChild.getAttribute("class").match(/void_year/)) {
            var y = $('.pif_years_group_' + pif.id)[0].getBoundingClientRect().height;
        } else {
            var y = $('.pif_years_group_' + pif.id)[0].getBoundingClientRect().height + 60;
        }
    }

    var base_pif_group = pif_years_group.append('g')
            .attr('transform', 'translate(0,' + y + ')');

    /* Création du rectangle de la base du pif*/
    var rect_base_pif = base_pif_group.append('rect')
            .attr('class', function () {
                if (hide_base_pif == 0) {
                    return 'base_pif' + pif.id;
                } else {
                    return 'void_year';
                }
            }).attr('width', $('.pif_years_group_' + pif.id)[0].getBoundingClientRect().width)
            .attr('height',20);

    /* Création du texte de la base du pif*/
    var text_base = base_pif_group.append('text')
            .attr('fill', 'white')
            .attr('y', 16)
            .attr('class', 'text_base_pif')
            .attr('id', 'text_pif' + pif.id)
            .text(pif.base);

    // permet de centrer la base si le texte est plus grand que la largeur du pif
    var shift = 0;
    if ($('.text_base_pif#text_pif' + pif.id)[0].getBoundingClientRect().width > $('.base_pif' + pif.id)[0].getBoundingClientRect().width) {
        shift = (($('.text_base_pif#text_pif' + pif.id)[0].getBoundingClientRect().width - $('.base_pif' + pif.id)[0].getBoundingClientRect().width) + 50 ) /2;
        base_pif_group.attr('transform', 'translate(' + -shift +',' + y + ')');
        base_pif_group.attr('width', $('.text_base_pif#text_pif' + pif.id)[0].getBoundingClientRect().width + 50);
        rect_base_pif.attr('width', $('.text_base_pif#text_pif' + pif.id)[0].getBoundingClientRect().width + 50);
    }

    text_base.attr('x', (parseInt(rect_base_pif.attr('width')) - $('.text_base_pif#text_pif' + pif.id)[0].getBoundingClientRect().width)/2);
    d3.select('#svg_area_' + pif.id).attr('height', $('#pif_' + pif.id + '_container').height() - 20 );// pour que le svg ne dépasse pas sur la barre de légende


    pif.draw_gateways(dataset);

    //montre les années correspondante au type de formation ou au job passé en view parameters
    pif.hideByEducations();

    pif_years_group.attr('transform',function () {
        if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return 'translate(0,30) scale(0.75)';
        }
        return 'translate(0,30)';
    });

    var gateways = $('#pif_' + pif.id + '.gateways');
    gateways.attr('transform',function () {
        if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return 'translate(0,30) scale(0.75)';
        }
        return 'translate(0,30) ';
    });

    $('#svg_area_' + pif.id)
    .css('height', $('#pif_' + pif.id + '_area')[0].getBBox().height + 120)
    .css('margin-left', '20px')
    .css('margin-top', function() {
        if ('full' == view_type) {
             if (0 < ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2)) {
                 return ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2) + 'px';
             }
         return 0;
        }
    });

    // Flèche de navigation du pif
    svg_principal_area.append('div')
        .attr('class', 'half-circle-left')
        .attr('id', 'half-circle-left_pif_' + pif.id)
        .attr('pif', pif.id)
        .style('top', parseInt(svg_principal_area.style('height'))/2 - 16 + 'px')
        .on('click', function() {

            var pifId = $(this).attr('pif');
            var BB_svg_area = $('#svg_area_' + pifId)[0].getBoundingClientRect();
            $('#oni-ico-fleche4_right_pif_' + pifId).css('visibility', 'visible');
            $('#half-circle-right_pif_' + pifId).css('visibility', 'visible');

            if ($('#pif_' + pifId + '_container').hasClass('pif_container_embed') || (!$('#left_pan_' + pifId).hasClass('visible') && 768 > $(window).width() && 'full' == view_type) ) {
                var left_min = $('.fiche-pif .pif_container_embed').length ? 50 : 0;
            } else {
                var left_min = 200;
            }

            if ( left_min >  zoom[pifId].translate()[0] + BB_svg_area.width) {
                left =  zoom[pifId].translate()[0] + BB_svg_area.width;
            } else {
                left = left_min;
            }

            var translate_y = $('.fiche-pif .pif_container_embed').length ? -90 : 0;

            svg.transition()
               .duration(500)
               .ease('quad')
               .attr('transform', 'translate(' + left + ',' + translate_y + ') scale(' + zoom_value + ')');

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                zoom[pifId].translate([left, zoom[pifId].translate()[1]]);
            } else {
                zoom[pifId].translate([left, translate_y]);
            }

            if (zoom[pifId].translate()[0] == left_min) {
                $(this).css('visibility', 'hidden');
                $('#oni-ico-fleche4_left_pif_' + pifId).css('visibility', 'hidden');
            }
        });

    svg_principal_area.append('div')
        .attr('class', 'half-circle-right')
        .attr('id', 'half-circle-right_pif_' + pif.id)
        .attr('pif', pif.id)
        .style('top', parseInt(svg_principal_area.style('height'))/2 - 16 + 'px')
        .on('click', function() {

            var pifId = $(this).attr('pif');
            var BB_svg_area = $('#svg_area_' + pifId)[0].getBoundingClientRect();
            var movable_area_w = $('#pif_' + pifId + '_container .pif_years_group_' + pifId)[0].getBoundingClientRect().width;
            var pif_width = $('#pif_' + pifId + '_container').outerWidth();

            $('#oni-ico-fleche4_left_pif_' + pifId).css('visibility', 'visible');
            $('#half-circle-left_pif_' + pifId).css('visibility', 'visible');

            if ($('#pif_' + pifId + '_container').hasClass('pif_container_embed') || (!$('#left_pan_' + pifId).hasClass('visible') && 768 > $(window).width() && 'full' == view_type) ) {
                var right_min = 40;
            } else {
                var right_min = 240;
            }

            right = Math.max(pif_width - right_min - movable_area_w, zoom[pifId].translate()[0] - BB_svg_area.width);
            var translate_y = $('.fiche-pif .pif_container_embed' ).length ? -90 : 0;
            svg.transition()
                .duration(500)
                .ease('quad')
                .attr('transform', 'translate(' + right + ',' + translate_y + ') scale(' + zoom_value + ')');

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                zoom[pifId].translate([right, zoom[pifId].translate()[1]]);
            } else {
                zoom[pifId].translate([right, translate_y]);
            }

            if (zoom[pifId].translate()[0] <= pif_width - right_min - movable_area_w) {
                $(this).css('visibility', 'hidden');
                $('#oni-ico-fleche4_right_pif_' + pifId).css('visibility', 'hidden');
            }
        });

    var arrow_pif_left = svg_principal_area.append('div')
        .attr('class', 'oni-ico-fleche4 ico-fleche-left')
        .attr('id', 'oni-ico-fleche4_left_pif_' + pif.id)
        .style('top', ((parseInt(svg_principal_area.style('height')) / 2) - 6) + 'px')
        .style('visibility', function() {
             if ($('#pif_' + pif.id + '_container .pif_years_group_' + pif.id)[0].getBBox().width < $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                return 'hidden';
            }
            return 'visible';
        });

    var arrow_pif_right = svg_principal_area.append('div')
        .attr('class', 'oni-ico-fleche4 ico-fleche-right')
        .attr('id', 'oni-ico-fleche4_right_pif_' + pif.id)
        .style('top', parseInt(svg_principal_area.style('height'))/2 + 'px')
        .style('visibility', function() {
            if ($('#pif_' + pif.id + '_container .pif_years_group_' + pif.id)[0].getBBox().width < $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                return 'hidden';
            }
            return 'visible';
        });

    pif.setArrowsVisibility();

    svg.attr('transform', function() {
        // Centrer le PIF
        var BB_pif = $('#pif_years_group_id' + pif.id)[0].getBoundingClientRect();
        var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
        var x = Math.abs(BB_pif.left - BB_svg_area.left) + ((Math.abs(BB_svg_area.width) - Math.abs(BB_pif.width))/2);
        zoom[pif.id].translate([x, 0]);
        return 'translate(' + x + ',0) scale(' + zoom_value + ')';
    });

    $('#svg_area_' + pif.id).css('height', $('#pif_' + pif.id + '_area')[0].getBBox().height + 120)
    .css('margin-top', function() {
        if ('full' == view_type) {
            if (0 < ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2)) {
                return ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2) + 'px';
            }
            return 0;
        }
    });

    pif.drawFiltersArea();

    window.addEventListener('resize', function() {
      if (!$('#ideo-content .fiche-pif').length) {
        pif_years_group.attr('transform',function () {
            if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return 'translate(0,30) scale(0.75)';
            }
            return 'translate(0,30)';
        });

        gateways.attr('transform', function() {
            if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return 'translate(0,30) scale(0.75)';
            }
            return 'translate(0,30)';
        });

        d3.select('#right_pan_' + pif.id)
        .style('height', $('#pif_' + pif.id + '_container').css('height'));
        d3.select('#left_pan_' + pif.id)
        .style('height', $('#pif_' + pif.id + '_container').css('height'));

        if ('full' == view_type) {
            if (480 < $(window).width()) {
                $('#portraits_container_' + pif.id).css('bottom', '');
            } else {
                if ('none' != $('#filters_container_' + pif.id).css('display')) {
                    $('#tabs_left_' + pif.id).css('bottom', $('#filters_container_' + pif.id)[0].getBoundingClientRect().height);
                    $('#filters_container_' + pif.id).css('bottom', 0);
                } else if ('none' != $('#portraits_container_' + pif.id).css('display')) {
                    $('#tabs_left_' + pif.id).css('bottom', $('#portraits_container_' + pif.id)[0].getBoundingClientRect().height);
                    $('#portraits_container_' + pif.id).css('bottom', 0);
                } else if ('none' != $('#enrichments_container_' + pif.id).css('display')) {
                    $('#tabs_left_' + pif.id).css('bottom', $('#enrichments_container_' + pif.id)[0].getBoundingClientRect().height);
                    $('#enrichments_container_' + pif.id).css('bottom', 0);
                }

                 d3.select('#zoom_buttons_' + pif.id)
                 .style('top', $('#title_pif_' + pif.id).height() + 20 + 'px');

                 $('#left_pan_' + pif.id).addClass('visible');
            }
        }

        tooltip.style('visibility', 'hidden');
        tooltipL.style('visibility', 'hidden');

        $('#svg_area_' + pif.id).css('height', $('#pif_' + pif.id + '_area')[0].getBBox().height + 120)
        .css('margin-top', function() {
            if ('full' == view_type) {
                if (0 < ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2)) {
                    return ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2) + 'px';
                }
                return 0;
            }
        });
        $('#pif_' + pif.id + '_container').css('height', $('#svg_area_' + pif.id).height());

        pif_width = $('#pif_' + pif.id + '_container').outerWidth();
        d3.select('#svg_area_' + pif.id).attr('width', pif_width - 10).call(zoom[pif.id])
        .on('mousewheel.zoom', null)
        .on('DOMMouseScroll.zoom', null)
        .on('wheel.zoom', null);
        //permet de remettre le pif à la position de base pour qu'il ne soit pas "bloqué" hors de l'area lorsqu'on resize
        svg.attr('transform', 'translate(0,0)');
        zoom[pif.id].translate([0, 0]);
        svg.attr('transform', function() {
            // Centrer le PIF
            var BB_pif = $('#pif_years_group_id'+pif.id)[0].getBoundingClientRect();
            var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
            var x = Math.abs(BB_pif.left - BB_svg_area.left) + ((Math.abs(BB_svg_area.width) - Math.abs(BB_pif.width))/2);
            zoom[pif.id].translate([x, 0]);
            return 'translate(' + x + ',0)';
        });
        pif.setArrowsVisibility();
        zoom_value = 1;
      }
    });
}

Pif.prototype.display_description_box = function(enseignement, color, type, diploma_over, year_id) {
    var pif = this;
    type = type || '';
    diploma_over = diploma_over || false;
    year_id = year_id || 0;
    var desc_box = d3.select('#information_pif_' + pif.id);
    var info_ref = desc_box.insert('div','#education_information_pif_' + pif.id).attr('id', 'information_ref_' + pif.id);

    if (diploma_over && year_id && pif.years[year_id].diploma && pif.years[year_id].diploma!='') {
        name = pif.years[year_id].diploma;
        desc_box.attr("class", "information_pif_diploma");
    } else {
        name = enseignement.name;
        desc_box.attr("class", "information_pif");
    }

    info_ref.append('div').attr('class', 'information_year_name').html(name);

    info_ref.append('div')
    .attr('class', 'oni-ico-croix_cercle description_cross')
    .attr('pif', pif.id)
    .on('click', function() {
        var pifId = $(this).attr('pif');
        $('#information_pif_' + pifId).css('visibility', 'hidden');
        $('#information_pif_' + pifId).removeClass('active');
        $('#education_information_pif_' + pifId).css('display', 'none');
    });

    if (diploma_over && year_id != 0 && pif.years[year_id].diplomas_desc && pif.years[year_id].diplomas_desc!='') {
        description = pif.years[year_id].diplomas_desc;
    } else {
        description = enseignement.description;
    }

    info_ref.append('div').attr('class', 'information_year_desc').html(description);

    if ('formation' == type) {
        var shift_top = ($('#title_pif_' + pif.id).height() + ($('#svg_area_' + pif.id)[0].getBoundingClientRect().height / 2) - desc_box[0][0].getBoundingClientRect().height / 2 );

        if (shift_top < $('#title_pif_' + pif.id).height()) {
            shift_top = $('#title_pif_' + pif.id).height();
        }
    }
}

Pif.prototype.draw_gateways = function(dataset) {
    var pif = this;
    if (this.gateways.length) {
        var svg = d3.select('#pif_' + pif.id + '_container #pif_' + pif.id + '_area');
        var gateways_group = svg.append('g')
            .attr('id', 'pif_' + pif.id)
            .attr('class', 'gateways')
            .attr('transform',function () {
                 if (pif.get_width_max(dataset)*2 < $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                     var x = ($('#svg_area_' + pif.id)[0].getBoundingClientRect().width - pif.get_width_max(dataset)*2) / 2;
                 } else if (pif.get_width_max(dataset) < $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                     var x = ($('#svg_area_' + pif.id)[0].getBoundingClientRect().width - pif.get_width_max(dataset)) / 2;
                 } else {
                     var x = 5;
                 }
                 return 'translate('+ x +',30)';
            });

        gateways_group.append('defs')
        .append('marker')
            .attr('id', 'pifArrowMarker')
            .attr('stroke-width', '0px')
            .attr('markerUnits', 'strokeWidth')
            .attr('orient', 'auto')
            .attr('markerHeight', 6)
            .attr('markerWidth', 6)
            .attr('refX', 3)
            .attr('refY', 3)
            .append('path')
                .attr('d', 'M0,0 L3,3 L0,6 L6,3 Z')
                .attr('style', 'fill: #000000; stroke-dasharray: none;');

        var year_rect_padding = 6;
        for (var index = 0; index < pif.gateways.length; index++) {
            var gateway = pif.gateways[index];
            if (pif.got_year(gateway.from) && pif.got_year(gateway.to)) {
                var from_rect = d3.select('.pif_' + pif.id + 'rect_year_' + gateway.from);
                var from_year = d3.select('.pif_' + pif.id + 'year' + gateway.from);
                if (!from_year[0][0]) { continue; }
                var from_line = d3.select(from_year[0][0].parentNode);
                var from_x;
                var from_x_1 = year_rect_padding + parseInt(from_year.attr('transform').match(/translate\(([0-9]+)[, ]?([0-9]*)\)/)[1]);
                var from_x_2 = -2*year_rect_padding + from_x_1 + parseInt(from_rect.attr('width'));
                var from_y = Math.ceil(from_rect.attr('height')/2 + parseInt(from_line.attr('transform').match(/translate\(([0-9]+)[, ]?([0-9]*)\)/)[2]));

                var to_rect = d3.select('.pif_' + pif.id + 'rect_year_' + gateway.to);
                var to_year = d3.select('.pif_' + pif.id + 'year' + gateway.to);
                if (!to_year[0][0]) { continue; }
                var to_line = d3.select(to_year[0][0].parentNode);
                var to_x;
                var to_x_1 = year_rect_padding + parseInt(to_year.attr('transform').match(/translate\(([0-9]+)[, ]?([0-9]*)\)/)[1]);
                var to_x_2 = -2*year_rect_padding + to_x_1 + parseInt(to_rect.attr('width'));
                var to_y = Math.ceil(to_rect.attr('height')/2 + parseInt(to_line.attr('transform').match(/translate\(([0-9]+)[, ]?([0-9]*)\)/)[2]));

                if (from_y != to_y) {
                    to_x_1 +=  to_rect.attr('width')/2;
                    to_y = Math.ceil(parseInt(to_rect.attr('height')) + parseInt(to_line.attr('transform').match(/translate\(([0-9]+)[, ]?([0-9]*)\)/)[2]));
                }

                var d_1_1 = Math.abs(from_x_1 - to_x_1);
                var d_1_2 = Math.abs(from_x_1 - to_x_2);
                var d_2_1 = Math.abs(from_x_2 - to_x_1);
                var m_d = Math.min(d_1_1, d_2_1, d_1_2);
                switch (m_d) {
                    case d_1_1: {
                        from_x = from_x_1;
                        to_x = to_x_1;
                    } break;
                    case d_1_2: {
                        from_x = from_x_1;
                        to_x = to_x_2;
                    } break;
                    case d_2_1: {
                        from_x = from_x_2;
                        to_x = to_x_1;
                    } break;
                }

                gateways_group.append('path')
                .attr('style', 'stroke: #000000; stroke-width: 2px; stroke-dasharray: 2,2; fill: none; marker-end: url(#pifArrowMarker);')
                .attr('d', 'M' + from_x + ',' + from_y + ' L' + to_x + ',' + to_y)
                .attr('class', function(d) {
                    return 'gateway_line education_' + pif.get_education(from_year[0][0].__data__) + ' gateway_line_' + pif.id;
                });
            }
        }
    }
}

/**********************************************************************
 * Cache les formations entières sauf celles passées en paramètres
 *********************************************************************/

Pif.prototype.hideAllBut = function(educationsArray){
    pif = this;
    if (educationsArray) {
        for(var i in pif.educationsObj) {
            if (-1 < educationsArray.indexOf(String(pif.educationsObj[i].id)) || -1 < educationsArray.indexOf(pif.educationsObj[i].id)) {
                d3.selectAll('.pif_' + pif.id + '.education_' + i).classed('notVisible', false);
                if (0 == pif.design) {
                    d3.select('.between_lines_' + pif.id + '.education_' + i).classed('notVisible', false);
                }
            } else {
                d3.selectAll('.pif_' + pif.id + '.education_' + i).classed('notVisible', true);
                if (0 == pif.design) {
                    d3.select('.between_lines_' + pif.id + '.education_' + i).classed('notVisible', true);
                }
            }
        }
        d3.selectAll('.year_title.notVisible').style('cursor','default');
    }
}

/**********************************************************************************
 * Cache les années en fonction du filtre d'éducations présent dans l'objet pif
 *********************************************************************************/

Pif.prototype.hideByEducations = function() {
    pif = this;
    if (pif.default_filters) {
        var educationsToShow = new Array();

        for(var i in pif.educationsObj) {
            for(var j in pif.educationsObj[i].education_type) {
                if (-1 < pif.default_filters.indexOf(pif.educationsObj[i].education_type[j].id)) {
                    educationsToShow.push(pif.educationsObj[i].id);
                    var education_type_object = pif.educationsObj[i].education_type[j];
                }
            }
        }
    } else if (pif.educationsRelToJob) {
        var educationsToShow = new Array();

        for(var i in pif.educationsObj) {
            for(var j in pif.educationsObj[i].education_type) {
                for( var k in pif.educationsRelToJob) {
                    if (pif.educationsRelToJob[k].type_formation == pif.educationsObj[i].education_type[j].id) {
                        educationsToShow.push(pif.educationsObj[i].id);
                    }
                }
            }
        }
    }

    if (educationsToShow) {
        pif.allYearsHidden(true);
        for(var h = 0; h < educationsToShow.length; h++) {
            d3.selectAll('.education_' + educationsToShow[h]).classed('notVisible', false);
        }
        d3.selectAll('.year_title.notVisible').style('cursor','default');
    }
}


/**********************************************************************************************************************
* Création des filtres et enrichissements
************************************************************************************************************************/

Pif.prototype.drawFiltersArea = function() {
    pif = this;

    var filters_area = d3.select('#enrichments_area_' + pif.id);
    var left_pan = d3.select('#left_pan_' + pif.id)
    .style('height', $('#pif_' + pif.id + '_container').css('height'));

    var container = d3.select('#pif_' + pif.id + '_container');

    var closing_cross = left_pan.append('div')
    .attr('class', 'oni-ico-croix_cercle cross_pan no_select_text')
    .attr('id', pif.id)
    .attr('pif', pif.id)
    .on('click', function() {
        var pifId = $(this).attr('pif');
        var container = d3.select('#pif_' + pifId + '_container');

        var movable_area_w = $('#pif_' + $(this).attr('pif') + '_container .pif_years_group_' + $(this).attr('pif'))[0].getBoundingClientRect().width;

        var shift_left = 0; // décalage à gauche en fonction du panel

        if ('full' == view_type) {
            if ($('#left_pan_' + pifId).hasClass('visible') && 480 < $(window).width()) {
                shift_left += parseInt($('#left_pan_' + pifId).css('width'));
                if ($('#portraits_pan_' + pifId).hasClass('visible') && 768 < parseInt($('#pif_' + pifId + '_container').css('width'))) {
                    shift_left += parseInt($('#portraits_pan_' + pifId).css('width'));
                }
            }
        } else {
            if ($('#left_pan_' + pifId).hasClass('visible')) {
                shift_left += parseInt($('#left_pan_' + pifId).css('width'));
            }
        }

        $('#left_pan_' + pifId).animate({
            'margin-left': '-200px'}, 200 );
        $('#left_pan_' + pifId).toggleClass('visible');
        $('#half-circle-left_pif_' + pifId).animate({
            'left': 0}, 200);
        $('#oni-ico-fleche4_left_pif_' + pifId).animate({
            'left': '1px'}, 200);
        $('#portraits_pan_' + pifId).css('width', 0);
        $('.portrait_container_' + pifId + '.portrait_pan_visible').removeClass('portrait_pan_visible');
        $('#portraits_pan_' + pifId).removeClass('portrait_pan_visible');
        $('#portrait_focus_' + pifId).remove();

        var shift_right = 0;

        if ((($('#right_pan_' + pifId).hasClass('visible') && (480 < $(window).width())) || (1024 < $(window).width())) && 'full' == view_type) {
            shift_right += parseInt($('#right_pan_' + pifId).css('width'));
        }

        if ( movable_area_w + shift_right < $('#svg_area_' + pifId)[0].getBoundingClientRect().width) {
            //pour recentrer le pif à la fermeture du panneau s'il ne peut pas être translaté
            var svg = d3.select('#pif_' + pifId + '_area');

            var trans_initial = d3.select('#pif_' + pifId + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];
            var zoom_initial = zoom[pifId].translate()[0];

            svg.attr('transform', 'translate(0,0)');
            zoom[pifId].translate([0, 0]);
            var BB_pif = $('#pif_years_group_id' + pifId)[0].getBoundingClientRect();
            var BB_svg_area = $('#svg_area_' + pifId)[0].getBoundingClientRect();
            var shift_negatif = BB_pif.left - BB_svg_area.left;

            svg.attr('transform', 'translate(' + trans_initial + ',0)');
            zoom[pifId].translate([zoom_initial, 0]);

            svg.transition()
            .duration(200)
            .ease('quad')
            .attr('transform', function() {
                var BB_pif = $('#pif_years_group_id' + pifId)[0].getBoundingClientRect();
                var BB_svg_area = $('#svg_area_' + pifId)[0].getBoundingClientRect();
                var position = d3.select('#pif_' + pifId + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];

                var x = position - ((BB_svg_area.width - BB_pif.width)/2) ;
                zoom[pifId].translate([position - x - shift_negatif, 0]);

                return 'translate(' + (position - x - shift_negatif ) + ',0)';
            });
        }

        allPif[$(this).attr('pif')].setArrowsVisibility();
        var pif_area = d3.select('#pif_' + pifId + '_area');
        if (movable_area_w + shift_left + shift_right > $('#svg_area_' + pifId)[0].getBoundingClientRect().width) {
            if (zoom[pifId].translate()[0] >= 80) {
                pif_area.transition()
                .duration(200)
                .ease('quad')
                .attr('transform', 'translate(80,0)');

                zoom[pifId].translate([80, 0]);
                $('#oni-ico-fleche4_left_pif_' + pifId).css('visibility', 'hidden');
                $('#half-circle-left_pif_' + pifId).css('visibility', 'hidden');
            }
        }
    });

    var left_pan_container = left_pan.append('div')
    .attr('class', 'left_pan_container')
    .attr('id', 'left_pan_container_' + pif.id)
    .style('margin-top', function() {
        if ($('.cross_pan').outerHeight() < $('#title_pif_' + pif.id).height()) {
            return ($('#title_pif_' + pif.id).height() - $('.cross_pan').outerHeight(true)) + 'px';
        }
        return 0;
    });

    var filtersContainer = left_pan_container.append('div')
    .attr('id', 'filters_container_' + pif.id)
    .attr('class', 'filters_container');

    filtersContainer.append('h3').text('FILTRES').attr('class', 'title_section').attr('id', 'title_section_' + pif.id);

    // Stages

    var count = 1; // permet d'avoir automatiquement les bg color des filtres

    if ('none' != $('.title_section').css('display')) {
        count++;
    }

    var sliders_area = filtersContainer.append('div').attr('class', 'sliders_area');

    var internships = sliders_area.append('div')
    .attr('class', 'internships filter_block')
    .attr('pif', pif.id)
    .style('background-color', function() {
        if (count%2) {
            return '#333333'
        }
    })
    .on('mouseover',function() {
        var pifId = $(this).attr('pif');
        var mouse = d3.mouse($(this).closest('#left_pan_' + pifId).get(0));
        internshipTooltip.style('visibility', 'visible')
        .style('top', mouse[1] - 15 + 'px');
    })
    .on('mousemove', function() {
        var pifId = $(this).attr('pif');
        var mouse = d3.mouse($(this).closest('#left_pan_' + pifId).get(0));
        internshipTooltip.style('visibility', 'visible')
        .style('top', mouse[1] - 15 + 'px');
    })
    .on('mouseout', function() {
        internshipTooltip.style('visibility', 'hidden');
    })
    .on('click', function() {
        internshipTooltip.style('visibility', 'visible');
    });

    count++;

    var internshipTooltip = filters_area.append('div')
    .attr('id', 'internships_pif_' + pif.id)
    .attr('class', 'filters_tooltip')
    .text('Importances des stages dans les formations');

    var internships_header = internships.append('div').attr('class', 'slider_header');
    internships_header.append('h4').attr('class', 'title_filter_block').text('Stages');
    internships_header.append('div')
    .attr('class', 'oni-ico-information info_icon')
    .attr('id', 'info_public_establishments_' + pif.id)
    .attr('pif', pif.id)
    .on('click', function() {
        var pifId = $(this).attr('pif');
        var overlay = d3.select('#overlay_' + pifId).style('display', 'inline');
        var overlay_content = d3.select('#overlay_content_' + pifId).style('display', 'inline');
        var tooltip_info_stage = overlay_content.append('span').append('div').attr('class', 'info_tooltip');
        tooltip_info_stage.append('h2').attr('class', 'info_tooltip_title').text('Stages');
        tooltip_info_stage.append('div').text('Importances des stages dans les formations.');
        tooltip_info_stage.append('div').attr('class', 'oni-ico-croix_cercle info_cross').on('click', function() {
            overlay.style('display', 'none');
            d3.select('#overlay_content_' + pifId + ' > span').remove();
            overlay_content.style('display', 'none');
        })
    });


    internships.append('div').attr('class', 'slider_filters').attr('id', 'slider_internships_' + pif.id);

    // Établissements publics

    var public_establishments = sliders_area.append('div')
    .attr('class', 'publics_establishments filter_block')
    .attr('pif', pif.id)
    .style('background-color', function() {
        if (count%2) {
            return '#333333'
        }
    })
    .on('mouseover',function() {
        var pifId = $(this).attr('pif');
        var mouse = d3.mouse($(this).closest('#left_pan_' + pifId).get(0));
        publicEstablishmentTooltip.style('visibility', 'visible')
        .style('top', mouse[1] - 15 + 'px');
    })
    .on('mousemove', function() {
        var pifId = $(this).attr('pif');
        var mouse = d3.mouse($(this).closest('#left_pan_' + pifId).get(0));
        publicEstablishmentTooltip.style('visibility', 'visible')
        .style('top', mouse[1] - 15 + 'px');
    })
    .on('mouseout', function() {
        publicEstablishmentTooltip.style('visibility', 'hidden');
    })
    .on('click', function() {
        publicEstablishmentTooltip.style('visibility', 'visible');
    });

    count++;

    var publicEstablishmentTooltip = filters_area.append('div')
    .attr('id', 'publics_establishments_pif_' + pif.id)
    .attr('class', 'filters_tooltip')
    .text('Quota d\'établissements publics proposant ces formations');

    var public_establishments_header = public_establishments.append('div').attr('class', 'slider_header');
    public_establishments_header.append('h4').attr('class', 'title_filter_block').text('Établissements public');
    public_establishments_header.append('div')
    .attr('class', 'oni-ico-information info_icon')
    .attr('id', 'info_public_establishments_' + pif.id)
    .attr('pif', pif.id)
    .on('click', function() {
        var pifId = $(this).attr('pif'),
        overlay = d3.select('#overlay_' + pifId).style('display', 'inline'),
        overlay_content = d3.select('#overlay_content_' + pifId).style('display', 'inline');

        var tooltip_info_public_establishment = overlay_content.append('span').append('div').attr('class', 'info_tooltip');
        tooltip_info_public_establishment.append('h2').attr('class', 'info_tooltip_title').text('Établissements public');
        tooltip_info_public_establishment.append('div').text('Quota d\'établissements publics proposant ces formations.');
        tooltip_info_public_establishment.append('div').attr('class', 'oni-ico-croix_cercle info_cross').on('click', function() {
            overlay.style('display', 'none');
            d3.select('#overlay_content_' + pifId + ' > span').remove();
            overlay_content.style('display', 'none');
        })
    });
    public_establishments.append('div').attr('class', 'slider_filters').attr('id', 'slider_public_establishments_' + pif.id);


    // Apprentissage

    var learning = sliders_area.append('div')
    .attr('class', 'learning filter_block')
    .attr('pif', pif.id)
    .style('background-color', function() {
        if (count%2) {
            return '#333333'
        }
    })
    .on('mouseover',function() {
        var pifId = $(this).attr('pif');
        var mouse = d3.mouse($(this).closest('#left_pan_' + pifId).get(0));
        learningTooltip.style('visibility', 'visible')
        .style('top', mouse[1] - 15 + 'px');
    })
    .on('mousemove', function() {
        var pifId = $(this).attr('pif');
        var mouse = d3.mouse($(this).closest('#left_pan_' + pifId).get(0));
        learningTooltip.style('visibility', 'visible')
        .style('top', mouse[1] - 15 + 'px');
    })
    .on('mouseout', function() {
        learningTooltip.style('visibility', 'hidden');
    })
    .on('click', function() {
        learningTooltip.style('visibility', 'visible');
    });

    count++;

    var learningTooltip = filters_area.append('div')
    .attr('id', 'learning_pif_' + pif.id)
    .attr('class', 'filters_tooltip')
    .text('Présence de formation par apprentissage');

    var learning_header = learning.append('div').attr('class', 'slider_header');
    learning_header.append('h4').attr('class', 'title_filter_block').text('Apprentissage');
    learning_header.append('div')
    .attr('class', 'oni-ico-information info_icon')
    .attr('id', 'info_public_establishments_' + pif.id)
    .attr('pif', pif.id)
    .on('click', function() {
        var pifId = $(this).attr('pif'),
        overlay = d3.select('#overlay_' + pif.id).style('display', 'inline'),
        overlay_content = d3.select('#overlay_content_' + pif.id).style('display', 'inline'),
        tooltip_info_public_establishment = overlay_content.append('span').append('div').attr('class', 'info_tooltip');

        tooltip_info_public_establishment.append('h2').attr('class', 'info_tooltip_title').text('Apprentissage');
        tooltip_info_public_establishment.append('div').text('Présence de formation par apprentissage.');
        tooltip_info_public_establishment.append('div')
        .attr('class', 'oni-ico-croix_cercle info_cross')
        .on('click', function() {
            overlay.style('display', 'none');
            d3.select('#overlay_content_' + pifId + ' > span').remove();
            overlay_content.style('display', 'none');
        })
    });

    learning.append('div').attr('class', 'slider_filters').attr('id', 'slider_learning_' + pif.id);

    //initialise les sliders
    $('#slider_internships_' + pif.id ).slider({
        min: 0,
        max: 110,
        slide: function(ev, ui) {
            //console.log(ev,ui);
            if (ui.value > 100) {
                return false;
            }
        }
    });
    $('#slider_public_establishments_' + pif.id).slider({
        min: 0,
        max: 110,
        slide: function(ev, ui) {
            //console.log(ev,ui);
            if (ui.value > 100) {
                return false;
            }
        }
    });
    $('#slider_learning_' + pif.id).slider({
        min: 0,
        max: 110,
        slide: function(ev, ui) {
            //console.log(ev,ui);
            if (ui.value > 100) {
                return false;
            }
        }
    });

    $( document ).ready(function() {
        if ($('.internships').length) {
            internshipTooltip.style('top', $('.internships').position().top + 'px');
        }
        if ($('.publics_establishments').length) {
            publicEstablishmentTooltip.style('top', $('.publics_establishments').position().top + 'px');
        }
        if ($('.learning').length) {
            learningTooltip.style('top', $('.learning').position().top + 'px');
        }
    });

    pif.drawFilterEducationType();

    $('#education_type_filter_select_' + pif.id).css('background-color', function() {
        if (count%2) {
            return '#333333'
        }
    })
    count++;

    pif.drawFilterJob();

    $('#jobs_area_' + pif.id).css('background-color', function() {
        if (count%2) {
            return '#333333'
        }
    })
    count++;

    var portraits_pan = d3.select('#portraits_pan_' + pif.id);

    portraits_pan.append('div')
    .attr('class', 'oni-ico-croix_cercle cross_portrait_pan no_select_text')
    .attr('pif', pif.id)
    .on('click', function() {
        $('#portraits_pan_' + pif.id).css('width', 0);
        $('.portrait_container_' + pif.id).removeClass('visible');
        $('#portraits_pan_' + pif.id).removeClass('visible');
        $('#portrait_focus_' + pif.id).remove();

        var shift_right = 0, shift_left = 0;

        if ('full' == view_type) {
            if ((($('#left_pan_' + $(this).attr('pif')).hasClass('visible') && (480 < $(window).width())) || (1024 < $(window).width())) && 'full' == view_type) {
                shift_left += parseInt($('#left_pan_' + pif.id).css('width'));
            }
        } else {
            if ($('#left_pan_' + pif.id).hasClass('visible')) {
                shift_left += parseInt($('#left_pan_' + pif.id).css('width'));
            }
        }
        if ((($('#right_pan_' + pif.id).hasClass('visible') && (480 < $(window).width())) || (1024 < $(window).width())) && 'full' == view_type) {
            shift_right += parseInt($('#right_pan_' + pif.id).css('width'));
        }

        var container = d3.select('#pif_' + pif.id + '_container');
        var svgBB = $('#pif_' + pif.id + '_container .pif_years_group_' + pif.id)[0].getBBox();

        var movable_area_w = $('#pif_' + $(this).attr('pif') + '_container .pif_years_group_' + $(this).attr('pif'))[0].getBoundingClientRect().width;

        if (movable_area_w + shift_left + shift_right < $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
            //pour recentrer le pif à la fermeture du panneau s'il ne peut pas être translaté
            var svg = d3.select('#pif_' + pif.id + '_area');

            svg.attr('transform', 'translate(0,0)');
            zoom[pif.id].translate([0, 0]);
            var BB_pif = $('#pif_years_group_id' + pif.id)[0].getBoundingClientRect();
            var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
            var shift_negatif = BB_pif.left - BB_svg_area.left;

            svg.transition()
            .duration(200)
            .ease('quad')
            .attr('transform', function() {
                var BB_pif = $('#pif_years_group_id' + pif.id)[0].getBoundingClientRect();
                var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                var position = d3.select('#pif_' + pif.id + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];

                var x = position - ((BB_svg_area.width - BB_pif.width)/2) ;
                zoom[pif.id].translate([position - x - shift_negatif + shift_left/2, 0]);

                return 'translate(' + (position - x - shift_negatif + shift_left/2) + ',0)';
            });
        }

        allPif[$(this).attr('pif')].setArrowsVisibility();
        var pif_area = d3.select('#pif_' + pif.id + '_area');
        if (movable_area_w + shift_left + shift_right > $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
            if (zoom[pif.id].translate()[0] >= (80 + shift_left)) {
                pif_area.transition()
                .duration(200)
                .ease('quad')
                .attr('transform', 'translate(' + (80 + shift_left) + ',0)');
                zoom[pif.id].translate([80 + shift_left, 0]);
                $('#oni-ico-fleche4_left_pif_' + pif.id).css('visibility', 'hidden');
                $('#half-circle-left_pif_' + pif.id).css('visibility', 'hidden');
            }
        }
    });

    var content_portrait = portraits_pan.append('div')
    .attr('id', 'portraits_pan_container_pif_' + pif.id)
    .attr('class', 'portraits_pan_container');

    var portraitsContainer = left_pan_container.append('div')
    .attr('id', 'portraits_container_' + pif.id)
    .attr('class', 'portraits_container');

    portraitsContainer.append('h3').text('PORTRAITS').attr('class', 'title_section').style('display', function() {
        if (0 == Object.size(pif.routes)) {
            return 'none';
        }
    });

    var count_portraits = 1; // permet d'avoir dynamiquement les bg color des portraits

    if ('none' != $('.title_section').css('display')) {
        count_portraits++;
    }

    for(i in pif.routes) {
        for(var j = 0; j < pif.routes[i].visualUrl.length; j++) {
            var actual_route = pif.routes[i];
            var portraitContainer = portraitsContainer.append('div')
            .attr('class', 'portrait_container portrait_container_' + pif.id)
            .attr('id', 'portrait_container_' + pif.routes[i].id + '_pif_' + pif.id)
            .style('background-color', function() {
                if (count_portraits % 2) {
                    return '#333333'
                }
                return '#4D4D4D';
            })
            .attr('route', i);

            count_portraits++;

            var portraitTitle = portraitContainer.append('div')
            .attr('id', 'portrait_title_route_' + pif.routes[i].id)
            .attr('class', 'portrait_title portrait_title_' + pif.id)
            .attr('route', pif.routes[i].id)
            .attr('pif', pif.id);

            portraitTitle.append('div')
            .attr('class', 'image_cropper')
            .append('div')
            .style('background-image', 'url(/' + pif.routes[i].visualUrl[j] + ')')
            .attr('class', 'portrait_img');

            var name = pif.routes[i].firstname + ' ' + pif.routes[i].name;
            var chapo = pif.routes[i].chapo;
            var description = pif.routes[i].route_content;

            portraitTitle.append('div')
            .attr('class', 'portrait_name')
            .attr('pif', pif.id)
            .text(name);

            var buttons_container = portraitContainer.append('div')
            .attr('class', 'description_buttons_container')
            .attr('id', 'description_buttons_container_route_' + i)
            .attr('route', i)
            .on('click', function() {
                if ($(this).hasClass('active')) {
                    $(this).children('.description_button_off').show();
                    d3.selectAll('.route_layer_' + pif.id).remove();
                    $('#portrait_container_' + $(this).attr('route') + '_pif_' + pif.id).removeClass('visible').removeClass('active');
                    $('#tabs_left_' + pif.id).css('bottom', (parseInt($('#tabs_left_' + pif.id).css('bottom')) - $('#content_route_' + $(this).attr('route'))[0].getBoundingClientRect().height) + 'px');

                    $('#content_route_' + $(this).attr('route')).css('display', 'none');
                } else {
                    $('.description_button_off').show();
                    $('.description_buttons_container').removeClass('active');
                    $(this).children('.description_button_off').hide();
                    $('.diagram_button_' + pif.id + '.active')
                    .css('background-color', '#999999').css('color', 'black').removeClass('active');

                    $('.content_route_pif_' + pif.id).css('display', 'none');
                    $('.portrait_container_' + pif.id).removeClass('visible');
                    $('#tabs_left_' + pif.id).css('bottom', $('#portraits_container_' + pif.id)[0].getBoundingClientRect().height + 'px');
                    //calcul de la hauteur maximale du content route à afficher pour mobile
                    $('#content_route_' + $(this).attr('route') + '.content_route_pif_' + pif.id)
                    .css('max-height', ($('#pif_' + pif.id +'_container').height() - $('#portraits_container_' + pif.id).height()
                        - $('#title_pif_' + pif.id).height() - 20 - $('#tabs_left_' + pif.id)[0].getBoundingClientRect().height) + 'px');

                    $('#portrait_container_' + $(this).attr('route') + '_pif_' + pif.id).addClass('visible').addClass('active');
                    $('#content_route_' + $(this).attr('route')).css('transition-delay', '0.3s').css('height', $('#content_route' + $(this).attr('route')).css('max-height'));

                    $('#content_route_' + $(this).attr('route')).css('display', 'block').addClass('visible');
                    $('#portrait_text_container_route_' + $(this).attr('route')).css('display', 'inline');
                    $('#route_' + $(this).attr('route')).css('display', 'none');

                    $('#portraits_pan_' + pif.id).addClass('portraits_pan_active');

                    $('#tabs_left_' + pif.id).css('bottom', (parseInt($('#tabs_left_' + pif.id).css('bottom')) + $('#content_route_' + $(this).attr('route'))[0].getBoundingClientRect().height) + 'px');

                    // si le contenu du portrait dépasse du viewport, on scroll pour centrer la vue dessus
                    var portrait_container_focused = $('#portrait_container_' + $(this).attr('route') + '_pif_' + pif.id);
                    var content_route_focused =  $('#content_route_' + $(this).attr('route'));
                    if (0 > portrait_container_focused[0].getBoundingClientRect().top) {
                        $('html, body').animate({ scrollTop: portrait_container_focused.offset().top}, 500);
                    } else if (content_route_focused[0].getBoundingClientRect().bottom > $(window).height()) {
                        $('html, body').animate({ scrollTop: (content_route_focused.offset().top + content_route_focused.height()) - $(window).height()}, 500);
                    }
                }
                $(this).toggleClass('active');
            });


            buttons_container.append('div')
            .attr('class', 'description_button description_button_' + pif.id + ' description_button_on')
            .attr('id', 'description_button_route_' + i)
            .attr('route', i);

            buttons_container.append('div')
            .attr('class', 'description_button description_button_' + pif.id + ' description_button_off')
            .attr('id', 'description_button_route_' + i)
            .attr('route', i);

            portraitContainer.append('div')
            .attr('class', 'diagram_button oni-ico-pif diagram_button_' + pif.id)
            .attr('id', ' diagram_button_route_' + i)
            .attr('route', i)
            .attr('pif', pif.id)
            .on('click', function() {
                if ($(this).hasClass('active')) {
                    $(this).css('background-color', '#999999').css('color', 'black');
                    d3.selectAll('.route_layer_' + $(this).attr('pif')).remove();
                    $('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).removeClass('visible');
                    $('#tabs_left_' + $(this).attr('pif')).css('bottom', (parseInt($('#tabs_left_' + $(this).attr('pif')).css('bottom')) - $('#content_route_' + $(this).attr('route'))[0].getBoundingClientRect().height) + 'px');
                    $('#content_route_' + $(this).attr('route')).css('display', 'none');
                    $('.embedded_route').remove();
                } else {
                    $('.embedded_route').remove();
                    $('.description_button_off').show();
                    $('.description_buttons_container').removeClass('active');

                    $('.diagram_button_' + $(this).attr('pif') + '.active')
                    .css('background-color', '#999999').css('color', 'black')
                    .removeClass('active');

                    $('#diagram_button_' + $(this).attr('pif')).css('background-color', '#999999').css('color', 'black');
                    $(this).css('background-color', '#1A1A1A').css('color', 'white');

                    $('.content_route_pif_' + $(this).attr('pif')).css('display', 'none');
                    $('.portrait_container_' + $(this).attr('pif')).removeClass('visible');
                    $('#tabs_left_' + $(this).attr('pif')).css('bottom', $('#portraits_container_' + $(this).attr('pif'))[0].getBoundingClientRect().height + 'px');
                    //calcul de la hauteur maximale du content route à afficher pour mobile
                    $('#content_route_' + $(this).attr('route') + '.content_route_pif_' + $(this).attr('pif'))
                    .css('max-height', ($('#pif_' + $(this).attr('pif') +'_container').height() - $('#portraits_container_' + $(this).attr('pif')).height()
                        - $('#title_pif_' + $(this).attr('pif')).height() - 20 - $('#tabs_left_' + $(this).attr('pif'))[0].getBoundingClientRect().height) + 'px');

                    $('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).addClass('visible');
                    $('#content_route_' + $(this).attr('route')).css('transition-delay', '0.3s').css('height', $('#content_route' + $(this).attr('route')).css('max-height'));

                    $('#content_route_' + $(this).attr('route')).css('display', 'block').addClass('visible');

                    $('#portrait_text_container_route_' + $(this).attr('route')).css('display', 'none');
                    $('#route_' + $(this).attr('route')).css('display', 'inline-block');

                    $('#portraits_pan_' + $(this).attr('pif')).addClass('portraits_pan_active');

                    drawEmbedRoute(pif.routes[$(this).attr('route')], '#route_' + $(this).attr('route'), $(this).attr('route'));
                    $('#tabs_left_' + $(this).attr('pif')).css('bottom', (parseInt($('#tabs_left_' + $(this).attr('pif')).css('bottom')) + $('#content_route_' + $(this).attr('route'))[0].getBoundingClientRect().height) + 'px');

                    // si le contenu du portrait dépasse du viewport, on scroll pour centrer la vue dessus
                    var portrait_container_focused = $('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif'));
                    var content_route_focused = $('#content_route_' + $(this).attr('route'));
                    if (0 > portrait_container_focused[0].getBoundingClientRect().top) {
                        $('html, body').animate({ scrollTop: portrait_container_focused.offset().top}, 500);
                    } else if (content_route_focused[0].getBoundingClientRect().bottom > $(window).height()) {
                        $('html, body').animate({ scrollTop: (content_route_focused.offset().top + content_route_focused.height()) - $(window).height()}, 500);
                    }
                }
                $(this).toggleClass('active');
            });


            var content_route = portraitsContainer.append('div')
            .attr('id', 'content_route_' + i)
            .attr('class', 'content_route content_route_pif_' + pif.id)
            .attr('route', i);

            content_route.append('div')
            .attr('class','portrait_arrow')
            .attr('route', i)
            .attr('pif', pif.id)
            .on('click', function() {
                // permet de redescendre les tabs lorsqu'on est sur mobile lorsqu'on clique sur la fleche
                if (480 >= $(window).width() && 'full' == view_type) {
                    $('#tabs_left_' + $(this).attr('pif')).css('bottom', (parseInt($('#tabs_left_' + $(this).attr('pif')).css('bottom')) - $('#content_route_' + $(this).attr('route'))[0].getBoundingClientRect().height) + 'px');
                }

                $('#description_buttons_container_route_' + $(this).attr('route')).removeClass('active');
                $('#description_button_route_' + $(this).attr('route') + '.description_button_off').show();

                $('#content_route_' + $(this).attr('route')).css('display', 'none');
                $('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).removeClass('visible').removeClass('active');

                $('.diagram_button_' + $(this).attr('pif') + '.active').css('background-color', '#999999').css('color', 'black');

                $('.diagram_button_' + $(this).attr('pif') + '.active').removeClass('active');
                $('.description_button_' + $(this).attr('pif') + '.active').removeClass('active');

                d3.selectAll('.route_layer_' + $(this).attr('pif')).remove();
            });

            var portrait_text = content_route.append('div')
            .attr('class', 'portrait_text_container portrait_text_container_' + pif.id)
            .attr('id', 'portrait_text_container_route_' + i);

            portrait_text.append('h3')
            .text('Mon parcours')
            .attr('class', 'title_portrait_text');

            portrait_text.append('h4')
            .text(chapo)
            .attr('class', 'portrait_chapo');

            portrait_text.append('p')
            .attr('class', 'portrait_text')
            .text(jQuery(description).text());

            var portrait_diagram = content_route.append('div')
            .attr('class', 'portrait_diagram_container portrait_diagram_container_' + pif.id)
            .attr('id', 'route_' + i);

            portraitTitle.on('click', function() {
                //si le portrait est actif et si la route isolée n'est pas active
                if ($('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).hasClass('active') && !$('.diagram_button_' + $(this).attr('pif') + '.active').length) {
                    //si le portrait_pan est visible on enlève la route tracée et on supprime les classes correspondantes
                    if ($('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).hasClass('visible')) {
                        $('.portrait_container_' + $(this).attr('pif')).removeClass('active').removeClass('visible');
                        $('#portraits_pan_' + $(this).attr('pif')).removeClass('visible');
                        $('#portrait_focus_' + $(this).attr('pif')).remove();

                        d3.selectAll('.route_layer_' + $(this).attr('pif')).remove();
                        if (480 >= $(window).width() && 'full' == view_type) {
                            $('#tabs_left_' + $(this).attr('pif')).css('bottom', (parseInt($('#tabs_left_' + $(this).attr('pif')).css('bottom')) - $('#content_route_' + $(this).attr('route'))[0].getBoundingClientRect().height) + 'px');
                        }
                        $('#description_button_route_' + $(this).attr('route') + '.description_button_off').show();
                        $('#description_buttons_container_route_' + $(this).attr('route')).removeClass('active');
                        $('#content_route_' + $(this).attr('route')).css('display', 'none');


                        // recentre le pif à la fermeture du panneau au clic sur un portrait
                        var shift_right = 0, shift_left = 0;

                        if ('full' == view_type) {
                            if ((($('#left_pan_' + $(this).attr('pif')).hasClass('visible') && (480 < $(window).width())) || (1024 < $(window).width())) && 'full' == view_type) {
                                shift_left += parseInt($('#left_pan_' + $(this).attr('pif')).css('width'));
                            }
                        } else {
                            if ($('#left_pan_' + $(this).attr('pif')).hasClass('visible')) {
                                shift_left += parseInt($('#left_pan_' + $(this).attr('pif')).css('width'));
                            }
                        }
                        if ((($('#right_pan_' + $(this).attr('pif')).hasClass('visible') && (480 < $(window).width())) || (1024 < $(window).width())) && 'full' == view_type) {
                            shift_right += parseInt($('#right_pan_' + $(this).attr('pif')).css('width'));
                        }

                        var movable_area_w = $('#pif_' + $(this).attr('pif') + '_container .pif_years_group_' + $(this).attr('pif'))[0].getBoundingClientRect().width;

                        if ( movable_area_w + shift_left + shift_right < $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect().width) {
                            //pour recentrer le pif à la fermeture du panneau s'il ne peut pas être translaté
                            var svg = d3.select('#pif_' + $(this).attr('pif') + '_area');

                            var trans_initial = d3.select('#pif_' + $(this).attr('pif') + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];
                            var zoom_initial = zoom[$(this).attr('pif')].translate()[0];

                            svg.attr('transform', 'translate(0,0)');
                            zoom[$(this).attr('pif')].translate([0, 0]);
                            var BB_pif = $('#pif_years_group_id' + $(this).attr('pif'))[0].getBoundingClientRect();
                            var BB_svg_area = $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect();
                            var shift_negatif = BB_pif.left - BB_svg_area.left;

                            svg.attr('transform', 'translate(' + trans_initial + ',0)');
                            zoom[$(this).attr('pif')].translate([zoom_initial, 0]);

                            svg.transition()
                            .duration(200)
                            .ease('quad')
                            .attr('transform', function() {
                                var BB_pif = $('#pif_years_group_id' + $(this).attr('pif'))[0].getBoundingClientRect();
                                var BB_svg_area = $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect();
                                var position = d3.select('#pif_' + $(this).attr('pif') + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];

                                var x = position - ((BB_svg_area.width - BB_pif.width)/2) ;
                                zoom[$(this).attr('pif')].translate([position - x - shift_negatif + shift_left/2, 0]);

                                return 'translate(' + (position - x - shift_negatif + shift_left/2) + ',0)';
                            });
                        }
                        allPif[$(this).attr('pif')].setArrowsVisibility();
                        var pif_area = d3.select('#pif_' + $(this).attr('pif') + '_area');
                        if (movable_area_w + shift_left + shift_right > $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect().width) {
                            if (zoom[$(this).attr('pif')].translate()[0] >= (80 + shift_left)) {
                                pif_area.transition()
                                .duration(200)
                                .ease('quad')
                                .attr('transform', 'translate(' + (80 + shift_left) + ',0)');

                                zoom[$(this).attr('pif')].translate([80 + shift_left, 0]);
                                $('#oni-ico-fleche4_right_pif_' + $(this).attr('pif')).css('visibility', 'hidden');
                                $('#half-circle-right_pif_' + $(this).attr('pif')).css('visibility', 'hidden');
                            }
                        }
                    } else { //sinon on ajoute les classes 'visible'
                        $('#portraits_pan_' + $(this).attr('pif')).addClass('visible');
                        $('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).addClass('visible')
                    }
                } else { // si on clique sur un portrait qui n'est pas actif
                    //enlève la zone de la route si elle est active
                    $('.diagram_button_' + $(this).attr('pif') + '.active')
                    .css('background-color', '#999999').css('color', 'black').removeClass('active');
                    $('#route_' + $(this).attr('route')).css('display', 'none');
                    $('#portrait_text_container_route_' + $(this).attr('route')).css('display', 'inline');

                    $('.element_portraits_pan_container_pif_' + $(this).attr('pif')).css('display', 'none');
                    $('#element_portraits_pan_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).css('display', 'block');
                    $('.portrait_container_' + $(this).attr('pif')).removeClass('active');
                    $('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).addClass('active').addClass('visible');
                    $('#portraits_pan_' + $(this).attr('pif')).addClass('visible');

                    $('.description_button_off.description_button_' + $(this).attr('pif')).show();
                    $('#description_buttons_container_route_' + $(this).attr('route')).addClass('active');

                    if ((480 < $(window).width() || 'embed' == view_type)) {
                        allPif[$(this).attr('pif')].draw_route(allPif[$(this).attr('pif')].routes[$(this).attr('route')]);
                    }

                    //replie toutes les zones de description/route des portraits
                    $('.content_route_pif_' + $(this).attr('pif')).css('display', 'none');
                    if (480 >= $(window).width() && 'full' == view_type) {
                        $('#tabs_left_' + $(this).attr('pif')).css('bottom', $('#portraits_container_' + $(this).attr('pif'))[0].getBoundingClientRect().height + 'px');
                        //calcul de la hauteur maximale du content route à afficher pour mobile
                        $('#content_route_' + $(this).attr('route') + '.content_route_pif_' + $(this).attr('pif'))
                        .css('max-height', ($('#pif_' + $(this).attr('pif') +'_container').height() - $('#portraits_container_' + $(this).attr('pif')).height()
                                - $('#title_pif_' + $(this).attr('pif')).height() - 20 - $('#tabs_left_' + $(this).attr('pif'))[0].getBoundingClientRect().height) + 'px');
                    } else {
                        $('#content_route_' + $(this).attr('route') + '.content_route_pif_' + $(this).attr('pif'))
                        .css('max-height', $('#left_pan_' + $(this).attr('pif')).height() - $('#portraits_container_' + $(this).attr('pif')).height()
                                - $('#title_pif_' + $(this).attr('pif')).height() - 20 + 'px')
                    }
                    $('#description_button_route_' + $(this).attr('route') + '.description_button_off').hide();
                    $('#content_route_' + $(this).attr('route')).css('transition-delay', '0.3s')
                    .css('height', $('#content_route' + $(this).attr('route')).css('max-height'))
                    .css('display', 'block').addClass('visible');

                    if (480 >= $(window).width() && 'full' == view_type) {
                        $('#tabs_left_' + $(this).attr('pif')).css('bottom', (parseInt($('#tabs_left_' + $(this).attr('pif')).css('bottom')) + $('#content_route_' + $(this).attr('route'))[0].getBoundingClientRect().height) + 'px');
                        // si le contenu du portrait dépasse du viewport, on scroll pour centrer la vue dessus
                        var portrait_container_focused = $('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif'));
                        var content_route_focused =  $('#content_route_' + $(this).attr('route'));
                        if (0 > portrait_container_focused[0].getBoundingClientRect().top) {
                            $('html, body').animate({ scrollTop: portrait_container_focused.offset().top}, 500);
                        } else if (content_route_focused[0].getBoundingClientRect().bottom > $(window).height()) {
                            $('html, body').animate({ scrollTop: (content_route_focused.offset().top + content_route_focused.height()) - $(window).height()}, 500);
                        }
                    }
                }

                //affiche ou cache le panel des portraits
                if ($('#portraits_pan_' + $(this).attr('pif')).hasClass('visible')) {
                    $('#portrait_focus_' + $(this).attr('pif')).remove();
                    $('#portraits_pan_' + $(this).attr('pif')).css('transition-delay', '0s').css('width', 0);
                    d3.select('#portrait_container_' + $(this).attr('route') + '_pif_' + $(this).attr('pif')).append('div')
                    .attr('class', 'portrait_focus')
                    .attr('id', 'portrait_focus_' + $(this).attr('pif'));

                    $('#portraits_pan_' + $(this).attr('pif')).css('width', $('.portraits_pan').css('max-width')).css('-ms-overflow-style', 'auto');
                } else {
                    $('#portraits_pan_' + $(this).attr('pif')).css('transition-delay', '0s').css('-ms-overflow-style', 'none').css('width', 0);
                }
            });
        }
    }

    //création des portraits
    for(i in pif.routes) {
        var name = pif.routes[i].firstname + ' ' + pif.routes[i].name;
        var chapo = pif.routes[i].chapo;
        var description = pif.routes[i].route_content;

        var portrait_element = content_portrait.append('div')
        .attr('id', 'element_portraits_pan_container_' + pif.routes[i].id + '_pif_' + pif.id)
        .attr('class', 'element_portraits_pan_container element_portraits_pan_container_pif_' + pif.id);

        portrait_element.append('h3')
        .text('Mon parcours')
        .attr('class', 'title_portrait_text');

        portrait_element.append('h4')
        .text(chapo);
        portrait_element.append('p')
        .attr('class', 'portrait_text')
        .text(jQuery(description).text());

        //si le texte du portrait dépasse la hauteur du container, on place le texte en haut du container et on ajuste les marges pour la scrollbar
        if ($('#portraits_pan_' + pif.id)[0].getBoundingClientRect().height < $('#element_portraits_pan_container_' + pif.routes[i].id + '_pif_' + pif.id)[0].getBoundingClientRect().height) {
            portrait_element.style('width', parseInt($('.portraits_pan').css('max-width')) - (parseInt($('.portraits_pan_container').css('padding-left')) + parseInt($('.portraits_pan_container').css('padding-right'))) - 10 + 'px');
            portrait_element.style('top', '0px');
        } else {
            var y_pos = Math.abs($('#portraits_container_' + pif.id).position().top) + ($('#portrait_container_' + pif.routes[i].id + '_pif_' + pif.id).position().top)
                + ($('#portrait_container_' + pif.routes[i].id + '_pif_' + pif.id)[0].getBoundingClientRect().height / 2)
                - ($('#element_portraits_pan_container_' + pif.routes[i].id + '_pif_' + pif.id)[0].getBoundingClientRect().height / 2)
                - ($('.cross_portrait_pan').outerHeight(true));
            portrait_element.style('width', parseInt($('.portraits_pan').css('max-width')) - (parseInt($('.portraits_pan_container').css('padding-left')) + parseInt($('.portraits_pan_container').css('padding-right'))) + 'px');
            portrait_element.style('top', y_pos + 'px');
            //si le texte dépasse en dessous
            if ($('#portraits_pan_' + pif.id)[0].getBoundingClientRect().bottom < $('#element_portraits_pan_container_' + i + '_pif_' + pif.id)[0].getBoundingClientRect().bottom) {
                portrait_element.style('top', '').style('bottom', -(parseInt($('#portraits_pan_' + pif.id)[0].getBoundingClientRect().height) - (parseInt($('.portraits_pan_container').css('padding-top')) + parseInt($('.portraits_pan_container').css('padding-bottom'))) - $('.cross_portrait_pan').outerHeight(true)) + 'px');
            }
        }
    }


    var tabs_left = d3.select('#tabs_left_' + pif.id)
    .style('margin-top', function() {
        if (($('.cross_pan').outerHeight() < $('#title_pif_' + pif.id).height())) {
            return $('#title_pif_' + pif.id).height() + 'px';
        }
        return $('.cross_pan').outerHeight(true) + 'px';
    });

    var tabs_right = d3.select('#tabs_right_' + pif.id)
    .style('margin-top', function() {
        if ($('.cross_pan').outerHeight() < $('#title_pif_' + pif.id).height()) {
            return $('#title_pif_' + pif.id).height() + 'px';
        }
        return $('.cross_pan').outerHeight(true) + 'px';
    });

    var tab_filters = tabs_left.append('div')
    .attr('class', 'tab no_select_text')
    .attr('id', 'tab_filters_' + pif.id)
    .attr('pif', pif.id)
    .text('FILTRES')
    .on('click', function() {
        var pifId = $(this).attr('pif');
        allPif[pifId].deployLeftPan($('#filters_container_' + pifId), $('#tab_filters_' + pifId), pifId);
    });

    var tab_portraits = tabs_left.append('div')
    .attr('class', 'tab no_select_text')
    .attr('id', 'tab_portraits_' + pif.id)
    .attr('pif', pif.id)
    .text('PORTRAITS')
    .on('click', function() {
        var pifId = $(this).attr('pif');
        allPif[pifId].deployLeftPan($('#portraits_container_' + pifId), $('#tab_portraits_' + pifId), pifId);
    })
    .style('display', function() {
        if (0 == Object.size(pif.routes)) {
            return 'none';
        }
    });

    var tab_legend = tabs_left.append('div')
    .attr('class', 'tab no_select_text display_tab')
    .attr('id', 'tab_legend_' + pif.id)
    .attr('pif', pif.id)
    .text('AFFICHAGE')
    .on('click', function() {
        var pifId = $(this).attr('pif');
        allPif[pifId].deployLeftPan($('#enrichments_container_' + pifId), $('#tab_legend_' + pifId), pifId);
    });

    //  ************ Partie de droite ***************

    var enrichmentsContainer = left_pan_container.append('div')
    .attr('id', 'enrichments_container_' + pif.id)
    .attr('class', 'enrichments_container');

    if ('full' == view_type) {
        var right_pan = d3.select('#right_pan_' + pif.id)
        .style('height', $('#pif_' + pif.id + '_container').css('height'));

        var closing_cross_right = right_pan.append('div')
        .attr('class', 'oni-ico-croix_cercle cross_pan no_select_text')
        .attr('pif', pif.id)
        .on('click', function() {
            var movable_area_w = $('#pif_' + $(this).attr('pif') + '_container .pif_years_group_' + $(this).attr('pif'))[0].getBoundingClientRect().width;

            $('#right_pan_' + pif.id).animate({
                'margin-right': '-' + $('#right_pan_' + pif.id).css('width')}, 200 );
            $('#right_pan_' + pif.id).toggleClass('visible');
            $('#half-circle-right_pif_' + pif.id).animate({
                'right': 0}, 200);
            $('#oni-ico-fleche4_right_pif_' + pif.id).animate({
                'right': '1px'}, 200);

            var shift_left = 0;

            if (($('#left_pan_' + pif.id).hasClass('visible') && (480 < $(window).width())) || (1024 < $(window).width())) {
                shift_left += parseInt($('#left_pan_' + pif.id).css('width'));
                if ($('#portraits_pan_' + pif.id).hasClass('visible') && 768 < parseInt($('#pif_' + pif.id + '_container').css('width'))) {
                    // evite les problèmes concernant une mauvaise width si l'animation du portraits pan n'est pas finie
                    shift_left = shift_left * 2;
                }
            }

            if ( movable_area_w + shift_left < $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                //pour recentrer le pif à la fermeture du panneau s'il ne peut pas être translaté
                var svg = d3.select('#pif_' + pif.id + '_area');

                var trans_initial = d3.select('#pif_' + pif.id + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];
                var zoom_initial = zoom[pif.id].translate()[0];

                svg.attr('transform', 'translate(0,0)');
                zoom[pif.id].translate([0, 0]);
                var BB_pif = $('#pif_years_group_id' + pif.id)[0].getBoundingClientRect();
                var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                var shift_negatif = BB_pif.left - BB_svg_area.left;

                svg.attr('transform', 'translate(' + trans_initial + ',0)');
                zoom[pif.id].translate([zoom_initial, 0]);

                svg.transition()
                .duration(200)
                .ease('quad')
                .attr('transform', function() {
                    var BB_pif = $('#pif_years_group_id' + pif.id)[0].getBoundingClientRect();
                    var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                    var position = d3.select('#pif_' + pif.id + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];

                    var x = position - ((BB_svg_area.width - BB_pif.width)/2) ;
                    zoom[pif.id].translate([position - x - shift_negatif, 0]);
                    return 'translate(' + (position - x - shift_negatif ) + ',0)';
                });
            }

            allPif[$(this).attr('pif')].setArrowsVisibility();
            var pif_area = d3.select('#pif_' + pif.id + '_area');
            var pif_width = $('#pif_' + pif.id + '_container').outerWidth();
            if (movable_area_w + shift_left > $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                if (zoom[pif.id].translate()[0] <= -(movable_area_w - pif_width + 80)) {
                    pif_area.transition()
                    .duration(200)
                    .ease('quad')
                    .attr('transform', 'translate(' + -(movable_area_w - pif_width + 80 ) + ',0)');

                    zoom[pif.id].translate([-(movable_area_w - pif_width + 80), 0]);
                    $('#oni-ico-fleche4_right_pif_' + pif.id).css('visibility', 'hidden');
                    $('#half-circle-right_pif_' + pif.id).css('visibility', 'hidden');
                }
            }
        });

        var right_pan_container = right_pan.append('div')
        .attr('class', 'right_pan_container')
        .attr('id', 'right_pan_container_' + pif.id)
        .style('margin-top', function() {
            if ($('.cross_pan').outerHeight() < $('#title_pif_' + pif.id).height()) {
                return ($('#title_pif_' + pif.id).height() - $('.cross_pan').outerHeight(true)) + 'px';
            }
            return 0;
        });


        var tab_legend_right = tabs_right.append('div')
        .attr('class', 'tab no_select_text display_tab_right')
        .attr('id', 'tab_legend_right_' + pif.id)
        .attr('pif', pif.id)
        .text('AFFICHAGE')
        .on('click', function() {
            var movable_area_w = $('#pif_' + $(this).attr('pif') + '_container .pif_years_group_' + $(this).attr('pif'))[0].getBoundingClientRect().width;

            if ($('#right_pan_' + $(this).attr('pif')).hasClass('visible')) {
                $('#right_pan_' + $(this).attr('pif')).animate({
                    'margin-right': '-' + $('#right_pan_' + $(this).attr('pif')).css('width')}, 200 );
                $('#right_pan_' + $(this).attr('pif')).toggleClass('visible');
                $('#half-circle-right_pif_' + $(this).attr('pif')).animate({
                    'right': 0}, 200);
                $('#oni-ico-fleche4_right_pif_' + $(this).attr('pif')).animate({
                    'right': '1px'}, 200);

                var pif_area = d3.select('#pif_' + $(this).attr('pif') + '_area');

                if (movable_area_w > $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect().width) {
                    if (zoom[$(this).attr('pif')].translate()[0] >= 80) {
                        pif_area.transition()
                        .duration(200)
                        .ease('quad')
                        .attr('transform', 'translate(' + 80 + ',0)');
                        zoom[$(this).attr('pif')].translate([80, 0]);

                    }
                }

                var shift_left = 0;

                if (($('#left_pan_' + $(this).attr('pif')).hasClass('visible') && (480 < $(window).width())) || (1024 < $(window).width())) {
                    shift_left += parseInt($('#left_pan_' + $(this).attr('pif')).css('width'));
                    if ($('#portraits_pan_' + $(this).attr('pif')).hasClass('visible') && 768 < parseInt($('#pif_' + $(this).attr('pif') + '_container').css('width'))) {
                        // evite les problèmes concernant une mauvaise width si l'animation du portraits pan n'est pas finie
                        shift_left = shift_left * 2;
                    }
                }

                if ( movable_area_w + shift_left < $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect().width) {
                    //pour recentrer le pif à la fermeture du panneau s'il ne peut pas être translaté
                    var svg = d3.select('#pif_' + $(this).attr('pif') + '_area');

                    var trans_initial = d3.select('#pif_' + $(this).attr('pif') + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];
                    var zoom_initial = zoom[$(this).attr('pif')].translate()[0];

                    svg.attr('transform', 'translate(0,0)');
                    zoom[$(this).attr('pif')].translate([0, 0]);
                    var BB_pif = $('#pif_years_group_id' + $(this).attr('pif'))[0].getBoundingClientRect();
                    var BB_svg_area = $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect();
                    var shift_negatif = BB_pif.left - BB_svg_area.left;

                    svg.attr('transform', 'translate(' + trans_initial + ',0)');
                    zoom[$(this).attr('pif')].translate([zoom_initial, 0]);

                    svg.transition()
                    .duration(200)
                    .ease('quad')
                    .attr('transform', function() {
                        var BB_pif = $('#pif_years_group_id' + $(this).attr('pif'))[0].getBoundingClientRect();
                        var BB_svg_area = $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect();
                        var position = d3.select('#pif_' + $(this).attr('pif') + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];

                        var x = position - ((BB_svg_area.width - BB_pif.width)/2) ;
                        zoom[$(this).attr('pif')].translate([position - x - shift_negatif, 0]);
                        return 'translate(' + (position - x - shift_negatif ) + ',0)';
                    });
                }
                allPif[$(this).attr('pif')].setArrowsVisibility();

                var pif_area = d3.select('#pif_' + pif.id + '_area');
                var pif_width = $('#pif_' + pif.id + '_container').outerWidth();
                if (movable_area_w + shift_left > $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                    if (zoom[pif.id].translate()[0] <= -(movable_area_w - pif_width + 80)) {
                        pif_area.transition()
                        .duration(200)
                        .ease('quad')
                        .attr('transform', 'translate(' + -(movable_area_w - pif_width + 80 ) + ',0)');

                        zoom[pif.id].translate([-(movable_area_w - pif_width + 80), 0]);
                        $('#oni-ico-fleche4_right_pif_' + pif.id).css('visibility', 'hidden');
                        $('#half-circle-right_pif_' + pif.id).css('visibility', 'hidden');
                    }
                }
            } else {
                var shift_right = 0; // décalage à droite en fonction du panel

                if (480 < $(window).width()) {
                    shift_right += parseInt($('#right_pan_' + $(this).attr('pif')).css('width'));
                }

                allPif[$(this).attr('pif')].setArrowsVisibility();

                if (movable_area_w + shift_right > $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect().width) {
                    $('#oni-ico-fleche4_right_pif_' + $(this).attr('pif')).css('visibility', 'visible');
                    $('#half-circle-right_pif_' + $(this).attr('pif')).css('visibility', 'visible');
                }

                $('#right_pan_' + $(this).attr('pif')).animate({
                    'margin-right': 0}, 200 );
                $('#right_pan_' + $(this).attr('pif')).toggleClass('visible');
                $('#half-circle-right_pif_' + $(this).attr('pif')).animate({
                    'right': $('#right_pan_' + $(this).attr('pif')).css('width')}, 200);
                $('#oni-ico-fleche4_right_pif_' + $(this).attr('pif')).animate({
                    'right': $('#right_pan_' + $(this).attr('pif')).css('width')}, 200);

                if (480 < $(window).width() || 'view_type' == 'embed') {
                    if (parseInt($('#right_pan_' + $(this).attr('pif')).css('width')) > $('#svg_area_' + $(this).attr('pif')).width() - $('#pif_' + $(this).attr('pif') + '_area')[0].getBoundingClientRect().right
                            && movable_area_w < $('#svg_area_' + $(this).attr('pif'))[0].getBoundingClientRect().width) {
                        //si le pif est plus petit que la zone d'affichage (et donc ne peut pas être translaté) et que le panneau couvre une partie du graphique
                        var pif_container_width = $('#pif_' + $(this).attr('pif') + '_container').outerWidth();
                        d3.select('#pif_' + $(this).attr('pif') + '_area').transition()
                        .duration(200)
                        .ease('quad')
                        .attr('transform', 'translate(' + (-(movable_area_w -
_width + 80 + shift_right)) + ',0)');
                        zoom[$(this).attr('pif')].translate([-(movable_area_w - pif_container_width + 80 + shift_right), 0]);
                    }
                }
            }
            $('#tab_filters_' + $(this).attr('pif')).css('background-color', '#4D4D4D');
            $('#tab_portraits_' + $(this).attr('pif')).css('background-color', '#4D4D4D');
            $('#tab_legend_' + $(this).attr('pif')).css('background-color', '#666666');
            $('#tab_legend_right_' + $(this).attr('pif')).css('background-color', '#666666');
        });

        var enrichmentsContainerRight = right_pan_container.append('div')
        .attr('id', 'enrichments_container_right_' + pif.id)
        .attr('class', 'enrichments_container_right');

        build_enrichments_area(enrichmentsContainerRight);
    }

    build_enrichments_area(enrichmentsContainer);

    var zoom_buttons = d3.select('#enrichments_area_' + pif.id).append('div')
    .attr('class', 'zoom_buttons')
    .attr('id', 'zoom_buttons_' + pif.id)
    .style('top', $('#title_pif_' + pif.id).height() + 20 + 'px');

    zoom_buttons.append('div')
    .attr('class', 'oni-ico-plus_cercle zoom_plus')
    .on('click', function() {
        if (1 > zoom_value) {
            zoom_value = zoom_value + 0.1;
            var position = d3.select('#pif_' + pif.id + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];
            $('#pif_' + pif.id + '_area').attr('transform', 'translate(' + position + ', 0) scale(' + zoom_value + ')');
        }
    });

    zoom_buttons.append('div')
    .attr('class', 'oni-ico-moins_cercle zoom_minus')
    .on('click', function() {
        if (0.7 < zoom_value) {
            zoom_value = zoom_value - 0.1;
            $('#pif_' + pif.id + '_area').attr('transform', $('#pif_' + pif.id + '_area').attr('transform'));
            var position = d3.select('#pif_' + pif.id + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];
            $('#pif_' + pif.id + '_area').attr('transform', 'translate(' + position + ', 0) scale(' + zoom_value + ')');
        }
    });
}


/*********************************************************************************************
 * Permet d'intéragir avec le panneau de gauche via les onglets
 *********************************************************************************************/

Pif.prototype.deployLeftPan = function(element, tab, pifId) {
    var movable_area_w = $('#pif_' + pifId + '_container .pif_years_group_' + pifId)[0].getBoundingClientRect().width;

   if ($('#left_pan_' + pifId).hasClass('visible') && element.css('display') == 'none') {
        //si le panneau est affiché, mais que les elements ne le sont pas, on les affiche et on attribue la bonne hauteur pour les onglets
        if (480 >= $(window).width()) {
            element.css('display', 'inline');
            $('#tabs_left_' + pifId).css('bottom', element[0].getBoundingClientRect().height + 'px');
        }
    } else if (!$('#left_pan_' + pifId).hasClass('visible')) {
        //si le panneau n'est pas visible, on l'affiche avec les elements

        var shift_left = 0; // décalage à gauche en fonction du panel

        if (480 < $(window).width() /* ||  'embed' == view_type*/) {
            shift_left += parseInt($('#left_pan_' + pifId).css('width'));
            if ($('#portraits_pan_' + pifId).hasClass('visible') && 768 < parseInt($('#pif_' + pifId + '_container').css('width'))) {
                shift_left += parseInt($('#portraits_pan_' + pifId).css('width'));
            }
        }


        if (480 < $(window).width() /* || 'embed' == view_type*/) {
            $('#left_pan_' + pifId).animate({
                'margin-left': 0},  200 );

            $('#left_pan_' + pifId).toggleClass('visible');
            $('#half-circle-left_pif_' + pifId).animate({
                'left': $('#left_pan_' + pifId).css('width')}, 200);
            $('#oni-ico-fleche4_left_pif_' + pifId).animate({
                'left': $('#left_pan_' + pifId).css('width')}, 200);
        } else {
            element.css('display', 'inline')
            .css('bottom', '-' + element[0].getBoundingClientRect().height + 'px');

            $('#tabs_left_' + pifId).animate({
                'bottom': element[0].getBoundingClientRect().height + 'px'}, 200 );

            $('#filters_container_' + pifId).animate({
                'bottom': 0}, 200 );
            $('#portraits_container_' + pifId).animate({
                'bottom': 0}, 200 );
            $('#enrichments_container_' + pifId).animate({
                'bottom': 0}, 200 );


            $('#left_pan_' + pifId).toggleClass('visible');
        }

        if (480 < $(window).width() /* || 'view_type' == 'embed'*/) {
            if (parseInt($('#left_pan_' + pifId).css('width')) > $('#pif_' + pifId + '_area').offset().left - $('#pif_' + pifId + '_container').offset().left
                    && movable_area_w < $('#svg_area_' + pifId)[0].getBoundingClientRect().width) {
                //si le pif est plus petit que la zone d'affichage (et donc ne peut pas être translaté) et que le panneau couvre une partie du graphique
                var pif_container_width = $('#pif_' + pifId + '_container').outerWidth();
                d3.select('#pif_' + pifId + '_area').transition()
                .duration(200)
                .ease('quad')
                .attr('transform', 'translate(' + (80 + shift_left) + ',0)');
                zoom[pifId].translate([80 + shift_left, 0]);
                allPif[pifId].setArrowsVisibility();
            }
        }
    }

    $('#tab_filters_' + pifId).css('background-color', '#4D4D4D');
    $('#tab_portraits_' + pifId).css('background-color', '#4D4D4D');
    $('#tab_legend_' + pifId).css('background-color', '#4D4D4D');
    tab.css('background-color', '#666666');

    $('#filters_container_' + pifId).css('display', 'none');
    $('#enrichments_container_' + pifId).css('display', 'none');
    $('#portraits_container_' + pifId).css('display', 'none');
    element.css('display', 'inline');
}


/**************************************************************************************************
 * Construit la partie de la légendes / des enrichisements
 **************************************************************************************************/
function build_enrichments_area(enrichmentsContainer) {

    enrichmentsContainer.append('h3').text('AFFICHAGE').attr('class', 'title_section');

    var legendContainer = enrichmentsContainer.append('div')
    .attr('class', 'legend_container');

    legendContainer.append('div')
    .text('Origines des élèves')
    .attr('class', 'filter_block enrichments_button origin')
    .attr('id', 'origin_' + pif.id)
    .attr('pif', pif.id)
    .style('background-color', function() {
        if ($(this).hasClass('enrichments_button_active')) {
            return '#B3B3B3';
        }
    })
    .on('click', function() {
        $(this).toggleClass('enrichments_button_active');
        if ($(this).hasClass('enrichments_button_active')) {
            $('#origin_' + $(this).attr('pif')).css('background-color','#B3B3B3').addClass('enrichments_button_active'); // permet d'activer les buttons des deux pan
            $(this).css('background-color', '#B3B3B3');
        } else {
            $('#origin_' + $(this).attr('pif')).css('background-color','').removeClass('enrichments_button_active');
            $(this).css('background-color', '');
        }
    });

    legendContainer.append('div')
    .text('Nombre d\'établissements')
    .attr('class', 'filter_block enrichments_button nbre')
    .attr('id', 'institutions_number_' + pif.id)
    .attr('pif', pif.id)
    .style('background-color', function() {
        if ($(this).hasClass('enrichments_button_active')) {
            return '#B3B3B3';
        }
    })
    .on('click', function() {
        $(this).toggleClass('enrichments_button_active');
        if ($(this).hasClass('enrichments_button_active')) {
            $('#institutions_number_' + $(this).attr('pif')).css('background-color','#B3B3B3').addClass('enrichments_button_active');
            $(this).css('background-color', '#B3B3B3');
        } else {
            $('#institutions_number_' + $(this).attr('pif')).css('background-color','').removeClass('enrichments_button_active');
            $(this).css('background-color', '');
        }
    });

    legendContainer.append('div')
    .text('Éffectifs')
    .attr('class', 'filter_block enrichments_button eff')
    .attr('id', 'effectives_' + pif.id)
    .attr('pif', pif.id)
    .style('background-color', function() {
        if ($(this).hasClass('enrichments_button_active')) {
            return '#B3B3B3';
        }
    })
    .on('click', function() {
        $(this).toggleClass('enrichments_button_active');
        if ($(this).hasClass('enrichments_button_active')) {
            $('#effectives_' + $(this).attr('pif')).css('background-color','#B3B3B3').addClass('enrichments_button_active');
            $(this).css('background-color', '#B3B3B3');
        } else {
            $('#effectives_' + $(this).attr('pif')).css('background-color','').removeClass('enrichments_button_active');
            $(this).css('background-color', '');
        }
    });

    legendContainer.append('div')
    .text('Diplômes')
    .attr('class', 'filter_block enrichments_button enrichments_button_active')
    .attr('id', 'qualifications_' + pif.id)
    .attr('pif', pif.id)
    .style('background-color', function() {
        if ($(this).hasClass('enrichments_button_active')) {
            return '#B3B3B3';
        }
    })
    .on('click', function() {
        $(this).toggleClass('enrichments_button_active');
        if ($(this).hasClass('enrichments_button_active')) {
            $('#qualifications_' + $(this).attr('pif')).css('background-color','#B3B3B3').addClass('enrichments_button_active');
            d3.selectAll('#rect_title_diploma_' + $(this).attr('pif')).style('visibility', 'visible');
            $(this).css('background-color', '#B3B3B3');
        } else {
            $('#qualifications_' + $(this).attr('pif')).css('background-color','').removeClass('enrichments_button_active');
            d3.selectAll('#rect_title_diploma_' + $(this).attr('pif')).style('visibility', 'hidden');
            $(this).css('background-color', '');
        }
    });

    legendContainer.append('div')
    .text('Passerelles')
    .attr('class', 'filter_block enrichments_button enrichments_button_active')
    .attr('id', 'gateways_' + pif.id)
    .attr('pif', pif.id)
    .style('background-color', function() {
        if ($(this).hasClass('enrichments_button_active')) {
            return '#B3B3B3';
        }
    })
    .on('click', function() {
        $(this).toggleClass('enrichments_button_active');
        if ($(this).hasClass('enrichments_button_active')) {
            $('#gateways_' + $(this).attr('pif')).css('background-color','#B3B3B3').addClass('enrichments_button_active');
            d3.selectAll('#pif_' + $(this).attr('pif') + '.gateways').style('visibility', 'visible');
            $(this).css('background-color', '#B3B3B3');
        } else {
            $('#gateways_' + $(this).attr('pif')).css('background-color','').removeClass('enrichments_button_active');
            d3.selectAll('#pif_' + $(this).attr('pif') + '.gateways').style('visibility', 'hidden');
            $(this).css('background-color', '');
        }
    });

    legendContainer.append('div')
    .text('Sélections')
    .attr('class', 'filter_block enrichments_button enrichments_button_active')
    .attr('id', 'selection_' + pif.id)
    .attr('pif', pif.id)
    .style('background-color', function() {
        if ($(this).hasClass('enrichments_button_active')) {
            return '#B3B3B3';
        }
    })
    .on('click', function() {
        $(this).toggleClass('enrichments_button_active');
        if ($(this).hasClass('enrichments_button_active')) {
            $('#selection_' + $(this).attr('pif')).css('background-color','#B3B3B3').addClass('enrichments_button_active');
            d3.selectAll('.year_selectivity_' + $(this).attr('pif')).style('visibility', 'visible');
            $(this).css('background-color', '#B3B3B3');
        } else {
            $('#selection_' + $(this).attr('pif')).css('background-color','').removeClass('enrichments_button_active');
            d3.selectAll('.year_selectivity_' + $(this).attr('pif')).style('visibility', 'hidden');
            $(this).css('background-color', '');
        }
    });


    legendContainer.append('div')
    .text('Niveaux de reconnaissance')
    .attr('class', 'filter_block enrichments_button lvl')
    .attr('id', 'recognition_level_' + pif.id)
    .attr('pif', pif.id)
    .style('background-color', function() {
        if ($(this).hasClass('enrichments_button_active')) {
            return '#B3B3B3';
        }
    })
    .on('click', function() {
        $(this).toggleClass('enrichments_button_active');
        if ($(this).hasClass('enrichments_button_active')) {
            $('#recognition_level_' + $(this).attr('pif')).css('background-color','#B3B3B3').addClass('enrichments_button_active');
            $(this).css('background-color', '#B3B3B3');
        } else {
            $('#recognition_level_' + $(this).attr('pif')).css('background-color','').removeClass('enrichments_button_active');
            $(this).css('background-color', '');
        }
    });
}


/****************************************************************************************
 * Construit le filtre par métier
 ****************************************************************************************/

Pif.prototype.drawFilterJob = function() {
    pif = this;
    // si on veut afficher le filtre métier
    if (parseInt(pif.jobs_existing)) {
        var jobs_area = d3.select('#filters_container_' + pif.id)
        .append('div')
        .attr('class', 'jobs_area filter_block')
        .attr('id', 'jobs_area_' + pif.id);

        jobs_area.append('h4').attr('class', 'title_filter_block job_area_title').text('Métiers');

        jobs_area.append('div')
        .attr('class', 'oni-ico-information info_icon_jobs')
        .attr('pif', pif.id)
        .on('click', function() {
            var pifId = $(this).attr('pif'),
            overlay = d3.select('#overlay_' + $(this).attr('pif')).style('display', 'inline'),
            overlay_content = d3.select('#overlay_content_' + $(this).attr('pif')).style('display', 'inline'),
            tooltip_info_jobs = overlay_content.append('span').append('div').attr('class', 'info_tooltip');

            tooltip_info_jobs.append('h2').attr('class', 'info_tooltip_title').text('Métiers');
            tooltip_info_jobs.append('div').text('Ce filtre montre les formations qui permettent d\'accéder au métier sélectionné. Chaque formation affichée permet d\'exercer ce métier.');
            tooltip_info_jobs.append('div')
            .attr('class', 'oni-ico-croix_cercle info_cross')
            .on('click', function() {
                overlay.style('display', 'none');
                d3.select('#overlay_content_' + pifId + ' > span').remove();
                overlay_content.style('display', 'none');
            })
        });

        var jobFilterCross = jobs_area
        .append('div')
        .attr('id', 'job_cross_' + pif.id)
        .attr('class', 'oni-ico-croix filter_cross')
        .attr('pif', pif.id)
        .on('click', function() {
            allPif[$(this).attr('pif')].allYearsHidden(false);
            if (allPif[$(this).attr('pif')].jobs) {
                $('#title_jobs_base_' + $(this).attr('pif')).text('Métiers');
                $('.default_jobs_list_label_' + $(this).attr('pif') + '.active').removeClass('active');
                $('.default_jobs_list_checkbox_' + $(this).attr('pif') + '.active').removeClass('active').prop('checked', false);
                $('#checkbox_list_job_on_' + $(this).attr('pif')).css('visibility', 'hidden');
                $('#default_jobs_arrow_' + $(this).attr('pif')).css('transform', 'rotate(0deg)');
            } else {
                $('#ss_domaines_list_' + $(this).attr('pif')).css('visibility', 'hidden');
                titleSsDomaine.text('Sous-domaines');
                $('#jobs_list_' + $(this).attr('pif')).css('visibility', 'hidden');
                titleJobs.text('Métiers');
                $('#title_domaine_list_' + $(this).attr('pif')).text('Domaines');
                $('#domaines_list_on_' + $(this).attr('pif')).css('visibility', 'hidden');

                $('#error_jobs_' + $(this).attr('pif')).remove();
                $('#error_ss_domaines_' + $(this).attr('pif')).remove();
            }
            $(this).css('display', 'none');
        });

        if (pif.jobs) {
            var jobFilter = jobs_area.append('div')
            .attr('id', 'job_filter_select_' + pif.id)
            .attr('class', 'list_filter');

            var listBase = jobFilter
            .append('div')
            .attr('id', 'checkbox_list_job_' + pif.id)
            .attr('class', 'checkbox_list_base')
            .attr('pif', pif.id)
            .on('click', function() {
                if ('hidden' == list.style('visibility')) {
                    $('#checkbox_list_job_on_' + $(this).attr('pif')).css('bottom', '');
                    $('.checkbox_list_on').css('visibility', 'hidden');
                    $('.list_arrow').css('transform', 'rotate(0deg)');
                    list.style('visibility','visible').style('overflow-y', 'auto');
                    arrowIcon.style('transform','rotate(180deg)');

                    //affiche la liste pour mobile
                    if (480 >= $(window).width() && 'full' == view_type) {
                        $('#overlay_' + $(this).attr('pif')).css('display', 'inline');
                        $('#overlay_content_' + $(this).attr('pif')).empty().css('display', 'inline');

                        $('#checkbox_list_job_on_' + $(this).attr('pif'))
                        .detach()
                        .appendTo('#overlay_content_' + $(this).attr('pif'))
                        .css('left', ($('#pif_' + $(this).attr('pif') + '_container').width() - $('#checkbox_list_job_on_' + $(this).attr('pif')).outerWidth(true)) / 2)
                        .css('top', ($('#pif_' + $(this).attr('pif') + '_container').height() - $('#checkbox_list_job_on_' + $(this).attr('pif')).outerHeight(true)) / 3);
                    }
                } else {
                    list.style('visibility','hidden')
                    .style('overflow-y', 'hidden'); // permet d'éviter un bug sur chrome, qui affiche la scrollbar même si la liste est cachée
                    arrowIcon.style('transform','rotate(0deg)');
                }
            });

            listBase.append('div')
            .attr('id', 'title_jobs_base_' + pif.id)
            .attr('class', 'list_title')
            .text('Métiers');

            var arrowIcon = listBase.append('div')
            .attr('class','list_arrow')
            .attr('id', 'default_jobs_arrow_' + pif.id);

            var list = jobFilter
                .append('div')
                .attr('id', 'checkbox_list_job_on_' + pif.id)
                .attr('class', 'checkbox_list_on');

            var listSelected = d3.select('#checkbox_list_job_on_' + pif.id);

            for(var i = 0; i < pif.jobs.length; i++) {
                var listElement = listSelected.append('div')
                .attr('class', 'list_element');

                listElement.append('label')
                .attr('for', 'job_' + i + '_' + pif.id)
                .attr('class', 'list_label default_jobs_list_label_' + pif.id)
                .attr('id', 'label_job_' + i + '_' + pif.id)
                .text(pif.jobs[i].name);

                listElement.append('input')
                .attr('type', 'radio')
                .attr('class', 'list_checkbox list_checkbox_' + pif.id + ' default_jobs_list_checkbox_' + pif.id)
                .attr('pif', pif.id)
                .attr('name', 'radio_' + pif.id)
                .attr('id', 'job_' + i + '_' + pif.id)
                .attr('value', i)
                .on('click', function() {
                    if ($(this).hasClass('active')) {
                        allPif[$(this).attr('pif')].allYearsHidden(false);
                        $(this).removeClass('active');
                        $(this).prop('checked', false);
                        $('#label_job_' + $(this).attr('value') + '_' + $(this).attr('pif')).removeClass('active');

                        //s'il n'y a plus de radio coché
                        if (!$('.default_jobs_list_checkobx_' + $(this).attr('pif') + '.active').length) {
                            jobFilterCross.style('display', 'none');
                        }
                    } else {
                        $('.default_jobs_list_label').removeClass('active');
                        $('.default_jobs_list_checkbox_' + pif.id).removeClass('active');
                        allPif[$(this).attr('pif')].hideAllBut(allPif[$(this).attr('pif')].jobs[$(this).attr('value')].id);
                        $('#label_job_' + $(this).attr('value') + '_' + $(this).attr('pif')).addClass('active');
                        $(this).addClass('active');
                        $('#title_jobs_base_' + $(this).attr('pif')).text($('#label_job_' + $(this).attr('value') + '_' + $(this).attr('pif')).text());

                        jobFilterCross.style('display', 'block');
                    }
                    $('.education_type_list_checkbox_' + $(this).attr('pif')).prop('checked', false);
                    $('#education_cross_' + $(this).attr('pif')).css('display', 'none');
                    allPif[$(this).attr('pif')].filteredEducationsArray.length = 0;
                });
            }

            listSelected.append('div')
            .attr('id', 'ok_button_' + pif.id )
            .attr('class', 'ok_button')
            .attr('pif', pif.id)
            .text('OK')
            .on('click', function() {
                $('#checkbox_list_job_on_' + $(this).attr('pif')).css('visibility', 'hidden')
                .css('overflow-y', 'hidden')
                .css('top', '')
                .css('left', '')
                .detach()
                .appendTo('#job_filter_select_' + $(this).attr('pif'));

                $('#overlay_' + $(this).attr('pif')).css('display', 'none');
                $('#overlay_content_' + $(this).attr('pif')).empty().css('display', 'none');
                arrowIcon.style('transform','rotate(0deg)');
            });
        } else {
            jobs_area
            .append('div')
            .attr('id', 'loading_' + pif.id)
            .attr('class', 'oni-ico-pif loading');

            var domainesFilter = jobs_area
            .append('div')
            .attr('id', 'domaines_filter_select_' + pif.id)
            .attr('class', 'list_filter_job');

            var domainesListBase = domainesFilter
                .append('div')
                .attr('id', 'domaines_list_' + pif.id)
                .attr('class', 'checkbox_list_base')
                .attr('pif', pif.id)
                .style('visibility', 'hidden')
                .on('click', function() {
                    if ('hidden' == domainesList.style('visibility')) {
                        $('#domaines_list_on_' + $(this).attr('pif')).css('bottom', '');
                        $('.checkbox_list_on').css('visibility', 'hidden');
                        $('.list_arrow').css('transform', 'rotate(0deg)');
                        domainesList.style('visibility','visible').style('overflow-y', 'auto');
                        arrowIconDomaines.style('transform','rotate(180deg)');

                        //affiche la liste pour mobile
                        if (480 >= $(window).width() /*&& 'full' == view_type*/) {
                            $('#overlay_' + $(this).attr('pif')).css('display', 'inline');
                            $('#overlay_content_' + $(this).attr('pif')).empty().css('display', 'inline');

                            $('#domaines_list_on_' + $(this).attr('pif'))
                            .detach()
                            .appendTo('#overlay_content_' + $(this).attr('pif'))
                            .css('left', ($('#pif_' + $(this).attr('pif') + '_container').width() - $('#domaines_list_on_' + $(this).attr('pif')).outerWidth(true)) / 2)
                            .css('top', ($('#pif_' + $(this).attr('pif') + '_container').height() - $('#domaines_list_on_' + $(this).attr('pif')).outerHeight(true)) / 3);
                        }
                    } else {
                        domainesList.style('visibility','hidden')
                        .style('overflow-y', 'hidden'); // permet d'éviter un bug sur chrome, qui affiche la scrollbar même si la liste est cachée
                        arrowIconDomaines.style('transform','rotate(0deg)');
                    }
                });

            var titleDomaine = domainesListBase.append('div')
                .attr('id', 'title_domaine_list_' + pif.id)
                .attr('class', 'list_title')
                .text('Domaines');

            var domaines_list_middle = parseInt($('#domaines_list_' + pif.id).css('height'))/2;

            $('#title_domaine_list_' + pif.id).css('margin-top',  domaines_list_middle - parseInt($('#title_domaine_list_' + pif.id).css('height'))/2);

            var arrowIconDomaines = domainesListBase.append('div')
            .attr('class', 'list_arrow')
            .attr('id', 'domaines_list_arrow_' + pif.id);

            var domainesList = domainesFilter
                .append('div')
                .attr('id', 'domaines_list_on_' + pif.id)
                .attr('class', 'checkbox_list_on');

            var ssDomainesFilter = jobs_area
            .append('div')
            .attr('id', 'ss_domaines_filter_select_' + pif.id)
            .attr('class', 'list_filter_job');

            var listSsDomainesBase = ssDomainesFilter.append('div')
            .attr('id', 'ss_domaines_list_' + pif.id)
            .attr('class', 'checkbox_list_base')
            .attr('pif', pif.id)
            .style('visibility', 'hidden')
            .on('click', function() {
                if ('hidden' == listSsDomaines.style('visibility')) {
                    $('#ss_domaines_list_on_' + $(this).attr('pif')).css('bottom', '');
                    $('.checkbox_list_on').css('visibility', 'hidden');
                    $('.list_arrow').css('transform', 'rotate(0deg)');
                    listSsDomaines.style('visibility','visible').style('overflow-y', 'auto');
                    arrowIconSsDomaines.style('transform','rotate(180deg)');

                    //affiche la liste pour mobile
                    if (480 >= $(window).width() /* && 'full' == view_type*/) {
                        $('#overlay_' + $(this).attr('pif')).css('display', 'inline');
                        $('#overlay_content_' + $(this).attr('pif')).empty().css('display', 'inline');

                        $('#ss_domaines_list_on_' + $(this).attr('pif'))
                        .detach()
                        .appendTo('#overlay_content_' + $(this).attr('pif'))
                        .css('left', ($('#pif_' + $(this).attr('pif') + '_container').width() - $('#ss_domaines_list_on_' + $(this).attr('pif')).outerWidth(true)) / 2)
                        .css('top', ($('#pif_' + $(this).attr('pif') + '_container').height() - $('#ss_domaines_list_on_' + $(this).attr('pif')).outerHeight(true)) / 3);
                    }
                } else {
                    listSsDomaines.style('visibility','hidden')
                    .style('overflow-y', 'hidden'); // permet d'éviter un bug sur chrome, qui affiche la scrollbar même si la liste est cachée
                    arrowIconSsDomaines.style('transform','rotate(0deg)');
                }
            });

            var titleSsDomaine = listSsDomainesBase.append('div')
            .attr('id', 'title_ss_domaine_list_' + pif.id)
            .attr('class', 'list_title')
            .text('Sous-Domaines');

            var ss_domaines_list_middle = parseInt($('#ss_domaines_list_' + pif.id).css('height'))/2;

            $('#title_ss_domaine_list_' + pif.id).css('margin-top',  ss_domaines_list_middle - parseInt($('#title_ss_domaine_list_' + pif.id).css('height'))/2);


            var arrowIconSsDomaines = listSsDomainesBase.append('div')
            .attr('class', 'list_arrow')
            .attr('id', 'arrow_ss_domaines_list_' + pif.id);

            var listSsDomaines = ssDomainesFilter
                .append('div')
                .attr('id', 'ss_domaines_list_on_' + pif.id)
                .attr('class', 'checkbox_list_on');

            var jobsFilter = jobs_area
                .append('div')
                .attr('id', 'jobs_filter_select_' + pif.id)
                .attr('class', 'list_filter_job');

            var listJobsBase = jobsFilter
                .append('div')
                .attr('id', 'jobs_list_' + pif.id)
                .attr('class', 'checkbox_list_base')
                .attr('pif', pif.id)
                .style('visibility', 'hidden')
                .on('click', function() {
                    if ('hidden' == listJobs.style('visibility')) {
                        $('#jobs_list_on_' + $(this).attr('pif')).css('bottom', '');
                        $('.checkbox_list_on').css('visibility', 'hidden');
                        $('.list_arrow').css('transform', 'rotate(0deg)');
                        listJobs.style('visibility','visible').style('overflow-y', 'auto');
                        arrowIconJobs.style('transform','rotate(180deg)');

                        //affiche la liste pour mobile
                        if (480 >= $(window).width() /* && 'full' == view_type*/) {
                            $('#overlay_' + $(this).attr('pif')).css('display', 'inline');
                            $('#overlay_content_' + $(this).attr('pif')).empty().css('display', 'inline');

                            $('#jobs_list_on_' + $(this).attr('pif'))
                            .detach()
                            .appendTo('#overlay_content_' + $(this).attr('pif'))
                            .css('left', ($('#pif_' + $(this).attr('pif') + '_container').width() - $('#jobs_list_on_' + $(this).attr('pif')).outerWidth(true)) / 2)
                            .css('top', ($('#pif_' + $(this).attr('pif') + '_container').height() - $('#jobs_list_on_' + $(this).attr('pif')).outerHeight(true)) / 3);
                        }
                    } else {
                        listJobs.style('visibility','hidden')
                        .style('overflow-y', 'hidden'); // permet d'éviter un bug sur chrome, qui affiche la scrollbar même si la liste est cachée
                        arrowIconJobs.style('transform','rotate(0deg)');
                    }
                });

            var titleJobs = listJobsBase.append('div')
                .attr('id', 'title_jobs_list_' + pif.id)
                .attr('class', 'list_title')
                .text('Métiers');

            var jobs_list_middle = parseInt($('#jobs_list_' + pif.id).css('height'))/2;

            $('#title_jobs_list_' + pif.id).css('margin-top',  jobs_list_middle - parseInt($('#title_jobs_list_' + pif.id).css('height'))/2);


            var arrowIconJobs = listJobsBase.append('div')
                .attr('class', 'list_arrow')
                .attr('id', 'jobs_list_arrow_' + pif.id);

            var listJobs = jobsFilter
                .append('div')
                .attr('id', 'jobs_list_on_' + pif.id)
                .attr('class', 'checkbox_list_on');


            $.ajax({url: '/onisep-pif/domains-json/pif_id=' + pif.id, type: 'GET', dataType: 'json',
                success: function(data) {
                    if ('success' == data.response) {
                        var educationsIdsTotal = data.educationsIds;
                        var educationsType = data.educationsType;
                        $('#domaines_list_' + data.pif_id).css('visibility', 'visible');
                        var listDomaineSelected = d3.select('#domaines_list_on_' + data.pif_id);

                        listDomaineSelected.append('div')
                        .attr('class', 'list_element_job')
                        .attr('id', 'domaine_-1_pif_' + data.pif_id)
                        .on('click', function() {
                            $('#ss_domaines_list_' + data.pif_id).css('visibility', 'hidden');
                            titleSsDomaine.text('Sous-domaines');
                            $('#jobs_list_' + data.pif_id).css('visibility', 'hidden');
                            titleJobs.text('Métiers');
                            d3.selectAll('.notVisible').classed('notVisible', false);

                            $('#title_domaine_list_' + data.pif_id).text('Domaines');
                            $('#domaines_list_on_' + data.pif_id).css('visibility', 'hidden');
                            arrowIconDomaines.style('transform','rotate(0deg)');
                        })
                        .append('label')
                        .attr('class', 'list_label_job')
                        .text('Domaines');

                        for(var i = 0; i < data.domaines.length; i++) {
                            var list_domaine = listDomaineSelected.append('div')
                            .attr('class', 'list_element_job')
                            .attr('id', 'domaine_' + data.domaines[i]['id'] + '_pif_' + data.pif_id)
                            .attr('domaine', data.domaines[i]['id'])
                            .attr('pif', data.pif_id)
                            .on('click', function() {
                                if (480 >= $(window).width() /*&& 'full' == view_type*/) {
                                    $('#domaines_list_on_' + data.pif_id).css('visibility', 'hidden')
                                    .css('overflow-y', 'hidden')
                                    .css('top', '')
                                    .css('left', '')
                                    .detach()
                                    .appendTo('#domaines_filter_select_' + data.pif_id);

                                    $('#overlay_' + data.pif_id).css('display', 'none');
                                    $('#overlay_content_' + data.pif_id).empty().css('display', 'none');
                                    arrowIconDomaines.style('transform','rotate(0deg)');
                                }

                                var domaine_selected = $(this);
                                $('#error_jobs_' + $(this).attr('pif')).remove();
                                $('#error_ss_domaines_' + $(this).attr('pif')).remove();
                                $('#ss_domaines_list_' + data.pif_id).css('visibility', 'hidden');
                                titleSsDomaine.text('Sous-domaines');
                                $('#jobs_list_' + data.pif_id).css('visibility', 'hidden');
                                titleJobs.text('Métiers');

                                $('#title_domaine_list_' + data.pif_id).text(domaine_selected.text());
                                $('#domaines_list_on_' + data.pif_id).css('visibility', 'hidden')
                                .css('overflow-y', 'hidden'); // permet d'empêcher un bug sur chrome qui affiche tout le temps la scrollbar
                                arrowIconDomaines.style('transform','rotate(0deg)');

                                $.ajax({url: '/onisep-pif/sub-domains-json/pif_id/' + pif.id + '/domain_id/' + domaine_selected.attr('domaine') , type: 'GET', dataType: 'json',
                                    success: function(data) {
                                        if ('success' == data.response) {
                                            if (null != data.ssDomaines) {
                                                jobFilterCross.style('display', 'block');
                                                $('#ss_domaines_list_on_' + data.pif_id).children().remove();
                                                $('#ss_domaines_list_' + data.pif_id).css('visibility', 'visible');
                                                var listSsDomainesSelected = d3.select('#ss_domaines_list_on_' + data.pif_id);

                                                for(var i = 0; i < data.ssDomaines.length; i++) {
                                                    var ss_domaines_list = listSsDomainesSelected.append('div')
                                                    .attr('class', 'list_element_job')
                                                    .attr('id', 'ss_domaine_' + data.ssDomaines[i]['id'] + '_pif_' + data.pif_id)
                                                    .attr('ssDomaine', data.ssDomaines[i]['id'])
                                                    .attr('pif', data.pif_id)
                                                    .on('click', function() {
                                                        if (480 >= $(window).width() /*&& 'full' == view_type*/) {
                                                            $('#ss_domaines_list_on_' + data.pif_id).css('visibility', 'hidden')
                                                            .css('overflow-y', 'hidden')
                                                            .css('top', '')
                                                            .css('left', '')
                                                            .detach()
                                                            .appendTo('#ss_domaines_filter_select_' + data.pif_id);

                                                            $('#overlay_' + data.pif_id).css('display', 'none');
                                                            $('#overlay_content_' + data.pif_id).empty().css('display', 'none');
                                                            arrowIconDomaines.style('transform','rotate(0deg)');
                                                        }

                                                        $('#jobs_list_' + data.pif_id).css('visibility', 'hidden');
                                                        titleJobs.text('Métiers');
                                                        var ssDomaine_selected = $(this);
                                                        $('#error_jobs_' + $(this).attr('pif')).remove();
                                                        $('#error_ss_domaines_' + $(this).attr('pif')).remove();
                                                        $('#title_ss_domaine_list_' + data.pif_id).text(ssDomaine_selected.text());
                                                        $('#ss_domaines_list_on_' + data.pif_id).css('visibility', 'hidden')
                                                        .css('overflow-y', 'hidden'); // permet d'empêcher un bug sur chrome qui affiche tout le temps la scrollbar
                                                        arrowIconSsDomaines.style('transform','rotate(0deg)');

                                                        $.ajax({url: '/onisep-pif/jobs-json/pif_id/' + pif.id + '/sous_domain_id/' + ssDomaine_selected.attr('ssdomaine'), type: 'GET', dataType: 'json',
                                                            success: function(data) {
                                                                if ('success' == data.response) {
                                                                    if (null != data.jobs) {
                                                                        $('#jobs_list_on_' + data.pif_id).children().remove();
                                                                        $('#jobs_list_' + data.pif_id).css('visibility', 'visible');
                                                                        var listJobsSelected = d3.select('#jobs_list_on_' + data.pif_id);

                                                                        for(var i = 0; i < data.jobs.length; i++) {
                                                                            var jobs_list = listJobsSelected.append('div')
                                                                            .attr('class', 'list_element_job')
                                                                            .attr('id', 'job_' + data.jobs[i]['id'] + '_pif_' + data.pif_id)
                                                                            .attr('pif', data.pif_id)
                                                                            .attr('number', i)
                                                                            .on('click', function() {
                                                                                pif.allYearsHidden(false);
                                                                                if (480 >= $(window).width() /* && 'full' == view_type */) {
                                                                                    $('#jobs_list_on_' + data.pif_id).css('visibility', 'hidden')
                                                                                    .css('overflow-y', 'hidden')
                                                                                    .css('top', '')
                                                                                    .css('left', '')
                                                                                    .detach()
                                                                                    .appendTo('#jobs_filter_select_' + data.pif_id);

                                                                                    $('#overlay_' + data.pif_id).css('display', 'none');
                                                                                    $('#overlay_content_' + data.pif_id).empty().css('display', 'none');
                                                                                    arrowIconDomaines.style('transform','rotate(0deg)');
                                                                                }

                                                                                job_selected = $(this);
                                                                                $('#title_jobs_list_' + data.pif_id).text(job_selected.text());
                                                                                $('#jobs_list_on_' + data.pif_id).css('visibility', 'hidden')
                                                                                .css('overflow-y', 'hidden'); // permet d'empêcher un bug sur chrome qui affiche tout le temps la scrollbar
                                                                                arrowIconJobs.style('transform','rotate(0deg)');
                                                                                allPif[data.pif_id].hideAllBut(data.jobs[job_selected.attr('number')]['educations']);
                                                                                $('#education_cross_' + $(this).attr('pif')).css('display', 'none');
                                                                                $('.list_checkbox_' + $(this).attr('pif')).prop('checked', false);
                                                                            });
                                                                            jobs_list.append('label')
                                                                            .attr('class', 'list_label_job')
                                                                            .text(data.jobs[i]['name']);
                                                                        }
                                                                    } else {
                                                                        $('#jobs_area_' + data.pif_id).append('<div id="error_jobs_' + data.pif_id + '" class="error_msg">Aucun métier en rapport avec les formations de ce PIF n\'a été trouvé.</div>');
                                                                    }
                                                                }
                                                            }, error: function(jqXHR, textStatus, errorThrown) {
                                                                //console.log('Erreur métier ' + jqXHR + ' ' + textStatus + ' ' + errorThrown);
                                                            }

                                                        })
                                                    });
                                                    ss_domaines_list.append('label')
                                                    .attr('class', 'list_label_job')
                                                    .text(data.ssDomaines[i]['name']);
                                                }
                                            } else {
                                                $('#jobs_area_' + data.pif_id).append('<div id="error_ss_domaines_' + data.pif_id + '" class="error_msg">Aucun sous-domaine en rapport avec les formations de ce PIF n\'a été trouvé.</div>');
                                            }
                                        }
                                    }, error: function(jqXHR, textStatus, errorThrown) {
                                        //console.log('Erreur sous-domaines ' + jqXHR + ' ' + textStatus + ' ' + errorThrown);
                                    }
                                });
                            });
                            list_domaine.append('label')
                            .attr('class', 'list_label_job')
                            .text(data.domaines[i]['name']);
                        }
                    }
                }, error: function(jqXHR, textStatus, errorThrown) {
                    //console.log('Erreur domaines ' + jqXHR + ' ' + textStatus + ' ' + errorThrown);
                }
            });
            $(document).ajaxSend(function(event, xhr, settings) {
                var requestPifId = settings.url.match(/pif_id[=|\/]([0-9]*)/);
                if (requestPifId) {
                    $('#loading_' + requestPifId[1]).show();
                }
            }).ajaxSuccess(function(event, xhr, settings){
                var requestPifId = xhr.responseText.match(/"pif_id":([0-9]*)/);
                if (requestPifId) {
                    $('#loading_' + requestPifId[1]).hide();
                }
            });

        }
    }

    $(function() {
        $(document).click(function(e) {
            var target = e.target;
            if ((480 < $(window).width() && 'full' == view_type) || 'embed' == view_type) {
                if (!$(target).is('#domaines_list_on_' + pif.id) && !$(target).is('#domaines_list_' + pif.id) && !$(target).parent().is('#domaines_list_' + pif.id) && 'visible' == $('#domaines_list_on_' + pif.id).css('visibility')) {
                    $('#domaines_list_on_' + pif.id).css('visibility', 'hidden')
                    .css('overflow-y', 'hidden'); // permet d'éviter un bug sur chrome, qui affiche la scrollbar même si la liste est cachée
                    $('#domaines_list_arrow_' + pif.id).css('transform', 'rotate(0)');
                }

                if (!$(target).is('#ss_domaines_list_on_' + pif.id) && !$(target).is('#ss_domaines_list_' + pif.id) && !$(target).parent().is('#ss_domaines_list_' + pif.id) && 'visible' == $('#ss_domaines_list_on_' + pif.id).css('visibility')) {
                    $('#ss_domaines_list_on_' + pif.id).css('visibility', 'hidden')
                    .css('overflow-y', 'hidden'); // permet d'éviter un bug sur chrome, qui affiche la scrollbar même si la liste est cachée
                    $('#arrow_ss_domaines_list_' + pif.id).css('transform', 'rotate(0)');
                }

                if (!$(target).is('#jobs_list_on_' + pif.id) && !$(target).is('#jobs_list_' + pif.id) && !$(target).parent().is('#jobs_list_' + pif.id) && 'visible' == $('#jobs_list_on_' + pif.id).css('visibility')) {
                    $('#jobs_list_on_' + pif.id).css('visibility', 'hidden')
                    .css('overflow-y', 'hidden'); // permet d'éviter un bug sur chrome, qui affiche la scrollbar même si la liste est cachée
                    $('#jobs_list_arrow_' + pif.id).css('transform', 'rotate(0)');
                }
            }
        });
    });
}


/**********************************************************************************************************************
* Création du filtre selon le type de formation
************************************************************************************************************************/

Pif.prototype.drawFilterEducationType = function() {
    pif = this;

    var typeFilter = d3.select('#filters_container_' + pif.id)
        .append('div')
        .attr('id', 'education_type_filter_select_' + pif.id)
        .attr('class', 'list_filter filter_block education_type_filter');

    var titleFilter = typeFilter
    .append('h4')
    .attr('class', 'title_filter_block')
    .text('Formation');

    var educationFilterCross = typeFilter
    .append('div')
    .attr('pif', pif.id)
    .attr('id', 'education_cross_' + pif.id)
    .attr('class', 'oni-ico-croix filter_cross')
    .on('click', function() {
        var pifId = $(this).attr('pif');
        allPif[pifId].allYearsHidden(false);
        allPif[pifId].filteredEducationsArray.length = 0;
        $('.list_checkbox_' + pifId).each(function() {
            $(this).prop('checked', false);
        });
        $(this).css('display', 'none');
    });

    var listBase = typeFilter
        .append('div')
        .attr('id', 'checkbox_list_type_' + pif.id)
        .attr('class', 'checkbox_list_base no_select_text')
        .attr('pif', pif.id)
        .on('click', function() {
            var pifId = $(this).attr('pif');

            if ('hidden' == d3.select('#checkbox_list_type_on_' + pifId).style('visibility')) {
                $('#checkbox_list_type_on_' + pifId).css('bottom', '');
                $('.list_arrow').css('transform', 'rotate(0deg)');
                $('.checkbox_list_on').css('visibility', 'hidden');
                list.style('visibility','visible').style('overflow-y', 'auto');
                arrowIcon.style('transform','rotate(180deg)');

                if (480 >= $(window).width() /*&&  'full' == view_type*/) {
                    $('#overlay_' + pifId).css('display', 'inline');
                    $('#overlay_content_' + pifId).empty().css('display', 'inline');

                    $('#checkbox_list_type_on_' + pifId).css('overflow-y', 'auto')
                    .detach()
                    .appendTo('#overlay_content_' + pifId)
                    .css('left', ($('#pif_' + pifId + '_container').width() - $('#checkbox_list_type_on_' + pifId).outerWidth(true)) / 2)
                    .css('top', ($('#pif_' + pifId + '_container').height() - $('#checkbox_list_type_on_' + pifId).outerHeight(true)) / 3);
                }
            } else {
                list.style('visibility','hidden')
                .style('overflow-y', 'hidden'); // permet d'éviter un bug sur chrome, qui affiche la scrollbar même si la liste est cachée
                arrowIcon.style('transform','rotate(0deg)');
            }
        });

    var titleBase = listBase.append('div')
        .attr('id', 'title_educations_type_base_' + pif.id)
        .attr('class', 'list_title')
        .text('Types de formation');

    var list_edu_types_middle = parseInt($('#checkbox_list_type_' + pif.id).css('height'))/2;

    $('#title_educations_type_base_' + pif.id).css('margin-top', list_edu_types_middle - parseInt($('#title_educations_type_base_' + pif.id).css('height'))/2);

    var arrowIcon = listBase.append('div')
        .attr('class','list_arrow')
        .attr('id', 'arrow_educations_type_' + pif.id);

    var list = typeFilter
        .append('div')
        .attr('id', 'checkbox_list_type_on_' + pif.id)
        .attr('class', 'checkbox_list_on');

    var listSelected = d3.select('#checkbox_list_type_on_' + pif.id);

    var divList = listSelected.append('div')
    .attr('class', 'list_element');

    divList.append('label')
    .attr('for', 'select_all_types_' + pif.id)
    .attr('class', 'list_label')
    .text('Tout');

    divList.append('input')
    .attr('type', 'checkbox')
    .attr('id', 'select_all_types_' + pif.id)
    .attr('class', 'list_checkbox list_checkbox_' + pif.id + ' education_type_list_checkbox_' + pif.id)
    .attr('pif', pif.id)
    .attr('name', 'select_all_types_' + pif.id)
    .attr('value', -1)
    .on('click', function() {
        var pifId = $(this).attr('pif');
        hideByEducationSelection(pifId, $(this).prop('checked'), $(this)[0].value);
        if (allPif[pifId].jobs) {
            $('.default_jobs_list_checkbox_' + pifId).prop('checked', false);
            $('.default_jobs_list_checkbox_' + pifId + '.active').removeClass('active');
            $('.default_jobs_list_label_' + pifId + '.active').removeClass('active');
            $('#title_jobs_base_' + pifId).text('Métiers');
            $('#job_cross_' + pifId).css('display', 'none');
        }
    });

    var educationTypeArray = new Array();
    var filteredEducationsArray = new Array();
    var count = 0;
    for(var i in pif.educationsObj) {
        count = 0;
        for(var j in pif.educationsObj[i]['education_type']) {
            count++;
            // s'il y a plus d'un type de formation pour une seule formation on incrémente le nom du checkbox
            if (1 < count) {
                if (-1 == educationTypeArray.indexOf(j)) {
                    educationTypeArray.push(j);
                    var divList = listSelected.append('div')
                    .attr('class', 'list_element');

                    divList.append('label')
                    .attr('for', i + '_' + count)
                    .attr('class', 'list_label')
                    .text(function() {
                        if (pif.educationsObj[i]['education_type'][j]['short_name']) {
                            return pif.educationsObj[i]['education_type'][j]['short_name'];
                        }
                        return pif.educationsObj[i]['education_type'][j]['name'];
                    });

                    divList.append('input')
                    .attr('type', 'checkbox')
                    .attr('class', 'list_checkbox list_checkbox_' + pif.id + ' education_type_list_checkbox_' + pif.id)
                    .attr('pif', pif.id)
                    .attr('id', i + '_' + count)
                    .attr('value', i)
                    .on('click', function() {
                        var pifId = $(this).attr('pif');
                        hideByEducationSelection(pifId, $(this).prop('checked'), $(this)[0].value);
                        if (allPif[pifId].jobs) {
                            $('.default_jobs_list_checkbox_' + pifId).prop('checked', false);
                            $('.default_jobs_list_checkbox_' + pifId + '.active').removeClass('active');
                            $('.default_jobs_list_label_' + pifId + '.active').removeClass('active');
                            $('#title_jobs_base_' + pifId).text('Métiers');
                            $('#job_cross_' + pifId).css('display', 'none');
                        }
                    });
                }
            } else {
                if (-1 == educationTypeArray.indexOf(j)) {
                    educationTypeArray.push(j);
                    var divList = listSelected.append('div')
                    .attr('class', 'list_element');

                    divList.append('label')
                    .attr('for', i)
                    .attr('class', 'list_label')
                    .text(function() {
                        if (pif.educationsObj[i]['education_type'][j]['short_name']) {
                            return pif.educationsObj[i]['education_type'][j]['short_name'];
                        }
                        return pif.educationsObj[i]['education_type'][j]['name'];
                    });

                    divList.append('input')
                    .attr('type', 'checkbox')
                    .attr('class', 'list_checkbox list_checkbox_' + pif.id + ' education_type_list_checkbox_' + pif.id)
                    .attr('pif', pif.id)
                    .attr('id', i)
                    .attr('value', i)
                    .on('click', function() {
                        var pifId = $(this).attr('pif');
                        hideByEducationSelection(pifId, $(this).prop('checked'), $(this)[0].value);
                        if (allPif[pifId].jobs) {
                            $('.default_jobs_list_checkbox_' + pifId).prop('checked', false);
                            $('.default_jobs_list_checkbox_' + pifId + '.active').removeClass('active');
                            $('.default_jobs_list_label_' + pifId + '.active').removeClass('active');
                            $('#title_jobs_base_' + pifId).text('Métiers');
                            $('#job_cross_' + pifId).css('display', 'none');
                        }
                    });
                }
            }
        }
    }
    listSelected.append('div')
    .attr('id', 'ok_button_' + pif.id )
    .attr('class', 'ok_button')
    .attr('pif', pif.id)
    .text('OK')
    .on('click', function() {
        var pifId = $(this).attr('pif');
        $('#checkbox_list_type_on_' + pifId).css('visibility', 'hidden')
        .css('overflow-y', 'hidden')
        .css('top', '')
        .css('left', '')
        .detach()
        .appendTo('#education_type_filter_select_' + pifId);

        $('#overlay_' + pifId).css('display', 'none');
        $('#overlay_content_' + pifId).empty().css('display', 'none');
        arrowIcon.style('transform','rotate(0deg)');
    });
}


/**************************************************************************************************
 * Cache/montre les formations selon les checkbox cochées du filtre par type de formation
 **************************************************************************************************/

function hideByEducationSelection(pifId, checked, value) {
    //on enlève la box de description de l'année
    if ($('#information_ref_' + pifId).length) {
        $('#information_ref_' + pifId).remove();
        $('#information_pif_' + pifId).css('visibility', 'hidden').removeClass('active');
        $('#education_information_pif_' + pifId).css('display', 'none');
    }

    // si 'tout' est cochée, on coche tous les checkbox et on passe l'opacité de toutes les années à 1
    if (-1 == parseInt(value)) {
        $('.list_checkbox_' + pifId + '.education_type_list_checkbox_' + pifId).prop('checked', checked);
        allPif[pifId].allYearsHidden(false);
    } else { // sinon on passe l'opacité de toutes les années à 0.2
        allPif[pifId].allYearsHidden(true);
    }

    //si on coche la formation, et que ce n'est pas la checkbox "tout", on l'ajoute au tableau
    if ((-1 != parseInt(value)) && (checked)) {
        allPif[pifId].filteredEducationsArray.push(value);
    }
    //si on décoche la formation, et que ce n'est pas la checkbox "tout", on l'enlève du tableau
    if ((-1 != parseInt(value)) && (!checked)) {
        var index = allPif[pifId].filteredEducationsArray.indexOf(value);
        allPif[pifId].filteredEducationsArray.splice(index,1);
    }

    //si on coche la checkbox "tout" on remplit le tableau avec toutes les valeurs des checkbox
    if ((-1 == parseInt(value))) {
        allPif[pifId].filteredEducationsArray.length = 0;
        if ($('#select_all_types_' + pifId).prop('checked')) {
            $('.list_checkbox_' + pifId + '.education_type_list_checkbox_' + pifId).each(function() {
                if (-1 != parseInt($(this).attr('value'))) {
                    allPif[pifId].filteredEducationsArray.push($(this).attr('value'));
                }
            })
        }
    }
    allPif[pifId].selectedEducation = 0;
    // à chaque fois qu'il y a un changement on met l'opacité à 1 des formations qui sont dans le tableau
    if (0 < allPif[pifId].filteredEducationsArray.length) { // s'il y a au moins une case de cochée, on change l'opacité
        for(var i = 0; i < allPif[pifId].filteredEducationsArray.length; i++) {
            d3.selectAll('.education_' + allPif[pifId].filteredEducationsArray[i]).classed('notVisible', false);
            if (-1 != d3.select('.education_' + allPif[pifId].filteredEducationsArray[i]).attr('class').indexOf('current_opacity')) {
                allPif[pifId].selectedEducation++;
            }
        }
        //s'il n'y a aucune formation de sélectionnée parmis celle du filtre, on enlève toutes les classe 'current_opacity'
        if (0 == allPif[pifId].selectedEducation) {
            d3.selectAll('.current_opacity').classed('current_opacity', false);
            $('.current_opacity #pif_' + $(this).attr('id')).removeClass('current_opacity');
        }
        d3.selectAll('.year_title.notVisible').style('cursor','default');
        $('#education_cross_' + pifId).css('display', 'block');
    } else { // sinon on remet l'opacité de toutes les années à 1
        allPif[pifId].allYearsHidden(false);
        $('#education_cross_' + pifId).css('display', 'none');
    }
}


/**********************************************************************************************************************
* Renvoie la taille d'un tableau associatif
************************************************************************************************************************/

Object.size = function(obj) {
    var size = 0;
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            size++;
        }
    }
    return size;
};


/**********************************************************************************************************************
* Change l'opacité de tous les blocs du PIF
************************************************************************************************************************/

Pif.prototype.allYearsHidden = function(state){
    var pif = this;
    d3.selectAll('.pif_' + pif.id + '.rect_year').classed('notVisible', state);
    d3.selectAll('#rect_title_diploma_' + pif.id + '.rect_title_diploma').classed('notVisible', state);
    d3.selectAll('.year_title_' + pif.id + '.year_title').classed('notVisible', state);
    d3.selectAll('.pif_' + pif.id + '.gateway_line').classed('notVisible', state);
    d3.selectAll('.year_with_previous_selectivity_' + pif.id + '.year_with_previous_selectivity').classed('notVisible', state);
    d3.selectAll('.year_without_previous_selectivity_' + pif.id + '.year_without_previous_selectivity').classed('notVisible', state);
    if (pif.design == 0) {
        d3.selectAll('.between_lines_' + pif.id + '.between_lines').classed('notVisible', state);
        d3.selectAll('.pif_' + pif.id + '.rect_title_diploma').classed('notVisible', state);
    }
}


/***********************************************************************************
 * Dessine le PIF avec le design zoom
 **********************************************************************************/
//TODO: factorize with draw_pif
Pif.prototype.draw_pif_zoom = function() {
    var pif = this;
    var dataset = pif.create_lines_pif();
    zoom[pif.id] = d3.behavior.zoom().on('zoom', zoomed);

    var container = d3.select('#pif_' + pif.id + '_container');

    // Propriétés du PIF
    var pif_width = $('#pif_' + pif.id + '_container').outerWidth();
    var pif_height = $('#pif_' + pif.id + '_container').outerHeight();

    var final_group = container.append('div')
            .attr('class', function () {
                if (pif.top != '') {
                    return 'final_group';
                } else {
                    return 'void_year';
                }
            });

    var rect_final_pif = final_group.append('div').attr('class', 'rect_final_pif');

    var text_final_pif = rect_final_pif.append('div')
            .attr('id', 'text_final_pif')
            .attr('x', (pif.get_width_max(dataset) - rect_padding_zoom) / 2 - pif.base.length * 3.5 )
            .attr('y', 15)
            .attr('font-size', 15)
            .text(pif.top);

    /**********************************************************************************************************************
    * On ajoute des caractéristiques à la div qui va wrap le svg principal pour gérer l'affichage d'une infobulle
    ************************************************************************************************************************/
    var svg_principal_area = d3.select('#svg_principal_area_' + pif.id);
    d3.select('#title_pif_' + pif.id).text(pif.name);

    /************************************************************************************************************************
    * Création du groupe d'ordre qui va contenir les rectangles et les textes qui contiennent les ordres des années par ligne
    ***********************************************************************************************************************/

    var hide_base_pif = 0;

    var svg = svg_principal_area.append('svg')
                                .attr('class', 'svg_area')
                                .attr('id', 'svg_area_' + pif.id)
                                .attr('pif', pif.id)
                                .attr('width', pif_width - 10)
                                .attr('height', '100%')
                                .call(zoom[pif.id])
                                .on("mousewheel.zoom", null)
                                .on("DOMMouseScroll.zoom", null)
                                .on("wheel.zoom", null)
                                .append('g')
                                .attr("id", 'pif_' + pif.id + '_area')
                                .attr('class', 'pif_area')
                                .attr('pif', pif.id);

    /******************************************************************************************************************
    * Création des années du pif en elles memes
    ******************************************************************************************************************/

    /* Création du groupe qui va accueillir toutes les années */

    var pif_years_group = svg.append('g')
                            .attr('id', 'pif_years_group_id' + pif.id)
                            .attr('class', function() {
                                if (pif.get_width_max(dataset) * 2 < $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                                    return 'pif_years_group_' + pif.id + ' double_column';
                                } else {
                                     return 'pif_years_group_' + pif.id;
                                }
                            });

    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
        $('#pif_' + pif.id + '_container').height(pif.get_height_max_zoom(dataset, 1) + 145 + 'px');
    } else {
        $('#pif_' + pif.id + '_container').height(pif.get_height_max_zoom(dataset, 0) + 145 + 'px');
    }

    /* Création d'un groupe pour chaque ligne du pif */

    var line_years = pif_years_group.selectAll('g')
            .data(dataset)
            .enter()
            .append('g')
            .attr('class', 'line_year' + pif.id)
            .attr('transform', function (year_id_list, i) {
                //permet de ne pas avoir de lignes avec une abscisse negative
                return 'translate(' + (dataset.length - i) * 25 + ',' + i * (h_rect_zoom + row_padding_zoom) + ')';
            });

    var line_under = line_years.append('line')
            .attr('x1', function(year_id_list) {

                var widthYearTot = 0;
                for(var i = 0; i < year_id_list.length; i++) {
                    widthYearTot += pif.year_width(pif.years[year_id_list[i]])*(w_rect_zoom + rect_padding_zoom);
                }
                return - rect_padding_zoom;
            })
            .attr('class', 'line_under')
            .attr('y1', h_rect_zoom - 1)
            .attr('x2', function(year_id_list) {

                var widthYearTot = 0;
                for(var i = 0; i < year_id_list.length; i++) {
                    widthYearTot += pif.year_width(pif.years[year_id_list[i]])*(w_rect_zoom + rect_padding_zoom);
                }
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return widthYearTot * 2 - rect_padding_zoom;
                }
                return widthYearTot;
            })
            .attr('y2', h_rect_zoom - 1)
            .attr('stroke-width', 1)
            .attr('stroke', 'black')
            .attr('transform', 'skewY(4)');

    /* Création d'une infobulle pour afficher le chapo */
    var tooltip = svg_principal_area
            .append('div')
            .attr('id', 'tooltip_' + pif.id)
            .attr('class', 'tooltip');
    var tooltipL = svg_principal_area
            .append('div')
            .attr('id', 'tooltipL_' + pif.id)
            .attr('class', 'tooltipL');

    //var height_pif_title = $('#title_pif_' + pif.id).height();

    /* Création d'un groupe pour chaque année */
    var year_cell = line_years.selectAll('g')
            .data(function(year_id_list) {return year_id_list;})
            .enter()
            .append('g')
            .attr('class',  function(year_id, i) {
                if (pif.years[year_id].real) {
                    return 'pif_' + pif.id + 'year' + year_id;
                } else {
                    return 'void_year';
                }
            })
            .attr('pif', pif.id)
            .attr('transform',function (year_id, i) {
                var years_array = this.parentNode.__data__;
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    var x = pif.get_x(years_array)[i] * 2;
                } else {
                    var x = pif.get_x(years_array)[i];
                }
                return 'translate(' + x + ',' + (x * 0.07).toFixed(1) + ')';
            })
            .attr('absciss', function(year_id, i) {
                var years_array = this.parentNode.__data__;
                var x = pif.get_x(years_array)[i];
                return x;
            })
            .attr('cell_width', function(year_id) {
                return w_rect_zoom * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom;
            })
            .style('cursor', function(year_id) {
                if (pif.get_education(year_id)) {
                    if (pif.educationsObj[pif.get_education(year_id)].target == 'Formations' && pif.educationsObj[pif.get_education(year_id)].target != 'Inactif') {
                        if (pif.educationsObj[pif.get_education(year_id)].description != '') {
                            return 'pointer';
                        } else {
                            return 'default';
                        }
                    } else if (pif.educationsObj[pif.get_education(year_id)].target == 'Années') {
                        if (pif.years[year_id].description != '') {
                            return 'pointer';
                        } else {
                            return 'default';
                        }
                    }
                } else {
                    return 'default';
                }
            })
            .on('mouseover',function(year_id) {
                var pifId = $(this).attr('pif');
                if (-1 == d3.select('.pif_' + pifId + 'rect_year_' + year_id).attr('class').indexOf('notVisible') && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    /* Si la cible de la formation est la formation, afficher le chapo de la formation dans une infobulle */
                    if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Formations') {

                        if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].chapo != '') {
                            tooltipL.html(allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].chapo);
                            tooltip.html(allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].chapo);
                            var tooltipBB = $('#tooltip_' + pifId)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pifId)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltipL
                                .style('visibility', 'visible');
                                tooltip
                                .style('visibility', 'hidden');
                            } else {
                                tooltip
                                .style('visibility', 'visible');
                                tooltipL
                                .style('visibility', 'hidden');
                            }
                        }
                        /* Cela va selectionner toutes les autres années du pif et modifier leur opacité */
                        for (var i = 0; i < allPif[pifId].get_others_years(year_id).length; i++) {
                            d3.select('.pif_' + pifId + 'rect_year_' + allPif[pifId].get_others_years(year_id)[i])
                            .attr('opacity', 0.6);
                        }

                    /* Si la cible de la formation est année, afficher le chapo de l'année dans une infobulle */
                    } else if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Années') {
                        d3.select('.pif_' + pifId + 'rect_year_' + year_id).attr('opacity', 0.6);
                        if (allPif[pifId].years[year_id].chapo != '' && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                            tooltipL.html(allPif[pifId].years[year_id].chapo);
                            tooltip.html(allPif[pifId].years[year_id].chapo);
                            var tooltipBB = $('#tooltip_' + pifId)[0].getBoundingClientRect();
                            var svgBB = $('#svg_area_' + pifId)[0].getBoundingClientRect();
                            if (svgBB.right < tooltipBB.right) {
                                tooltipL
                                .style('visibility', 'visible');
                                tooltip
                                .style('visibility', 'hidden');
                            } else {
                                tooltip
                                .style('visibility', 'visible');
                                tooltipL
                                .style('visibility', 'hidden');
                            }
                        }
                    }
                }
            })
            .on('mousemove', function(year_id) {
                var pifId = $(this).attr('pif');
                if (-1 == d3.select('.pif_' + pifId + 'rect_year_' + year_id).attr('class').indexOf('notVisible')  && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target != '') {
                        var mouse = d3.mouse($(this).closest('#svg_principal_area_' + pifId).get(0));
                        var tooltipLObj = document.getElementById("tooltipL_" + pifId);
                        var tooltipLBb = tooltipLObj.getBoundingClientRect();
                        var tooltipBB = $('#tooltip_' + pifId)[0].getBoundingClientRect();
                        var svgBB = $('#svg_area_' + pifId)[0].getBoundingClientRect();
                        if (svgBB.right < tooltipBB.right) {
                            tooltip
                            .style('visibility', 'hidden')
                            .style('left', mouse[0] + 60 + 'px')
                            .style('top', mouse[1] + 'px');
                            tooltipL
                            .style('visibility', 'visible')
                            .style('left', mouse[0] - (40 + tooltipLBb.width) + 'px')
                            .style('top', mouse[1] + 'px');
                            if (0 > $('#tooltipL_' + pifId)[0].getBoundingClientRect().left) {
                                tooltipL.style('left', '0px')
                                .style('max-width', mouse[0] + 'px')
                                .style('top', mouse[1] + 'px');
                            } else {
                                tooltipL.style('max-width', '250px');
                            }
                        } else {
                            tooltip
                            .style('visibility', 'visible')
                            .style('left', mouse[0] + 60 + 'px')
                            .style('top', mouse[1] + 'px');
                            tooltipL
                            .style('visibility', 'hidden')
                            .style('left', mouse[0] - (40 + tooltipLBb.width) + 'px')
                            .style('top', mouse[1] + 'px');
                        }
                        if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Formations' && allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].chapo == '') {
                            tooltip.style('visibility', 'hidden');
                            tooltipL.style('visibility', 'hidden');
                        }

                        if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Années' && allPif[pifId].years[year_id].chapo == '') {
                            tooltip.style('visibility', 'hidden');
                            tooltipL.style('visibility', 'hidden');
                        }
                    }

                    if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Formations' && allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].chapo == '') {
                        tooltip.style('visibility', 'hidden');
                        tooltipL.style('visibility', 'hidden');
                    }

                    if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Années' && allPif[pifId].years[year_id].chapo == '') {
                        tooltip.style('visibility', 'hidden');
                        tooltipL.style('visibility', 'hidden');
                    }
                }
            })
            .on('mouseout', function(year_id) {
                var pifId = $(this).attr('pif');
                if (-1 == d3.select('.pif_' + pifId + 'rect_year_' + year_id).attr('class').indexOf('notVisible') && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    d3.select(this).attr('opacity', 1)
                    for (var i = 0; i < allPif[pifId].get_others_years(year_id).length; i++) {
                    d3.select('.pif_' + pifId + 'rect_year_' + allPif[pifId].get_others_years(year_id)[i])
                        .attr('opacity', 1)
                    }
                    tooltip.style('visibility', 'hidden');
                    tooltipL.style('visibility', 'hidden');
                }
            })
            .on('click', function(year_id) {
                var pifId = $(this).attr('pif');
                if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Pas de clic') {
                    return false;
                }
                if (-1 == d3.select('.pif_' + pifId + 'rect_year_' + year_id).attr('class').indexOf('notVisible') && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    var mouse = d3.mouse($(this).closest('#svg_principal_area_' + pifId).get(0));
                    if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target != '') {
                        $('#information_pif_' + pifId).css('height', ''); // pour éviter que la zone d'info soit toujours de la même height

                        var tooltipBB = $('#tooltip_' + pifId)[0].getBoundingClientRect();
                        var tooltipLBB = $('#tooltipL_' + pifId)[0].getBoundingClientRect();
                        var svgBB = $('#svg_area_' + pifId)[0].getBoundingClientRect();
                        tooltipL.style('left', mouse[0] - (40 + tooltipLBB.width) + 'px');
                        if (svgBB.right < tooltipBB.right) {
                            tooltipL
                            .style('visibility', 'visible');
                            tooltip
                            .style('visibility', 'hidden');

                            if (0 > $('#tooltipL_' + pifId)[0].getBoundingClientRect().left) {
                                tooltipL.style('left', '0px')
                                .style('max-width', mouse[0] + 'px')
                                .style('top', mouse[1] + 'px');
                            } else {
                                tooltipL.style('max-width', '250px');
                            }
                        } else {
                            tooltip
                            .style('visibility', 'visible');
                            tooltipL
                            .style('visibility', 'hidden');

                        }
                        if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Formations' && allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].chapo == '') {
                            tooltip.style('visibility', 'hidden');
                            tooltipL.style('visibility', 'hidden');
                        }

                        if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Années' && allPif[pifId].years[year_id].chapo == '') {
                            tooltip.style('visibility', 'hidden');
                            tooltipL.style('visibility', 'hidden');
                        }
                    }
                }

                if (-1 == d3.select('.pif_' + pifId + 'rect_year_' + year_id).attr('class').indexOf('notVisible')) {
                    if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Années') {
                        //enlève l'opacité de l'état précédent
                        d3.selectAll('.pif_' + pifId).classed('current_opacity', false);
                        d3.select(this).classed('current_opacity', true);
                        if ($("#information_ref_" + pifId ).length) {
                            $("#information_ref_" + pifId ).remove();
                        }

                        var background_color_formation = $('.current_opacity .rect_year').attr('fill');

                        if (allPif[pifId].default_filters || allPif[pifId].educationsRelToJob) {
                            // on supprime le contenu précédent
                            $('.education_list ul').remove();
                            for(var i in allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].education_type) {
                                if (allPif[pifId].educationsRelToJob) {
                                    var list = $('.education_list_content').append('<ul></ul>').find('ul');
                                    for(var j in allPif[pifId].educationsRelToJob) {
                                        // on ne récupère que les formations qui sont en relation avec le type de formation correspondant à l'année cliquée
                                        if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].education_type[i].id == allPif[pifId].educationsRelToJob[j].type_formation) {
                                            if ('undefined' !== typeof __rootUrl) {
                                            	list.append('<a href=' + __rootUrl + allPif[pifId].educationsRelToJob[j].url + '><li class="education_list_element"> - ' + allPif[pifId].educationsRelToJob[j].libelle_complet + '</li></a>');
                                            } else {
                                                list.append('<a href=' + allPif[pifId].educationsRelToJob[j].url + '><li class="education_list_element"> - ' + allPif[pifId].educationsRelToJob[j].libelle_complet + '</li></a>');
                                            }
                                        }
                                    }
                                    // s'il n'y a pas de formation correspondante, le plier/déplier n'est pas affiché
                                    if ($('.education_list ul li').length) {
                                        $('.education_list').css('visibility', 'visible');
                                        $('#education_information_pif_' + pifId).css('display', 'block');
                                    } else {
                                        $('.education_list').css('visibility', 'hidden');
                                        $('#education_information_pif_' + pifId).css('display', 'none');
                                    }
                                }
                            }
                            allPif[pifId].display_description_box(allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].education_type[i], background_color_formation);
                        } else {
                            allPif[pifId].display_description_box(allPif[pifId].years[year_id], background_color_formation);
                        }

                        if (!$('#information_pif_' + pifId).hasClass('active')) {
                            $('#information_pif_' + pifId).addClass('active');
                            $('#information_pif_' + pifId).css('visibility', 'visible');
                        }

                    } else if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].target == 'Formations') {
                        //enlève l'opacité de l'état précédent
                        d3.selectAll('.pif_' + pifId).classed('current_opacity', false);
                        //Garde l'opacité au clic
                        for (var i = 0; i < allPif[pifId].get_others_years(year_id).length; i++) {
                            d3.select('.pif_' + pifId + 'rect_year_' + allPif[pifId].get_others_years(year_id)[i])
                            .classed('current_opacity', true);
                        }

                        if ($("#information_ref_" + pifId ).length) {
                            $("#information_ref_" + pifId ).remove();
                        }
                        var background_color_formation = $('.current_opacity').attr('fill');
                        if (allPif[pifId].default_filters || allPif[pifId].educationsRelToJob) {
                            // on supprime le contenu précédent
                            $('.education_list ul').remove();
                            for(var i in allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].education_type) {
                                if (allPif[pifId].educationsRelToJob) {
                                    var list = $('.education_list_content').append('<ul></ul>').find('ul');
                                    for(var j in allPif[pifId].educationsRelToJob) {
                                        // on ne récupère que les formations qui sont en relation avec le type de formation correspondant à l'année cliquée
                                        if (allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].education_type[i].id == allPif[pifId].educationsRelToJob[j].type_formation) {
                                            if ('undefined' !== typeof __rootUrl) {
                                                list.append('<a href=' + __rootUrl + allPif[pifId].educationsRelToJob[j].url + '><li class="education_list_element"> - ' + allPif[pifId].educationsRelToJob[j].libelle_complet + '</li></a>');
                                            } else {
                                                list.append('<a href=' + allPif[pifId].educationsRelToJob[j].url + '><li class="education_list_element"> - ' + allPif[pifId].educationsRelToJob[j].libelle_complet + '</li></a>');
                                            }
                                        }
                                    }
                                    // s'il n'y a pas de formation correspondante, le plier/déplier n'est pas affiché
                                    if ($('.education_list ul li').length) {
                                        $('.education_list').css('visibility', 'visible');
                                        $('#education_information_pif_' + pifId).css('display', 'block');
                                    } else {
                                        $('.education_list').css('visibility', 'hidden');
                                        $('#education_information_pif_' + pifId).css('display', 'none');
                                    }
                                }
                            }
                            allPif[pifId].display_description_box(allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)].education_type[i], background_color_formation);
                        } else {
                            allPif[pifId].display_description_box(allPif[pifId].educationsObj[allPif[pifId].get_education(year_id)], background_color_formation, 'formation');
                        }

                        if (!$('#information_pif_' + pifId).hasClass('active')) {
                            $('#information_pif_' + pifId).addClass('active');
                            $('#information_pif_' + pifId).css('visibility', 'visible');
                        }
                    }
                }
            });




    /* Création d'un groupe pour chaque année sans artifice */

    var g_year_without_artifice = year_cell.append('g')
                             .attr('class', 'year_without_artifice');

    /* Création d'un rectangle pour définir l'année */
    var rect_year = g_year_without_artifice.append('path')
            .attr('d', function(year_id) {
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr('class').indexOf('double_column') > -1) {
                    return topRoundedRect(0, 50, w_rect_zoom * 2 * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom, h_rect_zoom, 6)
                }
                return topRoundedRect(0, 50, w_rect_zoom * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom, h_rect_zoom, 6)
            })
            .attr('class', function(year_id) {return 'pif_' + pif.id + 'rect_year_' + year_id + ' rect_year education_' + pif.get_education(year_id) + ' pif_' + pif.id})
            .attr('pif', pif.id)
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', function(year_id) {
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect_zoom * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom) * 2;
                } else {
                    return w_rect_zoom * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom;
                }
            })
            .attr('height', h_rect_zoom)
            .attr('transform', 'skewY(4)')
            .attr('fill', function(year_id) {
                return get_year_background_color(year_id)
            });

    var shadow_rect_year = g_year_without_artifice.append('path')
            .attr('d', function(year_id) {
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return shadow(w_rect_zoom * 2 * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom, h_rect_zoom + 0.07 * (pif.year_width(pif.years[year_id]) * w_rect_zoom * 2));
                }
                return shadow(w_rect_zoom * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom, h_rect_zoom + 7.7 * pif.year_width(pif.years[year_id])-1);
            })
            .attr('class', function(year_id) {
                return 'pif_' + pif.id + 'shadow_year_' + year_id + ' shadow_rect_year education_' + pif.get_education(year_id)
            });

    /* Création du titre de l'année */
    var year_title = g_year_without_artifice.append('text')
            .style('cursor', function(year_id) {
                if (pif.get_education(year_id)) {
                    if (pif.educationsObj[pif.get_education(year_id)].target == 'Formations' && pif.educationsObj[pif.get_education(year_id)].description != '') {
                        return 'pointer';
                    } else if (pif.educationsObj[pif.get_education(year_id)].target == 'Années' && pif.years[year_id].description != '') {
                        return 'pointer';
                    }

                    return 'default';
                }
            })
            .attr('class', function(year_id) {
                if (pif.get_education(year_id)) {
                    if (pif.educationsObj[pif.get_education(year_id)].target) {
                        return 'year_title education_' + pif.get_education(year_id) + ' year_title_' + pif.id + ' pif_' + pif.id;
                    }
                    return 'year_title disabled education_' + pif.get_education(year_id) + ' year_title_' + pif.id + ' pif_' + pif.id;
                }
            })
            .attr('x', 5)
            .attr('y',h_rect_zoom / 3)
            .attr('fill', function(year_id) {
                return pif.get_year_text_color(year_id);
            })
            .attr('font-size', 13)
            .text(function(year_id) {
                if (!pif.years[year_id].real || 'Années' != pif.educationsObj[pif.get_education(year_id)].display_titles) {
                    return '';
                } else if (pif.educationsObj[pif.get_education(year_id)].display_titles == 'Années') {
                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr( 'class' ).indexOf('double_column') > -1) {
                        return pif.get_final_year_title(year_id, pif.years[year_id].name, 1);
                    } else {
                        return pif.get_final_year_title(year_id, pif.years[year_id].name, 0);
                    }
                }
            })
            .attr('transform', 'skewY(4)')
            .append('title')
            .text(function(year_id) {
                if (pif.year_width(pif.years[year_id]) == 1 && pif.years[year_id].name.length > 11 || pif.year_width(pif.years[year_id]) == 2 && pif.years[year_id].name.length > 27 || pif.year_width(pif.years[year_id]) == 3 && pif.years[year_id].name.length > 39) {
                    return pif.years[year_id].name;
                }
            });

    /* Création d'un groupe qui va créer le diplome */
    var g_year_diploma = year_cell.append('g')
                                .attr('class', 'year_diploma');



    /* Création d'un titre de diplome au dessus de chaque rectangle */
    var title_diploma = g_year_diploma.append('text')
            .style('cursor', 'default')
            .attr('id', function(year_id) {
                if ('' != pif.years[year_id].diploma) {
                    return 'rect_title_diploma_' + pif.id;
                } else {
                    return 'rect_null_diploma_' + pif.id;
                }
            })
            .attr('class', function(year_id) {
                if ('' != pif.years[year_id].diploma) {
                    return 'rect_title_diploma education_' + pif.get_education(year_id) + ' pif_' + pif.id;
                } else {
                    return 'rect_null_diploma';
                }
            })
            .attr('x', '5')
            .attr('y', -2)
            .attr('fill', 'black')
            .attr('font-weight', 'bold')
            .attr('font-size', 13)
            .attr('transform','skewY(4)')
            .text(function(year_id) {
                if (pif.years[year_id].diploma.length > pif.year_width(pif.years[year_id])*12) {
                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                        return pif.years[year_id].diploma.substring(0,15) + '...' ;
                    } else {
                        return pif.years[year_id].diploma.substring(0,7) + '...' ;
                    }
                } else {
                    return pif.years[year_id].diploma;
                }
            })
            .on('mouseover', function(year_id) {
                if (pif.years[year_id].diploma.length > pif.year_width(pif.years[year_id])*12) {
                    d3.select(this).style('cursor', 'help')
                }
            })
            .append('title')
            .text(function(year_id) {
                if (pif.years[year_id].diploma.length > pif.year_width(pif.years[year_id])*12) {
                    return pif.years[year_id].diploma;
                }
            });

    /* Création d'un groupe de séléctivitité pour chaque année */
    var g_year_selectivity = year_cell.append('g')
                                    .attr('class', 'year_selectivity_' + pif.id)
                                    .attr('transform', 'skewY(4)');

    /* On crée un groupe pour toute les années ayant une seule selectivité et pas de précédentes */
    var year_without_previous_selectivity = g_year_selectivity.append('g')
            .attr('class', function(year_id) {
                return 'year_without_previous_selectivity education_' + pif.get_education(year_id) + ' year_without_previous_selectivity_' + pif.id + ' pif_' + pif.id;
            });

    /* On crée un rectangle pour chaque année */
    var year_without_previous_selective_rect = year_without_previous_selectivity
            .append('rect')
            .attr('class', function(year_id) {
                if (pif.years[year_id].unique_selectivity != 'Aucune' && !pif.years[year_id].previous_years.length && pif.years[year_id].unique_selectivity != 'Admission controle continu') {
                    return 'rect_sel_year';
                } else {
                    return 'non_sel_year';
                }
            })
            .attr('x',0)
            .attr('y', h_rect_zoom)
            .attr('width', function(year_id) {
                if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect_zoom * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom) * 2;
                } else {
                    return w_rect_zoom * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding_zoom;
                }
            })
            .attr('height', 2)
            .attr('fill', 'red');

    /* Création d'un groupe qui va contenir les signes de selectivité */
    var year_without_previous_selective_sign = year_without_previous_selectivity
            .append('circle')
            .attr('class', function(year_id) { if ( pif.years[year_id].unique_selectivity != 'Aucune' && !pif.years[year_id].previous_years.length) { return 'rect_sel_year';} else {return 'non_sel_year';}})
            .attr('cx', function(year_id) {
                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect_zoom*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id])-1) * rect_padding_zoom);
                } else {
                    return (w_rect_zoom*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id])-1) * rect_padding_zoom)/2;
                }
            })
            .attr('cy', h_rect_zoom)
            .attr('r', 6)
            .attr('fill', 'red');

    /* Création d'un groupe qui va contenir touts les symboles de selectivité */
    var year_without_previous_selective_text = year_without_previous_selectivity
            .append('text')
            .attr('class', function(year_id) {
                if ( pif.years[year_id].unique_selectivity != 'Aucune' && !pif.years[year_id].previous_years.length && pif.years[year_id].unique_selectivity != 'Admission controle continu') {
                    return 'rect_sel_year';
                } else {
                    return 'non_sel_year';
                }
            })
            .attr('x', function(year_id) {
                if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                    return (w_rect_zoom*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1)*rect_padding_zoom) - 3;
                } else {
                    return (w_rect_zoom*pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id])  -1)*rect_padding_zoom)/2 - 3;
                }
            })
            .attr('y', h_rect_zoom + 4)
            .attr('font-size', 11)
            .attr('font-weight', 'bold')
            .attr('fill', 'white')
            .text(function(year_id) {
                if ('Sélectif sur concours, dossier, test' == pif.years[year_id].unique_selectivity) {
                    return 'S';
                } else if ('Selectif sur concours' == pif.years[year_id].unique_selectivity) {
                    return 'C';
                } else if ('Selectif par admission parallèle' == pif.years[year_id].unique_selectivity) {
                    return 'A';
                }
            });

    /* On crée un groupe pour toutes les années ayant des précédentes, donc plusieurs séléctivités */
    var year_with_previous_selectivity = g_year_selectivity.append('g')
            .attr('class', function(year_id) {
                return 'year_with_previous_selectivity education_' + pif.get_education(year_id) + ' year_with_previous_selectivity_' + pif.id + ' pif_' + pif.id;
            });

    /* On crée un rectangle pour chaque année précédente */
    var year_with_previous_selective_rect = year_with_previous_selectivity.selectAll('rect')
            .data(function(year_id) {
                var all_previous_years = new Array();
                if (pif.years[year_id].previous_years) {
                    for (var p = 0; p < pif.years[year_id].previous_years.length; p++) {
                        all_previous_years.push(pif.years[year_id].previous_years[p]);
                    }
                    return all_previous_years;
                }
            })
            .enter()
            .append('rect')
            .attr('id', function(year_id_sel_list) {
                if (year_id_sel_list[1] == 'Sélectif sur concours, dossier, test') {
                    return 'rect_sel_year_selection_' + pif.id;
                } else if (year_id_sel_list[1] == 'Selectif sur concours') {
                    return 'rect_sel_year_examination_' + pif.id;
                } else {
                    return 'non_sel_year_' + pif.id;
                }
            })
            .attr('class', function(year_id_sel_list) {
                if (year_id_sel_list[1] == 'Sélectif sur concours, dossier, test') {
                    return 'rect_sel_year rect_sel_year_selection';
                } else if (year_id_sel_list[1] == 'Selectif sur concours') {
                    return 'rect_sel_year rect_sel_year_examination';
                } else if (year_id_sel_list[1] != 'Aucune' && year_id_sel_list[1] != 'Admission controle continu') {
                    return 'rect_sel_year';
                } else {
                    return 'non_sel_year';
                }
            })
            .attr('x', function(year_id_sel_list) {
                // Si l'année a une seule précédente, l'absice est égale à 0
                if (pif.years[this.parentNode.__data__].previous_years.length == 1) {
                    return 0;
                } else {
                    // Si l'année a plusieurs précédentes
                    for (var c = 0; c < this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes.length; c++) {
                        var target_element = this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes[c];
                        if (year_id_sel_list[0] == target_element.__data__) {
                            // Si l'abscisse de l'année en cours est inférieure a celle de sa precedente
                            if (parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) <= parseInt(target_element.getAttribute('absciss'))) {
                                if (parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss') < 0)) {
                                    return 0;
                                } else {
                                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
                                        return (parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')))*2;
                                    } else {
                                        return parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'));
                                    }
                                }
                            } else {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
                                    return (parseInt(target_element.getAttribute('absciss')))*2;
                                } else {
                                    return parseInt(target_element.getAttribute('absciss'));
                                }
                            }
                        }
                    }
                }
            })
            .attr('y', h_rect_zoom)
            .attr('width', function(year_id_sel_list) {
                var rect_width = 0;
                rect_width = w_rect_zoom*pif.year_width(pif.years[this.parentNode.__data__]) + (pif.year_width(pif.years[this.parentNode.__data__]) - 1)*rect_padding_zoom;

                /* S'il n'y a pas ou qu'une année précédente */
                if (pif.years[this.parentNode.__data__].previous_years.length <= 1) {
                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr( 'class' ).indexOf('double_column') > -1) {
                        return rect_width*2;
                    } else {
                        return rect_width;
                    }
                } else {
                    // On récupère le tableau de la ligne suivante
                    for (var c = 0; c < this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes.length; c++) {
                        var target_element = this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes[c];
                        if (year_id_sel_list[0] == target_element.__data__) {
                            var xfinal1 = parseInt(target_element.getAttribute('absciss')) + parseInt(target_element.getAttribute('cell_width'));
                            var xfinal2 = parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));

                            // Si l'abscisse de l'année en cours est inférieure a celle de sa precedente
                            if (parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) <0 || parseInt(target_element.getAttribute('absciss')) < parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'))) {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                    return parseInt(target_element.getAttribute('cell_width'))*2;
                                } else {
                                    return parseInt(target_element.getAttribute('cell_width'));
                                }

                            } else if (xfinal1 > xfinal2) {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                    return (xfinal2 - parseInt(target_element.getAttribute('absciss')))*2;
                                } else {
                                    return xfinal2 - parseInt(target_element.getAttribute('absciss'));
                                }
                            } else {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                    return target_element.getAttribute('cell_width')*2;
                                } else {
                                    return target_element.getAttribute('cell_width');
                                }
                            }
                        }
                    }
                }
            })
            .attr('height', 2)
            .attr('fill', 'red');


    /* Création d'un groupe qui va contenir tous les symboles de séléctivité */
    var year_with_previous_selective_sign = year_with_previous_selectivity
            .selectAll('circle')
            .data(function(year_id) {
                var all_previous_years = new Array();
                if (pif.years[year_id].previous_years) {
                    for (var p = 0; p < pif.years[year_id].previous_years.length; p++) {
                        all_previous_years.push(pif.years[year_id].previous_years[p]);
                    }
                    return all_previous_years;
                }
            })
            .enter()
            .append('circle')
            .attr('class', function(year_id_sel_list) {
                if (year_id_sel_list[1] == 'Aucune' || year_id_sel_list[1] == 'Admission controle continu') {
                    return 'non_sel_year';
                } else {
                    return 'rect_sel_year';
                }
            })
            .attr('cx', function(year_id_sel_list) {
                var rect_width = 0;
                rect_width = w_rect_zoom*pif.year_width(pif.years[this.parentNode.__data__]) + (pif.year_width(pif.years[this.parentNode.__data__])-1) *rect_padding_zoom;
                if (pif.years[this.parentNode.__data__].previous_years.length == 1) {
                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                        return rect_width;
                    } else {
                        return rect_width/2;
                    }
                } else {
                    for (var c = 0; c < this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes.length; c++) {
                        var target_element = this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes[c];
                        var xfinal1 = parseInt(target_element.getAttribute('absciss')) + parseInt(target_element.getAttribute('cell_width'));
                        var xfinal2 = parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));
                        if (year_id_sel_list[0] == target_element.__data__) {

                            // Si l'abscisse de l'année en cours est inférieure a celle de sa precedente
                            if (parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) <= parseInt(target_element.getAttribute('absciss')) ) {

                                if (target_element.getAttribute('absciss') - this.parentNode.parentNode.parentNode.getAttribute('absciss') < 0) {
                                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                        return ((xfinal1) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')));
                                    } else {
                                        return ((xfinal1) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'))) /2;
                                    }
                                } else if (xfinal1 > xfinal2) {
                                    var abs_rect = parseInt(target_element.getAttribute('absciss'));
                                    var wid_rect = parseInt((parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'))) - target_element.getAttribute('absciss'));
                                    /* On récupère l'abscisse max du rectangle */
                                    var finalAbs = parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));

                                    /* on retourne l'abscisse max de l'année courante - la moitié de la largeur du rectangle de l'année précédente */
                                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                        return (finalAbs - (wid_rect/2))*2;
                                    } else {
                                        return finalAbs - (wid_rect/2);
                                    }
                                } else {
                                    var abs_rect = parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'));
                                    var wid_rect = parseInt(target_element.getAttribute('cell_width'));
                                    if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                        return (abs_rect + (wid_rect/2))*2;
                                    } else {
                                        return abs_rect + (wid_rect/2);
                                    }
                                }
                            } else {
                                if ($( '#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                    return 30;
                                } else {
                                    return 15;
                                }
                            }
                        }
                    }
                }
            })
            .attr('cy', h_rect_zoom)
            .attr('r', 6)
            .attr('fill', 'red');

    /* Création d'un groupe qui va contenir tous les signes de séléctivité */
    var year_with_previous_selective_text = year_with_previous_selectivity
            .selectAll('text')
            .data(function(year_id) {
                var all_previous_years = new Array();
                if (pif.years[year_id].previous_years) {
                    for (var p=0; p<pif.years[year_id].previous_years.length; p++) {
                        all_previous_years.push(pif.years[year_id].previous_years[p]);
                    }
                    return all_previous_years;
                }
            })
            .enter()
            .append('text')
            .attr('class', function(year_id_sel_list) {
                if (year_id_sel_list[1] == 'Aucune' || year_id_sel_list[1] == 'Admission controle continu') {
                    return 'non_sel_year';
                } else {
                    return 'rect_sel_year';
                }
            })
            .attr('x', function(year_id_sel_list) {
                var rect_width = 0;
                rect_width = w_rect_zoom*pif.year_width(pif.years[this.parentNode.__data__]) + (pif.year_width(pif.years[this.parentNode.__data__])-1)*rect_padding_zoom;

                if (pif.years[this.parentNode.__data__].previous_years.length == 1) {
                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                        return rect_width - 3;
                    } else {
                        return rect_width/2 - 3;
                    }
                } else {
                    for (var c=0; c<this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes.length; c++) {
                        var target_element = this.parentNode.parentNode.parentNode.parentNode.nextElementSibling.childNodes[c];
                        var xfinal1 = parseInt(target_element.getAttribute('absciss')) + parseInt(target_element.getAttribute('cell_width'));
                        var xfinal2 = parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));
                        if (year_id_sel_list[0] == target_element.__data__) {

                            // Si l'absciss de l'année en cours est inférieure a celle de sa precedente
                            if (parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) <= parseInt(target_element.getAttribute('absciss')) ) {

                                if (parseInt(target_element.getAttribute('absciss')) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) < 0) {
                                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr('class').indexOf('double_column') > -1) {
                                        return ((xfinal1) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss'))) - 3;
                                    } else {
                                        return ((xfinal1) - parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')))/2 - 3;
                                    }
                                } else if (xfinal1 > xfinal2) {
                                    var abs_rect = parseInt(target_element.getAttribute('absciss'));
                                    var wid_rect = parseInt((parseInt(this.parentNode.parentNode.parentNode.getAttribute('absciss')) + parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'))) - target_element.getAttribute('absciss'));
                                    /* On récupère l'abscisse max du rectangle */
                                    var finalAbs = parseInt(this.parentNode.parentNode.parentNode.getAttribute('cell_width'));
                                    /* on retourne l'abscisse max de l'année courante - la moitié de la largeur du rectangle de l'année précédente */
                                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
                                        return (finalAbs - (wid_rect/2)) * 2 - 3;
                                    } else {
                                        return finalAbs - (wid_rect/2) - 3;
                                    }

                                } else {
                                    var abs_rect = target_element.getAttribute('absciss') - this.parentNode.parentNode.parentNode.getAttribute('absciss');
                                    var wid_rect = target_element.getAttribute('cell_width');
                                    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
                                        return (abs_rect +(wid_rect/2))*2 -3;
                                    } else {
                                        return abs_rect + (wid_rect/2) -3;
                                    }
                                }

                            } else {
                                if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
                                    return 30;
                                } else {
                                    return 15;
                                }
                            }
                        }
                    }
                }
            })
            .attr('y', h_rect_zoom + 4)
            .attr('font-size', 11)
            .attr('font-weight', 'bold')
            .attr('fill', 'white')
            .text(function(year_id_sel_list) {
                switch(year_id_sel_list[1]) {
                case 'Sélectif sur concours, dossier, test':
                    return 'S';
                    break;
                case 'Selectif sur concours':
                    return 'C';
                    break;
                case 'Selectif par admission parallèle':
                    return 'A';
                    break;
                }
            });


    /*********************************************************************************************************************
    * Création du groupe  qui va afficher la base du pif
    *******************************************************************************************************************/

    /* Création du groupe qui va tout accueillir */

    var base_pif_group = pif_years_group.append('g');


    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
        var max_height = (pif.get_height_max_zoom(dataset, 1) + h_rect_zoom + 'px');
    } else {
        var max_height = (pif.get_height_max_zoom(dataset, 0) + h_rect_zoom + 'px');
    }

    var all_line_years = d3.selectAll('.line_year' + pif.id)[0].length;

    /* Création du rectangle de la base du pif*/
    var rect_base_pif = base_pif_group.append('rect')
            .attr('class', function () {
                if (hide_base_pif == 0) {
                    return 'base_pif' + pif.id;
                } else {
                    return 'void_year';
                }
            })
            .attr('height', 1)
            .attr('opacity', 0.5);

    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
        rect_base_pif.attr('width', pif.get_width_max(dataset) * 2);
    } else {
        rect_base_pif.attr('width', pif.get_width_max(dataset));
    }

    /* Création du texte de la base du pif */
    var text_base = base_pif_group.append('text')
            .attr('y', 0)
            .attr('class', 'text_base_pif_zoom')
            .attr('id', 'text_pif' + pif.id)
            .text(pif.base);


    // permet de centrer la base si le texte est plus grand que la largeur du pif
    var shift = 0;
    if ($('.text_base_pif_zoom#text_pif' + pif.id)[0].getBoundingClientRect().width > $('.base_pif' + pif.id)[0].getBoundingClientRect().width) {
        shift = (($('.text_base_pif_zoom#text_pif' + pif.id)[0].getBoundingClientRect().width - $('.base_pif' + pif.id)[0].getBoundingClientRect().width) + 50 ) /2;
        base_pif_group.attr('width', $('.text_base_pif_zoom#text_pif' + pif.id)[0].getBoundingClientRect().width + 50);
        rect_base_pif.attr('width', $('.text_base_pif_zoom#text_pif' + pif.id)[0].getBoundingClientRect().width + 50);
    }

    text_base.attr('x', (parseInt(rect_base_pif.attr('width')) - $('.text_base_pif_zoom#text_pif' + pif.id)[0].getBoundingClientRect().width)/2 ); // centre le texte
    base_pif_group.attr('transform', 'skewY(4) translate(' + (-shift).toFixed(2) + ',' + parseInt(max_height) + ')');

    $('#svg_area_' + pif.id).css('height', (parseInt($('#svg_principal_area_' + pif.id).css('height')) - 20) +'px' );// permet de prendre en compte la barre du titre


    if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id).attr('class').indexOf('double_column') > -1) {
        pif.draw_gateways_zoom(dataset, 1);
    } else {
        pif.draw_gateways_zoom(dataset, 0);
    }

    //montre les années correspondante au type de formation ou au job passé en view parameters
    pif.hideByEducations();

    pif_years_group.attr('transform',function () {
        if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return 'translate(0,30) scale(0.7)';
        }
        return 'translate(0,30) scale(0.9)';
    });


    var gateways = $('#pif_' + pif.id + '.gateways');
    gateways.attr('transform',function () {
        if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return 'translate(0,30) scale(0.7)';
        }
        return 'translate(0,30) scale(0.9)'
    });

    /**********************************************************************************************************************
     * fermer la popin on cliquant dehors
     ************************************************************************************************************************/

    d3.select("body").on("mouseup",function() {
       if (!nodeParentsIdMatch(d3.event.target, 'information_pif_' + pif.id)) {
           $('#information_pif_' + pif.id).removeClass('active');
           $('#information_pif_' + pif.id).css('visibility', 'hidden');
           $('#education_information_pif_' + pif.id).css('display', 'none');
       }
    });


    function nodeParentsIdMatch(node, id) {
        for (var n=node; n.parentNode; n=n.parentNode) {
            if (id == n.id) {
                return true;
            }
        }
        return false;
    }

    //Flèches d'indications du pif

    svg_principal_area.append('div')
        .attr('class', 'half-circle-left')
        .attr('id', 'half-circle-left_pif_' + pif.id)
        .attr('pif', pif.id)
        .style('top', parseInt(svg_principal_area.style('height'))/2 - 16 + 'px')
        .on('click', function() {

            var pifId = $(this).attr('pif');
            var BB_svg_area = $('#svg_area_' + pifId)[0].getBoundingClientRect();
            $('#oni-ico-fleche4_right_pif_' + pifId).css('visibility', 'visible');

            $('#half-circle-right_pif_' + pifId).css('visibility', 'visible');

            if ($('#pif_' + pifId + '_container').hasClass('pif_container_embed') || (!$('#left_pan_' + pifId).hasClass('visible') && 768 > $(window).width() && 'full' == view_type) ) {
                var left_min = 0;
            } else {
                var left_min = 200;
            }

            if ( left_min >  zoom[pifId].translate()[0] + BB_svg_area.width) {
                left =  zoom[pifId].translate()[0] + BB_svg_area.width;
            } else {
                left = left_min;
            }

            svg.transition()
               .duration(500)
               .ease('quad')
               .attr('transform', 'translate(' + left + ',0) scale(' + zoom_value + ')');

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                zoom[pifId].translate([ left, zoom[pifId].translate()[1]]);
            } else {
                zoom[pifId].translate([ left, 0]);
            }

            if ( zoom[pifId].translate()[0] == left_min ){
                $(this).css('visibility', 'hidden');
                $('#oni-ico-fleche4_left_pif_' + pifId).css('visibility', 'hidden');
            }
        });

    svg_principal_area.append('div')
        .attr('class', 'half-circle-right')
        .attr('id', 'half-circle-right_pif_' + pif.id)
        .attr('pif', pif.id)
        .style('top', parseInt(svg_principal_area.style('height'))/2 - 16 + 'px')
        .on('click', function() {

            var pifId = $(this).attr('pif');
            var BB_svg_area = $('#svg_area_' + pifId)[0].getBoundingClientRect();
            var movable_area_w = $('#pif_' + pifId + '_container .pif_years_group_' + pifId)[0].getBoundingClientRect().width;
            var pif_width = $('#pif_' + pifId + '_container').outerWidth();

            $('#oni-ico-fleche4_left_pif_' + pifId).css('visibility', 'visible');
            $('#half-circle-left_pif_' + pifId).css('visibility', 'visible');

            if ($('#pif_' + pifId + '_container').hasClass('pif_container_embed') || (!$('#left_pan_' + pifId).hasClass('visible') && 768 > $(window).width() && 'full' == view_type) ) {
                var right_min = 40;
            } else {
                var right_min = 240;
            }

            right = Math.max(pif_width - right_min - movable_area_w, zoom[pifId].translate()[0] - BB_svg_area.width);

            svg.transition()
                .duration(500)
                .ease('quad')
                .attr('transform', 'translate(' + right + ',0) scale(' + zoom_value + ')');

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                zoom[pifId].translate([right, zoom[pifId].translate()[1]]);
            } else {
                zoom[pifId].translate([right, 0]);
            }

            if (zoom[pifId].translate()[0] <= pif_width - right_min - movable_area_w) {
                $(this).css('visibility', 'hidden');
                $('#oni-ico-fleche4_right_pif_' + pifId).css('visibility', 'hidden');
            }
        });

    var arrow_pif_left = svg_principal_area.append('div')
            .attr('class', 'oni-ico-fleche4 ico-fleche-left')
            .attr('id', 'oni-ico-fleche4_left_pif_' + pif.id)
            .style('top', ((parseInt(svg_principal_area.style('height')) / 2) - 6) + 'px');

    var arrow_pif_right = svg_principal_area.append('div')
            .attr('class', 'oni-ico-fleche4 ico-fleche-right')
            .attr('id', 'oni-ico-fleche4_right_pif_' + pif.id)
            .style('top', ((parseInt(svg_principal_area.style('height')) / 2) - 6) + 'px');

    pif.setArrowsVisibility();

    svg.attr('transform', function() {
        // Centrer le PIF
        var BB_pif = $('#pif_years_group_id'+pif.id)[0].getBoundingClientRect();
        var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
        var x = Math.abs(BB_pif.left - BB_svg_area.left) + ((Math.abs(BB_svg_area.width) - Math.abs(BB_pif.width))/2);
        zoom[pif.id].translate([x, 0]);
        return 'translate(' + x + ',0)';
    });

    if ('full' != view_type) {
        $('#svg_area_' + pif.id).css('height', $('#pif_' + pif.id + '_area')[0].getBBox().height + 120)
            .css('margin-top', function() {
                if ('full' == view_type) {
                    if (0 < ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2)) {
                        return ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2) + 'px';
                    }
                    return 0;
                }
            });
        $('#pif_' + pif.id + '_container').css('height', $('#svg_area_' + pif.id).height());
    }

    pif.drawFiltersArea();

    window.addEventListener('resize', function() {
        if (!($('#ideo-content .fiche-pif').length)) {
            pif_years_group.attr('transform',function () {
                if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return 'translate(0,30) scale(0.7)';
                }
                return 'translate(0,30) scale(0.9)';
            });

            gateways.attr('transform', function() {
                if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return 'translate(0,30) scale(0.7)';
                }
                return 'translate(0,30) scale(0.9)';
            });

            d3.select('#right_pan_' + pif.id)
            .style('height', $('#pif_' + pif.id + '_container').css('height'));
            d3.select('#left_pan_' + pif.id)
            .style('height', $('#pif_' + pif.id + '_container').css('height'));

            if ('full' == view_type) {
                if (480 < $(window).width()) {
                    $('#portraits_container_' + pif.id).css('bottom', '');
                } else {
                    if ('none' != $('#filters_container_' + pif.id).css('display')) {
                        $('#tabs_left_' + pif.id).css('bottom', $('#filters_container_' + pif.id)[0].getBoundingClientRect().height);
                        $('#filters_container_' + pif.id).css('bottom', 0);
                    } else if ('none' != $('#portraits_container_' + pif.id).css('display')) {
                        $('#tabs_left_' + pif.id).css('bottom', $('#portraits_container_' + pif.id)[0].getBoundingClientRect().height);
                        $('#portraits_container_' + pif.id).css('bottom', 0);
                    }else if ('none' != $('#enrichments_container_' + pif.id).css('display')) {
                        $('#tabs_left_' + pif.id).css('bottom', $('#enrichments_container_' + pif.id)[0].getBoundingClientRect().height);
                        $('#enrichments_container_' + pif.id).css('bottom', 0);
                    }

                     d3.select('#zoom_buttons_' + pif.id)
                     .style('top', $('#title_pif_' + pif.id).height() + 20 + 'px');

                     $('#left_pan_' + pif.id).addClass('visible');
                }
            }

            tooltip.style('visibility', 'hidden');
            tooltipL.style('visibility', 'hidden');

            $('#svg_area_' + pif.id).css('height', $('#pif_' + pif.id + '_area')[0].getBBox().height + 120)
            .css('margin-top', function() {
                if ('full' == view_type) {
                    if (0 < ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2)) {
                        return ($('#svg_principal_area_' + pif.id).height() / 2) - ($('#svg_area_' + pif.id).height() / 2) + 'px';
                    }
                    return 0;
                }
            });
            $('#pif_' + pif.id + '_container').css('height', $('#svg_area_' + pif.id).height());

            pif_width = $('#pif_' + pif.id + '_container').outerWidth();
            d3.select('#svg_area_' + pif.id).attr('width', pif_width - 10).call(zoom[pif.id]).on("mousewheel.zoom", null)
            .on("DOMMouseScroll.zoom", null)
            .on("wheel.zoom", null);
            //permet de remettre le pif à la position de base pour qu'il ne soit pas "bloqué" hors de l'area lorsqu'on resize
            svg.attr('transform', 'translate(0,0)');
            zoom[pif.id].translate([0, 0]);
            svg.attr('transform', function() {
                // Centrer le PIF
                var BB_pif = $('#pif_years_group_id'+pif.id)[0].getBoundingClientRect();
                var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();
                var x = Math.abs(BB_pif.left - BB_svg_area.left) + ((Math.abs(BB_svg_area.width) - Math.abs(BB_pif.width))/2);

                zoom[pif.id].translate([x, 0]);
                return 'translate(' + x + ',0)';
            });
            pif.setArrowsVisibility();
            zoom_value = 1;
        }
    });

}


/***************************************************************************************************
 * Montre / cache les flèches de chaque côté du PIF selon s'il peut être translaté ou non
 ***************************************************************************************************/

Pif.prototype.setArrowsVisibility = function() {
    var pif = this;
    pif_BB = $('#pif_' + pif.id + '_container .pif_years_group_' + pif.id)[0].getBBox();
    var container = d3.select('#pif_' + pif.id + '_container');

    var movable_area_w = $('#pif_' + pif.id + '_container .pif_years_group_' + pif.id)[0].getBoundingClientRect().width;

    var shift_left = 0;
    if ($('#left_pan_' + pif.id).hasClass('visible') && 480 < $(window).width() || 1024 < $(window).width()) {
            shift_left += parseInt($('#left_pan_' + pif.id).css('width'));
            if ($('#portraits_pan_' + pif.id).hasClass('visible') && 768 < parseInt($('#pif_' + pif.id + '_container').css('width'))) {
                // evite les problèmes concernant une mauvaise width si l'animation du portraits pan n'est pas finie
                shift_left = shift_left * 2;
            }
    } else {
        if ($('#left_pan_' + pif.id).hasClass('visible')) {
            shift_left += parseInt($('#left_pan_' + pif.id).css('width'));
        }
    }

    var shift_right = 0;

    if (($('#right_pan_' + pif.id).hasClass('visible') && 480 < $(window).width() || 1024 < $(window).width()) && 'full' == view_type) {
        shift_right += parseInt($('#right_pan_' + pif.id).css('width'));
    }

    var visibility_state = 'hidden';
    if (movable_area_w + shift_left + shift_right + 80 > $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
        visibility_state = 'visible';
    }
    if ($('.fiche-pif .pif_container_embed').length) {
        var pif_area_width = $('#pif_' + pif.id + '_area')[0].getBoundingClientRect().width;
        if (
            $('#etudes').length &&  pif_area_width > $('#etudes').width()
            ||
            $('#les-formations-et-les-diplomes').length && pif_area_width > $('#les-formations-et-les-diplomes').width()
        ) {
            $('.svg_principal_area').css('overflow', 'hidden');
            visibility_state = 'visible';
        }
    }

    $('#half-circle-left_pif_' + pif.id)
    .css('visibility', visibility_state);

    $('#half-circle-right_pif_' + pif.id)
    .css('visibility', visibility_state);

    $('#oni-ico-fleche4_left_pif_' + pif.id)
    .css('visibility', visibility_state);

    $('#oni-ico-fleche4_right_pif_' + pif.id)
    .css('visibility', visibility_state);
}


/*******************************************************************
 * Crée les rectangles arrondis et les ombres pour le design zoom
 *******************************************************************/

function topRoundedRect(x, y ,width, height, radius) {
    return "M " + x + "," + y
        + " v " + (-height + radius)
        + " a " + radius + "," + radius + " 0 0 1 " + radius + "," + -radius
        + " h " + (width - 2*radius)
        + " a " + radius + "," + radius + " 0 0 1 " + radius + "," + radius
        + " v " + (height - radius)
        + " h " + -width
        + " Z ";
}

function shadow(x, y) {
    return "M " + x + "," + y
    + " v " + (- h_rect_zoom / 2)
    + " l 15, 1.5"
    + " Z ";
}


/***********************************************************************
 * déssine les passerelles sur le pif pour le design zoom
 **********************************************************************/

Pif.prototype.draw_gateways_zoom = function(dataset, doubleColumn) {
    pif = this;
    if (this.gateways.length) {
        var svg = d3.select('#pif_' + this.id + '_container #pif_' + this.id + '_area');
        var gateways_group = svg.append('g')
            .attr('id', 'pif_' + this.id)
            .attr('class', 'gateways')
        ;
        gateways_group.append('defs')
            .append('marker')
                .attr('id', 'pifArrowMarker')
                .attr('stroke-width', '0px')
                .attr('markerUnits', 'strokeWidth')
                .attr('orient', 'auto')
                .attr('markerHeight', 6)
                .attr('markerWidth', 6)
                .attr('refX', 3)
                .attr('refY', 3)
                .append('path')
                    .attr('d', 'M0,0 L3,3 L0,6 L6,3 Z')
                    .attr('style', 'fill: #000000; stroke-dasharray: none;')
        ;

        var year_rect_padding = 20;
        for (var index = 0; index < this.gateways.length; index++) {
            var gateway = this.gateways[index];
            if (this.got_year(gateway.from) && this.got_year(gateway.to)) {
                var from_rect = d3.select('.pif_' + this.id + 'rect_year_' + gateway.from);
                var from_year = d3.select('.pif_' + this.id + 'year' + gateway.from);
                if (!from_year[0][0]) { continue; }
                var from_line = d3.select(from_year[0][0].parentNode);
                var from_x, from_y, to_x, to_y;

                var to_rect = d3.select('.pif_' + this.id + 'rect_year_' + gateway.to);
                var to_year = d3.select('.pif_' + this.id + 'year' + gateway.to);
                if (!to_year[0][0]) { continue; }
                var to_line = d3.select(to_year[0][0].parentNode);

                if (1 == doubleColumn) {
                    rect_padding_zoom = rect_padding_zoom *2 ;
                }

                if (from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2] == to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]) {
                    // si les blocs sont sur la même ligne, on détermine la direction et on fait une flèche droite
                    if (parseFloat(from_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]) <= parseFloat(to_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1])) {
                        from_x = parseInt(from_rect.attr('width')) + parseInt(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(from_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                        from_y = Math.abs(parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]) - from_x )*0.07 + parseFloat(from_rect.attr('height') / 2.5) + parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]);
                        to_x = parseInt(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(to_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]) - 4;
                        to_y = Math.abs(parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - to_x )*0.07 + parseFloat(to_rect.attr('height') / 2.5) + parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]);

                    } else {
                        from_x = parseInt(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(from_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                        from_y = Math.abs(parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - from_x )*0.07 + parseFloat(from_rect.attr('height') / 2.5) + parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]);
                        to_x = parseInt(to_rect.attr('width')) + parseInt(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(to_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]) + 4;
                        to_y = Math.abs(parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - to_x )*0.07 + parseFloat(to_rect.attr('height') / 2.5) + parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]);
                    }

                    var lineData = [{'x': from_x, 'y': from_y}, {'x': to_x, 'y': to_y}];
                    // si la flèche pointe sur une case qui n'est pas à côté, ont fait passer la flèche par dessous les blocs
                    if (rect_padding_zoom < Math.abs(from_x - to_x)) {
                        if (from_x < to_x) {
                            from_x = (from_rect.attr('width') / 2) + 10 + parseInt(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(from_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                            from_y = Math.abs(parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - from_x )*0.07 + 2*parseFloat(from_rect.attr('height')) + parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]) - h_rect_zoom;
                            to_x = (to_rect.attr('width') / 3) + parseInt(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(to_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                            to_y = Math.abs(parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - to_x )*0.07 + parseFloat(to_rect.attr('height'))+parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]);
                        } else {
                            from_x = (from_rect.attr('width') / 3) - 10 + parseInt(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(from_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                            from_y = Math.abs(parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - from_x )*0.07 + 2*parseFloat(from_rect.attr('height')) + parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]) - h_rect_zoom;
                            to_x = (to_rect.attr('width') / 2) + parseInt(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(to_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                            to_y = Math.abs(parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - to_x )*0.07 + parseFloat(to_rect.attr('height')) + parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]);
                        }
                        var lineData = [{'x': from_x, 'y': from_y}, {'x': from_x - 7, 'y': from_y + 12},  {'x': to_x - 4, 'y': to_y + 12}, {'x': to_x, 'y': to_y + 4}];
                    }
                } else { //sinon on fait une flèche incurvée en déterminant sa direction
                    // si la flèche pointe sur une position à droite du départ
                    if (parseFloat(from_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]) <= parseFloat(to_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1])) {
                        from_x = (from_rect.attr('width') / 1.5) + 10 + parseInt(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(from_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                        from_y = Math.abs(parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - from_x )*0.07 + parseFloat(from_rect.attr('height'))+parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]) - h_rect_zoom;
                        to_x = (to_rect.attr('width') / 3) + parseInt(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(to_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                        to_y = Math.abs(parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - to_x )*0.07 + parseFloat(to_rect.attr('height')) + parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]);
                    } else {
                        from_x = (from_rect.attr('width') / 3) - 10 + parseInt(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(from_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                        from_y = Math.abs(parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - from_x )*0.07 + parseFloat(from_rect.attr('height')) + parseFloat(from_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]) - h_rect_zoom;
                        to_x = (to_rect.attr('width') / 1.5) + parseInt(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) + parseFloat(to_year.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*\.?[0-9]*?)\)/)[1]);
                        to_y = Math.abs(parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[1]) - to_x )*0.07 + parseFloat(to_rect.attr('height')) + parseFloat(to_line.attr('transform').match(/translate\((-?[0-9]+)[, ]?([0-9]*)\)/)[2]);
                    }
                    var lineData = [{'x': from_x, 'y': from_y}, {'x': from_x + 10, 'y': from_y - 18},  {'x': to_x - 4, 'y': to_y + 18}, {'x': to_x, 'y': to_y + 4}];
                }

                var bezierLine = d3.svg.line()
                .x(function(d) { return d.x; })
                .y(function(d) { return d.y; })
                .interpolate("basis");
                gateways_group.append('path')
                .attr("d", bezierLine(lineData))
                .attr('style', 'stroke: #000000; stroke-width: 1.5px; stroke-dasharray: 2,2; fill: none; marker-end: url(#pifArrowMarker);')
                .attr('class', function(d){
                    return 'gateway_line education_' + pif.get_education(from_year[0][0].__data__) + ' pif_' + pif.id;
                });
            }
        }
    }
}


/**********************************************************************************************
 * Déssine les parcours sur le PIF
 *********************************************************************************************/

Pif.prototype.draw_route = function(route) {
    var pif = this;
    var pos_init = d3.select('#pif_' + pif.id + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];

    var movable_area_w = $('#pif_' + pif.id + '_container .pif_years_group_' + pif.id)[0].getBoundingClientRect().width;

    var svg = d3.select('#pif_' + pif.id + '_container #pif_' + pif.id + '_area');

    var shift_left = 0, shift_right = 0;

    if ('full' == view_type) {
        if ($('#left_pan_' + pif.id).hasClass('visible') && 480 < $(window).width() || 1024 < $(window).width()) {
            shift_left += parseInt($('#left_pan_' + pif.id).css('width'));
            if ($('#portraits_pan_' + pif.id).hasClass('visible') && 768 < parseInt($('#pif_' + pif.id + '_container').css('width'))) {
                // evite les problèmes concernant une mauvaise width si l'animation du portraits pan n'est pas finie
                shift_left = shift_left * 2;
            }
        }
    } else {
        if ($('#left_pan_' + pif.id).hasClass('visible')) {
            shift_left += parseInt($('#left_pan_' + pif.id).css('width'));
        }
    }


    if (($('#right_pan_' + pif.id).hasClass('visible') && 480 < $(window).width() || 1024 < $(window).width()) && 'full' == view_type) {
        shift_right += parseInt($('#right_pan_' + pif.id).css('width'));
    }
    // si le le pif n'a pas besoin de translate, on ne le bouge pas
    if (movable_area_w + shift_left + shift_right > $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
        svg.attr('transform', 'translate(0,0)'); // on met le svg en (0,0) pour calculer correctement les positions des parcours
    }


    d3.selectAll('.route_layer_' + pif.id).remove();
    var route_layer = d3.select('#pif_' + pif.id +'_area').append('g')
    .attr('id', 'route_layer_pif_' + pif.id)
    .attr('class', 'route_layer route_layer_' + pif.id);
    var data = new Array();
    var delay = 500;
    var nbr_points = 0;
    var width_rect = w_rect;
    var height_rect = h_rect;
    var rect_padd = 0;
    var container = d3.select('#pif_' + pif.id + '_container');
    if (0 == pif.design) {
        width_rect = w_rect;
        height_rect = h_rect;
        rect_padd = rect_padding;
        if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            width_rect = w_rect * 0.75;
            height_rect = h_rect * 0.75;
            rect_padd = rect_padding * 0.75;
        }
        var color = '#666666';
        var opacity = 1;
        var point_radius = 6;
    } else if (1 == pif.design) {
        width_rect = w_rect_zoom * 0.9;
        height_rect = h_rect_zoom * 0.9;
        rect_padd = rect_padding_zoom * 0.9;
        if (768 > parseInt(container.style('width')) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            width_rect = w_rect_zoom * 0.7;
            height_rect = h_rect_zoom * 0.7;
            rect_padd = rect_padding_zoom * 0.7;
        }

        var color = '#4D4D4D';
        var opacity = 1;
        var point_radius = 6;
    }

    //si la première année est la même que celle de la base, copie le tableau des années moins la première
    var base_linked = 0;
    if (pif.base_year == route.years[0].id) {
        var route_years_array = route.years.slice(0);
        route_years_array.shift();
        base_linked = 1;
    } else {
        var route_years_array = route.years;
    }

    for(var i = 0; i < route_years_array.length; i++) {
        if ('pif_year' == route_years_array[i].type) {
            // actual rect
            var rect = $('.pif_' + pif.id + 'rect_year_' + route_years_array[i].id);
            var offset = $('#svg_area_' + pif.id).offset();
            var pos = rect.offset();

            if (0 == pif.design) {
                var x = (pos.left - offset.left) + width_rect - (point_radius + 1);
                var y = (pos.top - offset.top) + height_rect - (point_radius + 1);
            } else if (1 == pif.design) {
                var x = (pos.left - offset.left) + width_rect / 2;
                var y = (pos.top - offset.top)+ 2 * height_rect / 3;
            }

            // si ce n'est pas le premier point (qui doit être placé en fonction du second si l'année fait plus d'une unité)
            if (0 != nbr_points) {
                //previous point
                // pour calculer la meilleur position par rapport au rect_previous et permet d'éviter d'avoir les texte simple dans rect_previous
                if (route_years_array[i - 1]) {
                    var is_year = 0;
                    var id_previous_point = i - 1;
                    while(is_year == 0) {
                        if ('pif_year' != route_years_array[id_previous_point].type) {
                            id_previous_point--;
                        } else {
                            is_year = 1;
                            var previous_point = $('#' + (nbr_points - 1) + '.points_route_' + route.id);
                        }
                    }
                    var offset_svg = $('#svg_area_' + pif.id).offset();
                    var pos_previous_point = previous_point.offset();
                    var x_previous_point = data[data.length - 1].x;
                    var y_previous_point = data[data.length - 1].y;
                }

                //next point
                if (route_years_array[i + 1]) {
                    var is_year = 0;
                    var id_next_point = i + 1;
                    while(is_year == 0) {
                        if ('pif_year' != route_years_array[id_next_point].type) {
                            id_next_point++;
                        } else {
                            is_year = 1;
                            var next_rect = $('.pif_' + pif.id + 'rect_year_' + route_years_array[id_next_point].id);
                        }
                    }
                    var pos_next_rect = next_rect.offset();


                    if (0 == pif.design) {
                        var x_next_point = (pos_next_rect.left - offset.left) + width_rect - (point_radius + 1);
                        var y_next_point = (pos_next_rect.top - offset.top) + height_rect - (point_radius + 1);
                    } else if (1 == pif.design) {
                        var x_next_point = (pos_next_rect.left - offset.left) + width_rect / 2;
                        var y_next_point = (pos_next_rect.top - offset.top)+ 2 * height_rect / 3;
                    }

                }

                var final_pos = 1;
                var pos_found = 0;
                //si l'année fait plus d'une unité
                if (1 < pif.year_width(pif.years[route_years_array[i].id])) {
                    //si le point suivant est sur une année de la même formation
                    if (route_years_array[i + 1] && (route_years_array[i + 1].type != 'simple_text') && (this.get_education(route_years_array[i].id) == this.get_education(route_years_array[i + 1].id)) && (1 < pif.year_width(pif.years[route_years_array[i].id]))) {
                        var years_actual_education = pif.educationsObj[this.get_education(route_years_array[i].id)].years;

                        var stop = 0;
                        var index_education = 1;
                        var got_education = 0;
                        // on va chercher le dernier point faisant partie de cette formation pour placer les autres en fonction de sa position
                        for(var j = i + 1; j < route_years_array.length; j++) {
                            if (this.get_education(route_years_array[j].id) != this.get_education(route_years_array[i].id)) {
                                var last_rect_same_education = $('.pif_' + pif.id + 'rect_year_' + route_years_array[j - 1].id);
                                var pos_last = last_rect_same_education.offset();

                                if (0 == pif.design) {
                                    var x_last = (pos_last.left - offset_svg.left) + width_rect - (point_radius + 1);
                                    var y_last = (pos_last.top - offset_svg.top) + height_rect - (point_radius + 1);
                                } else if (1 == pif.design) {
                                    var x_last = (pos_last.left - offset_svg.left) + width_rect / 2;
                                    var y_last = (pos_last.top - offset_svg.top) + 2 * height_rect / 3;
                                }

                                var last_year = route_years_array[j - 1].id;
                                got_education = 1;
                            }
                        }

                        if (0 == got_education) {
                            var last_rect_same_education = $('.pif_' + pif.id + 'rect_year_' + route_years_array[route_years_array.length - 1].id);
                            var pos_last = last_rect_same_education.offset();


                            if (0 == pif.design) {
                                var x_last = (pos_last.left - offset_svg.left) + width_rect - (point_radius + 1);
                                var y_last = (pos_last.top - offset_svg.top) + height_rect - (point_radius + 1);
                            } else if (1 == pif.design) {
                                var x_last = (pos_last.left - offset_svg.left) + width_rect / 2;
                                var y_last = (pos_last.top - offset_svg.top) + 2 * height_rect / 3;
                            }

                            var last_year = route_years_array[route_years_array.length - 1].id;
                        }


                        if (1 == pif.design) { // si design zoom
                            // on récupère le nombre d'année entre le premier point et le dernier pour savoir le décalage à adopter
                            for(var j = 0; j < pif.educationsObj[pif.years[route_years_array[i].id].education].years.length ; j++) {
                                if (pif.educationsObj[pif.years[route_years_array[i].id].education].years[j] == route_years_array[i].id) {
                                    var id_first_point_in_education = j;
                                }
                                if (pif.educationsObj[pif.years[route_years_array[i].id].education].years[j] == last_year) {
                                    var id_last_point_in_education = j;
                                }
                            }

                            var shift = (id_last_point_in_education - id_first_point_in_education) * 25 - 6; //... - radius of circle;

                            var distance_shifted = x_last - shift - x;

                            x = x_last - shift;
                            y = y + distance_shifted * 0.07;
                        } else {
                            x = x_last;
                        }
                    } else { //si le point suivant n'est pas de la même formation
                        if (0 == pif.design) {
                            for(var j = 1; j < pif.year_width(pif.years[route_years_array[i].id]); j++) {
                                var actual_length = Math.sqrt(Math.pow(x_previous_point - (x + (width_rect + rect_padd) * j), 2) + Math.pow(y_previous_point - y, 2));
                                var previous_length = Math.sqrt(Math.pow(x_previous_point - (x + (width_rect + rect_padd) * (j - 1)), 2) + Math.pow(y_previous_point - y, 2));

                                if (previous_length < actual_length) {
                                    final_pos = j - 1;
                                    // permet de ne pas avoir le rect_padding en moins si le point est au début du rectangle, ce qui ferait un décalage
                                    if (0 != final_pos) {
                                        x = x + (width_rect + rect_padd) * final_pos;
                                    }

                                    pos_found = 1;
                                    break;
                                }
                            }
                            if (0 == pos_found) {
                                final_pos = pif.year_width(pif.years[route_years_array[i].id]) - 1;
                                x = x + (width_rect + rect_padd) * final_pos;
                            }
                        } else if (1 == pif.design) {
                            for(var j = 1; j < pif.year_width(pif.years[route_years_array[i].id]); j++) {
                                var actual_length = Math.sqrt(Math.pow(x_previous_point - (x + (width_rect + rect_padd) * j), 2) + Math.pow(y_previous_point - (y + (x + (width_rect + rect_padd) * j - x ) * 0.07), 2));
                                var previous_length = Math.sqrt(Math.pow(x_previous_point - (x + (width_rect + rect_padd) * (j - 1)), 2) + Math.pow(y_previous_point - (y + (x + (width_rect + rect_padd) * (j - 1) - x ) * 0.07), 2));

                                if (previous_length < actual_length) {
                                    final_pos = j - 1;
                                    // permet de ne pas avoir le rect_padding en moins si le point est au début du rectangle, ce qui ferait un décalage
                                    if (0 != final_pos) {
                                        x = x + (width_rect + rect_padd) * final_pos;
                                        y = y + (x + (((width_rect + rect_padd) * final_pos )) - x ) * 0.07;
                                    }

                                    pos_found = 1;
                                    break;
                                }
                            }
                            if (0 == pos_found) {
                                final_pos = pif.year_width(pif.years[route_years_array[i].id]) - 1;
                                x = x + (width_rect + rect_padd) * final_pos;
                                y = y + (x + (((width_rect + rect_padd) * final_pos )) - x ) * 0.07;
                            }
                        }
                    }
                }

                var position = {'x': x, 'y': y };

            } else {
                var position = {'x': x, 'y': y};
            }

            if (!parseInt(route_years_array[i].hidden)) {
                route_layer.append('circle')
                .attr('id', nbr_points)
                .attr('class', 'points_route_' + route.id)
                .attr('cx', x)
                .attr('cy', y )
                .style('fill', color)
                .style('opacity', opacity)
                .attr('r', '0')
                .transition()
                .duration(700)
                .delay(delay)
                .ease('bounce')
                .attr('r', point_radius);
            }

            data.push(position);

            nbr_points++;
        } else {
            //console.log('texte simple');
        }
    }

    //on refait une passe pour vérifier si le premier point est bien positionné
    if (1 < pif.year_width(pif.years[route_years_array[0].id])) {

        // calcul de rect_next
        if (route_years_array[1]) {
            var x = parseFloat($('#0.points_route_' + route.id).attr('cx'));
            var y = parseFloat($('#0.points_route_' + route.id).attr('cy'));

            var flag = 0;
            var id_next_point = 1;
            while(flag == 0) {
                if ('pif_year' != route_years_array[id_next_point].type) {
                    id_next_point++;
                } else {
                    flag = 1;
                    var next_point = data[1];
                }
            }
            var x_next_point = next_point.x;
            var y_next_point = next_point.y;

            var final_pos = 1;
            var pos_found = 0;

            if (0 == pif.design) {
                for(var j = 1; j < pif.year_width(pif.years[route_years_array[0].id]); j++) {
                    var actual_length = Math.sqrt(Math.pow(x_next_point - (x + (width_rect + rect_padd) * j), 2) + Math.pow(y_next_point - y, 2));
                    var previous_length = Math.sqrt(Math.pow(x_next_point - (x + (width_rect + rect_padd) * (j - 1)), 2) + Math.pow(y_next_point - y, 2));

                    if (previous_length < actual_length) {
                        final_pos = j - 1;
                        if (0 != final_pos) {
                            x = x + (width_rect + rect_padd) * final_pos;
                        }
                        pos_found = 1;
                        data[0] = {'x': x, 'y': y}
                        break;
                    }
                }
                if (0 == pos_found) {
                    final_pos = pif.year_width(pif.years[route_years_array[0].id]) - 1;
                    x = x + (width_rect + rect_padd) * final_pos - rect_padd;
                }
            } else if (1 == pif.design) {
                for(var j = 1; j < pif.year_width(pif.years[route_years_array[0].id]); j++) {
                    var actual_length = Math.sqrt(Math.pow(x_next_point - (x + (width_rect + rect_padd) * j), 2) + Math.pow(y_next_point - (y + (x + (width_rect + rect_padd) * j - x ) * 0.07), 2));
                    var previous_length = Math.sqrt(Math.pow(x_next_point - (x + (width_rect + rect_padd) * (j - 1)), 2) + Math.pow(y_next_point - (y + (x + (width_rect + rect_padd) * (j - 1) - x ) * 0.07), 2));

                    if (previous_length < actual_length) {
                        final_pos = j - 1;
                        if (0 != final_pos) {
                            x = x + (width_rect + rect_padd) * final_pos;
                            y = y + (x + (((width_rect + rect_padd) * final_pos )) - x ) * 0.07;
                        }
                        pos_found = 1;
                        data[0] = {'x': x, 'y': y}
                        break;
                    }
                }
                if (0 == pos_found) {
                    final_pos = pif.year_width(pif.years[route_years_array[0].id]) - 1;
                    x = x + (width_rect + rect_padd) * final_pos - rect_padd;
                    y = y + (x + (((width_rect + rect_padd) * final_pos )) - x ) * 0.07;
                }
            }


            var position = {'x': x, 'y': y};

            $('#0.points_route_' + route.id).remove();

            route_layer.append('circle')
            .attr('id', '0')
            .attr('class', 'points_route_' + route.id)
            .attr('cx', x)
            .attr('cy', y )
            .style('fill', color)
            .style('opacity', opacity)
            .attr('r', '0')
            .transition()
            .duration(700)
            .delay(delay)
            .ease('bounce')
            .attr('r', point_radius);
        }
    }
    var vertical_length_to_base = $('.base_pif' + pif.id).offset().top - data[0].y;
    var base_pos_x = $('.base_pif' + pif.id).offset().left - offset_svg.left;
    var base_pos_y = $('.base_pif' + pif.id).offset().top - offset_svg.top;
    var horizontal_length_to_base = Math.abs(data[0].x - base_pos_x);
    var vertical_length_to_base = Math.abs(data[0].y - base_pos_y);

    var text_offset = $('#text_pif' + pif.id).offset();

    var x_text = (text_offset.left - offset_svg.left);
    var y_text = (text_offset.top - offset_svg.top);
    var text_width = $('#text_pif' + pif.id)[0].getBoundingClientRect().width;

    if (base_linked) { // on relie la base au premier point
        if (0 == pif.design) {
            var x_point_base = data[0].x;
            var y_point_base = base_pos_y + $('.base_pif' + pif.id)[0].getBoundingClientRect().height / 2;

            //si le point est à la même position que le texte de la base
            if (x_point_base >= x_text - 6 && x_point_base <= (x_text + text_width + 6)) {
                var y_point_base = y_text - point_radius;
            }
        } else if (1 == pif.design) {
            var y_point_base_tmp = base_pos_y + horizontal_length_to_base * 0.07;
            var length_y = y_point_base_tmp - data[0].y; // longueur verticale entre 1er et 2eme point
            var x_point_base = data[0].x + (length_y * -0.33); //position en x en fonction de la longueur
            var length_x = data[0].x - x_point_base; //longueur entre ancienne et nouvelle position x
            var shift_pos_y_final = length_x * 0.07; // décalage à ajouter au y
            var y_point_base = y_point_base_tmp - shift_pos_y_final;

            //si le point est à la même position que le texte de la base
            if (x_point_base >= x_text - 6 && x_point_base <= (x_text + text_width + 6)) {
                var new_y_point_base = y_text - point_radius;
                var shift_x = (y_point_base - new_y_point_base) * -0.3;
                x_point_base = x_point_base - shift_x;
                y_point_base = new_y_point_base + (x_point_base - x_text) * 0.07;
            }
        }
        if (!parseInt(route.years[0].hidden)) {
            route_layer.append('circle')
            .attr('id', '0')
            .attr('class', 'points_route_' + route.id)
            .attr('cx', x_point_base)
            .attr('cy', y_point_base)
            .style('fill', color)
            .style('opacity', opacity)
            .attr('r', '0')
            .transition()
            .duration(700)
            .delay(delay)
            .ease('bounce')
            .attr('r', point_radius);
        }

        var position = {'x': x_point_base, 'y': y_point_base};
        data.unshift(position);

    }

    var line = d3.svg.line()
    .x (function(d) {return d.x})
    .y (function(d) {return d.y});

    var path = route_layer.selectAll('path')
    .data([data])
    .enter()
    .append('path')
    .attr('d', line)
    .attr('fill', 'none')
    .attr('stroke', color)
    .style('opacity', opacity)
    .attr('stroke-width', '3');

    var totalLength = path.node().getTotalLength();

    var shift_x = d3.select('#pif_' + pif.id + '_area').attr('transform').match(/translate\((-?[0-9]+\.?[0-9]*)[, ]?\ ?(0)?\)/)[1];
    route_layer.attr('transform', 'translate(' + -shift_x + ')');

    path.attr('stroke-dasharray', totalLength + " " + totalLength)
    .attr('stroke-dashoffset', totalLength)
    .transition()
    .duration(2 * totalLength)
    .delay(delay)
    .ease('linear')
    .attr('stroke-dashoffset', 0);

    // si le pif dépasse la zone visible
    if (movable_area_w + shift_left + shift_right > $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
        var BB_route_left = $('#route_layer_pif_' + pif.id)[0].getBoundingClientRect().left - $('#pif_' + pif.id + '_container')[0].getBoundingClientRect().left;
        var BB_route_width = $('#route_layer_pif_' + pif.id)[0].getBoundingClientRect().width;
        var BB_svg_area = $('#svg_area_' + pif.id)[0].getBoundingClientRect();

        var container = d3.select('#pif_' + pif.id + '_container');
        var svgBB = $('#pif_' + pif.id + '_container .pif_years_group_' + pif.id)[0].getBBox();
        var pif_width = $('#pif_' + pif.id + '_container').outerWidth();

        var x = -BB_route_left + shift_left + 20;

        //permet de centre la vue sur la route si celle-ci ne dépasse pas de la zone visible
        if (BB_route_width < pif_width - shift_left - shift_right) {
            x = x - 20 + (((pif_width - shift_left - shift_right) - BB_route_width) / 2)
        }

        svg.attr('transform', 'translate(' + pos_init + ',0)'); //on remet le svg à la position ou il était avant de commencer l'animation pour ne pas avoir de 'saut' visuel


        if (0 == pif.design) {
            if (movable_area_w + shift_left + shift_right> $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                if (x > -(movable_area_w - pif_width + 20) - shift_right && x < shift_left) {
                    $('#oni-ico-fleche4_left_pif_' + pif.id).css('visibility', 'visible');
                    $('#oni-ico-fleche4_right_pif_' + pif.id).css('visibility', 'visible');
                    $('#half-circle-right_pif_' + pif.id).css('visibility', 'visible');
                    $('#half-circle-left_pif_' + pif.id).css('visibility', 'visible');
                    zoom[pif.id].translate([x, zoom[pif.id].translate()[1]]);
                } else if (x >= shift_left) {// limite gauche
                    $('#oni-ico-fleche4_left_pif_' + pif.id).css('visibility', 'hidden');
                    $('#half-circle-left_pif_' + pif.id).css('visibility', 'hidden');
                    $('#oni-ico-fleche4_right_pif_' + pif.id).css('visibility', 'visible');
                    $('#half-circle-right_pif_' + pif.id).css('visibility', 'visible');
                    x = shift_left;
                    zoom[pif.id].translate([x, zoom[pif.id].translate()[1]]);
                } else {// limite droite
                    $('#oni-ico-fleche4_right_pif_' + pif.id).css('visibility', 'hidden');
                    $('#half-circle-right_pif_' + pif.id).css('visibility', 'hidden');
                    $('#oni-ico-fleche4_left_pif_' + pif.id).css('visibility', 'visible');
                    $('#half-circle-left_pif_' + pif.id).css('visibility', 'visible');
                    x = -(movable_area_w - pif_width + 20) - shift_right;
                    zoom[pif.id].translate([x, zoom[pif.id].translate()[1]]);
                }
                svg.transition()
                .duration(delay-100)
                .ease('quad')
                .attr('transform', 'translate(' + x + ',0)');
            }
        } else if (1 == pif.design) {
            if (movable_area_w + shift_left + shift_right > $('#svg_area_' + pif.id)[0].getBoundingClientRect().width) {
                if (x > -(movable_area_w - pif_width + 40 + shift_right) && x < (20 + shift_left) ) {
                    $('#oni-ico-fleche4_left_pif_' + pif.id).css('visibility', 'visible');
                    $('#half-circle-left_pif_' + pif.id).css('visibility', 'visible');
                    $('#oni-ico-fleche4_right_pif_' + pif.id).css('visibility', 'visible');
                    $('#half-circle-right_pif_' + pif.id).css('visibility', 'visible');
                    zoom[pif.id].translate([x, zoom[pif.id].translate()[1]]);
                } else if (x >= (20 + shift_left)) {// limite gauche
                    $('#oni-ico-fleche4_left_pif_' + pif.id).css('visibility', 'hidden');
                    $('#half-circle-left_pif_' + pif.id).css('visibility', 'hidden');
                    $('#oni-ico-fleche4_right_pif_' + pif.id).css('visibility', 'visible');
                    $('#half-circle-right_pif_' + pif.id).css('visibility', 'visible');
                    x = (20 + shift_left);
                    zoom[pif.id].translate([x, zoom[pif.id].translate()[1]]);
                } else {// limite droite
                    $('#oni-ico-fleche4_right_pif_' + pif.id).css('visibility', 'hidden');
                    $('#half-circle-right_pif_' + pif.id).css('visibility', 'hidden');
                    $('#oni-ico-fleche4_left_pif_' + pif.id).css('visibility', 'visible');
                    $('#half-circle-left_pif_' + pif.id).css('visibility', 'visible');
                    x = -(movable_area_w - pif_width + 40) - shift_right;
                    zoom[pif.id].translate([x, zoom[pif.id].translate()[1]]);
                }
                svg.transition()
                .duration(delay-100)
                .ease('quad')
                .attr('transform', 'translate(' + x + ',0)');
            }
        }
    }
    zoom_value = 1;
    pif.setArrowsVisibility();
}



var route_zoom = new Array(); // Permet d'avoir plusieurs routes sur la même page

/*****************************************************************
 * Dessine les parcours isolés
 ***************************************************************/

function drawEmbedRoute(route, panel, routeId){
    var scale_value = 1;
    route_zoom[routeId] = d3.behavior.zoom().on('zoom', route_zoomed);
    /****************************************************************************************************************************
     * Fonction qui va permettre d'effectuer des translations du svg s'il est plus grand que la zone dans laquelle il se trouve
     ****************************************************************************************************************************/

    function route_zoomed() {
        var actual_route_id = $(this).attr('route');
        var route_width = $('#movable_area_' + actual_route_id)[0].getBoundingClientRect().width;
        var route_container_width = $('#route_' + actual_route_id)[0].getBoundingClientRect().width;

        //si la route est plus grande que son container
        if (route_width > route_container_width) {
            if (route_zoom[actual_route_id].translate()[0] > -(route_width + 20) + route_container_width && route_zoom[actual_route_id].translate()[0] < 10) {
                $('#left_arrow_route_' + actual_route_id).css('visibility', 'visible');
                $('#right_arrow_route_' + actual_route_id).css('visibility', 'visible');
                $('#half-circle-left_route_' + actual_route_id).css('visibility', 'visible');
                $('#half-circle-right_route_' + actual_route_id).css('visibility', 'visible');
                var t = route_zoom[actual_route_id].translate();
                tx = t[0];
                tx = Math.min(tx, 10);
                tx = Math.max(tx, -(route_width + 20) + route_container_width);
                movable_area.attr('transform', 'translate(' + tx + ', 0) scale(' + scale_value + ')');
            } else if (route_zoom[actual_route_id].translate()[0] >= 0) { // limite gauche
                $('#left_arrow_route_' + actual_route_id).css('visibility', 'hidden');
                $('#right_arrow_route_' + actual_route_id).css('visibility', 'visible');
                $('#half-circle-left_route_' + actual_route_id).css('visibility', 'hidden');
                $('#half-circle-right_route_' + actual_route_id).css('visibility', 'visible');
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) { // permet de ne pas bloquer le scroll vertical lorsqu'on est sur le bord gauche du pif
                    route_zoom[actual_route_id].translate([10, route_zoom[actual_route_id].translate()[1]]);
                } else {
                    route_zoom[actual_route_id].translate([10, 0]);
                }
                movable_area.attr('transform', 'translate(10 ,0) scale(' + scale_value + ')');
            } else { // limite droite
                $('#left_arrow_route_' + actual_route_id).css('visibility', 'visible');
                $('#right_arrow_route_' + actual_route_id).css('visibility', 'hidden');
                $('#half-circle-left_route_' + actual_route_id).css('visibility', 'visible');
                $('#half-circle-right_route_' + actual_route_id).css('visibility', 'hidden');
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) { // permet de ne pas bloquer le scroll vertical lorsqu'on est sur le bord gauche du pif
                    route_zoom[actual_route_id].translate([-(route_width + 20) + route_container_width, route_zoom[actual_route_id].translate()[1]]);
                } else {
                    route_zoom[actual_route_id].translate([-(route_width + 20) + route_container_width, 0]);
                }
                movable_area.attr('transform', 'translate(' + (-(route_width + 20) + route_container_width ) + ',0) scale(' + scale_value + ')');
            }
        }

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            //permet de scroller verticalement sur mobile
            window.scrollBy(0, -(route_zoom[actual_route_id].translate()[1])/10);
            route_zoom[actual_route_id].translate([route_zoom[actual_route_id].translate()[0], 0]);
        }
    }

    var screen_limit = 320,
    duration = 200,
    route_data = new Array(),
    color = 0,
    color_array = new Array(),
    route_years = route.yearsData;

    //définition des couleurs et création des données pour le svg
    for(var i = 0; i < route_years.length; i++) {
        if (route_years[i].type != 'simple_text') {
            color = get_year_background_color(route_years[i].id);

            //Récupère la couleur de l'année suivante (si c'est un diplôme et qu'il n'est pas dans le PIF,
            // le get_year_background_color renverra 0 mais il faut quand même
            // que cette année ait la même couleur que celle des années de la formation qui suit)
            if (0 == color && 0 == i && route_years[i + 1]) {
                color = get_year_background_color(route_years[i + 1].id)
            }
            //si la formation de l'année est la même que celles précédentes, on prend la même couleur
            if (i > 0 && route_years[i-1].formation_name && route_years[i].formation_name == route_years[i-1].formation_name) {
                color = color_array[i-1];
            }
        } else { // si l'année est une année en dehors du PIF
            color = '#AFAFAF';
        }

        if (0 == color) {
            color = getRandomColor(color_array);
        }
        color_array.push(color);
        year_data = {'yearId': route_years[i].id , 'color': color, 'name': route_years[i].name, 'type': route_years[i].type, 'description': route_years[i].description};

        route_data.push(year_data);
    }

    var route_svg = d3.select(panel).append('svg')
            .attr('class', 'embedded_route embedded_route_' + routeId)
            .attr('route', routeId)
            .call(route_zoom[routeId])
            .on('mousewheel.zoom', null)
            .on('DOMMouseScroll.zoom', null)
            .on('wheel.zoom', null);

    var movable_area = route_svg.append('g')
            .attr('class', 'movable_area')
            .attr('id', 'movable_area_' + routeId);

    route_zoom[routeId].translate([10, 0]);

    var route_group = movable_area.append('g')
            .attr('class', 'route_group')
            .attr('id', 'route_' + routeId + '_group');

    var lines = route_group.selectAll('path').data(route_data)
            .enter()
            .append('line');

    var circles = route_group.selectAll('circle').data(route_data)
            .enter()
            .append('circle');

    var route_text_group = movable_area.append('g')
            .attr('class', 'route_text_group')
            .attr('id', 'route_' + routeId + '_text_group');

    var text = route_text_group.selectAll('text').data(route_data)
            .enter()
            .append('text');

    var description = route_text_group.selectAll('.embedded_route_description').data(route_data)
            .enter()
            .append('text');

    var animation_count = 1;

    if ('undefined' == typeof embedded_route_view) {// si la route est utilisée dans le pif
        //création des lignes entre chaque point
        var lAttr = lines
            .attr('x1', function(yearData) { return 20; })
            .attr('y1', function(yearData, i) { return ((i * 25) + 10); })
            .attr('x2', function(yearData) { return 20; })
            .attr('y2', function(yearData, i) { return ((i * 25) + 10); })
            .attr('class', 'embedded_route_line route_' + routeId )
            .attr('stroke', function(yearData) { return yearData.color; })
            .attr('stroke-width', 3)
            .attr('i', function(yearData, i) {return i;})
            .attr('id', function(yearData, i) { return 'route_' + routeId + '_line_' + i ;});

        //création des cercles
        var cAttr = circles
            .attr('id', function(yearData){
                if ('pif_year' == yearData.type) {
                    return 'embedded_route_' + routeId + '_circle_year_' + yearData.yearId;
                }
                return 'embedded_route_' + routeId + '_circle_year_' + yearData.yearId + '_diploma';
            })
            .attr('class', 'embedded_route_circle route_' + routeId)
            .attr('cx', '20')
            .attr('cy', function(yearData, i) {return (i * 25) + 10; })
            .attr('fill', function(yearData) { return yearData.color; })
            .attr('r', 0)
            .attr('route', routeId)
            .attr('year', function(yearData){return yearData.yearId;})
            .attr('i', function(yearData, i){return i;})
            .on('click', function() {
                var routeId = $(this).attr('route'),
                routeNumber = $(this).attr('i');
                // lorsque l'animation est terminée
                if (animation_count >= route_data.length && d3.select('.description_' + routeNumber + '.route_' + routeId).text()) {
                    var all_circles = d3.selectAll('.embedded_route_circle.route_' + routeId);
                    var all_lines = d3.selectAll('.embedded_route_line.route_' + routeId);
                    var all_texts = d3.selectAll('.embedded_route_text.route_' + routeId);
                    var all_descriptions = d3.selectAll('.embedded_route_description.route_' + routeId);

                    //remise à zéro des différents éléments
                    all_lines.each(function(d, i) {
                        d3.select(this).attr('x1', '20')
                        .attr('y1', ((i * 25) + 10))
                        .attr('x2', '20')
                        .attr('y2', (((i + 1) * 25) + 10));
                    });

                    all_circles.each(function(d, i) {
                        d3.select(this).attr('cy', (i * 25) + 10);
                    });

                    all_texts.each(function(d, i) {
                        // permet de garder la bonne position du texte s'il y a plusieurs lignes
                        var tspan_childs = d3.select(this.childNodes);
                        var y_shift = (tspan_childs.node().length - 1) * 5;

                        d3.select(this).attr('y', ((i * 25) + 15) - y_shift);
                        d3.selectAll(this.childNodes).each(function() {
                            d3.select(this).attr('y', ((i * 25) + 15) - y_shift);
                        })
                    });

                    all_descriptions.each(function(d, i) {
                        d3.select(this).style('visibility', 'hidden');
                    });

                    var description_height = d3.select(all_descriptions[0][routeNumber]).node().getBBox().height;

                    route_svg.style('height', route_data.length * 25 + 10 + 'px');
                    if (!d3.select(this).classed('active')) {
                        if (d3.select('#route_' + routeId + '_line_' + routeNumber)[0][0]) {
                            d3.select('#route_' + routeId + '_line_' + routeNumber)
                                .attr('y2', parseInt(d3.select('#route_' + routeId + '_line_' + routeNumber).attr('y2')) + description_height + 10);
                        }

                        d3.select(all_descriptions[0][routeNumber]).style('visibility', 'visible');

                        all_circles.classed('active', false);
                        all_texts.classed('active', false);

                        for(var i = parseInt(routeNumber) + 1; i < all_circles[0].length; i++) {
                            d3.select(all_circles[0][i]).attr('cy', parseInt(d3.select(all_circles[0][i]).attr('cy')) + description_height + 10);
                            d3.select(all_texts[0][i]).attr('y', parseInt(d3.select(all_texts[0][i]).attr('y')) + description_height + 10);
                            var text_childs = d3.selectAll(all_texts[0][i].childNodes);
                            text_childs.each(function() {
                                d3.select(this).attr('y', parseInt(d3.select(this).attr('y')) + description_height + 10);
                            })
                            if (all_lines[0][i]) {
                                d3.select(all_lines[0][i]).attr('y1', parseInt(d3.select(all_lines[0][i]).attr('y1')) + description_height + 10)
                                .attr('y2', parseInt(d3.select(all_lines[0][i]).attr('y2')) + description_height + 10);
                            }
                        }
                        route_svg.style('height', route_data.length * 25 + 10 + description_height + 10 + 'px');
                        d3.select(this).classed('active', true);
                        d3.select(all_texts[0][routeNumber]).classed('active', true);
                    } else {
                        d3.select(this).classed('active', false);
                        d3.select(all_texts[0][routeNumber]).classed('active', false);
                    }
                    $('#tabs_left_' + pif.id).css('bottom', $('#portraits_container_' + pif.id)[0].getBoundingClientRect().height);
                }
            });

        //création des titres des années
        var tAttr = text
            .attr('id', function(yearData){
                if ('pif_year' == yearData.type) {
                    return 'embedded_route_' + routeId + '_text_year_' + yearData.yearId;
                }
                return 'embedded_route_' + routeId + '_text_year_' + yearData.yearId + '_diploma';
            })
            .attr('class', 'embedded_route_text route_' + routeId)
            .text( function (yearData) {
                if ('diploma' == yearData.type) {
                    return yearData.name.toUpperCase();
                }
                return yearData.name;
            })
            .attr('x', 40)
            .attr('y', function (yearData, i) { return ((i * 25) + 15);})
            .attr('i', function(yearData, i){return i;})
            .attr('route', routeId)
            .attr('font-size', '15px')
            .attr('fill', 'black')
            .attr('fill-opacity', 0)
            .attr('route', routeId)
            .on('click', function() {
                var routeId = $(this).attr('route'),
                routeNumber = $(this).attr('i');
                //lorsque l'animation est terminée
                if (animation_count >= route_data.length && d3.select('.description_' + routeNumber + '.route_' + routeId).text()) {
                    var all_circles = d3.selectAll('.embedded_route_circle.route_' + routeId);
                    var all_lines = d3.selectAll('.embedded_route_line.route_' + routeId);
                    var all_texts = d3.selectAll('.embedded_route_text.route_' + routeId);
                    var all_descriptions = d3.selectAll('.embedded_route_description.route_' + routeId);

                    //remise à zero des différents éléments
                    all_lines.each(function(d, i){
                        d3.select(this).attr('x1', '20')
                        .attr('y1', ((i * 25) + 10))
                        .attr('x2', '20')
                        .attr('y2', (((i + 1) * 25) + 10));
                    });

                    all_circles.each(function(d, i){
                        d3.select(this).attr('cy', (i * 25) + 10);
                    });

                    all_texts.each(function(d, i){
                        // permet de garder la bonne position du texte s'il y a plusieurs lignes
                        var tspan_childs = d3.select(this.childNodes);
                        var y_shift = (tspan_childs.node().length - 1) * 5;

                        d3.select(this).attr('y', ((i * 25) + 15) - y_shift);
                        d3.selectAll(this.childNodes).each(function() {
                            d3.select(this).attr('y', ((i * 25) + 15) - y_shift);
                        })
                    });

                    //on cache toutes les descriptions
                    all_descriptions.each(function(d, i){
                        d3.select(this).style('visibility', 'hidden');

                    });

                    //hauteur de la description de l'année selectionnée
                    var description_height = d3.select(all_descriptions[0][routeNumber]).node().getBBox().height;
                    //on redimensionne le svg en prenant en compte la hauteur de la description
                    route_svg.style('height', route_data.length * 25 + 10 + 'px');

                    //si l'année sur laquelle on a cliquée n'est pas déjà active
                    if (!d3.select(this).classed('active')) {

                        if (d3.select('#route_' + routeId + '_line_' + routeNumber)[0][0]) {
                            d3.select('#route_' + routeId + '_line_' + routeNumber)
                                .attr('y2', parseInt(d3.select('#route_' + routeId + '_line_' + routeNumber).attr('y2')) + description_height + 10);
                        }

                        d3.select(all_descriptions[0][routeNumber]).style('visibility', 'visible');

                        all_circles.classed('active', false);
                        all_texts.classed('active', false);

                        for(var i = parseInt(routeNumber) + 1; i < all_circles[0].length; i++) {
                            d3.select(all_circles[0][i]).attr('cy', parseInt(d3.select(all_circles[0][i]).attr('cy')) + description_height + 10);
                            d3.select(all_texts[0][i]).attr('y', parseInt(d3.select(all_texts[0][i]).attr('y')) + description_height + 10);
                            var text_childs = d3.selectAll(all_texts[0][i].childNodes);
                            text_childs.each(function() {
                                d3.select(this).attr('y', parseInt(d3.select(this).attr('y')) + description_height + 10);
                            });
                            if (all_lines[0][i]) {
                                d3.select(all_lines[0][i]).attr('y1', parseInt(d3.select(all_lines[0][i]).attr('y1')) + description_height + 10)
                                .attr('y2', parseInt(d3.select(all_lines[0][i]).attr('y2')) + description_height + 10);
                            }
                        }
                        route_svg.style('height', route_data.length * 25 + 10 + description_height + 10 + 'px');
                        d3.select(this).classed('active', true);
                        d3.select(all_circles[0][routeNumber]).classed('active', true);
                    } else {
                        d3.select(this).classed('active', false);
                        d3.select(all_circles[0][routeNumber]).classed('active', false);
                    }
                    $('#tabs_left_' + pif.id).css('bottom', $('#portraits_container_' + pif.id)[0].getBoundingClientRect().height);
                }
            });

        //création des descriptions des années
        var dAttr = description
            .attr('id', function(yearData){return 'embedded_route_' + routeId + '_description_year_' + yearData.yearId;})
            .attr('class', function(yearData, i){ return 'embedded_route_description description_' + i + ' route_' + routeId; })
            .attr('year', function(yearData){return yearData.yearId;})
            .attr('i', function(yearData, i){return i;})
            .attr('x', 50)
            .attr('y', function(yearData, i){return ((i * 25) + 35);})
            .text(function(yearData) {
                if (yearData.description) {
                    return jQuery(yearData.description).text();
                } else {// s'il n'y a pas de description
                    $(document).ready(function() {
                        if ('pif_year' == yearData.type) {
                            d3.select('#embedded_route_' + routeId + '_text_year_' + yearData.yearId).style('cursor', 'default');
                            d3.select('#embedded_route_' + routeId + '_circle_year_' + yearData.yearId).style('cursor', 'default');
                        } else {
                            d3.select('#embedded_route_' + routeId + '_text_year_' + yearData.yearId + '_diploma').style('cursor', 'default');
                            d3.select('#embedded_route_' + routeId + '_circle_year_' + yearData.yearId+ '_diploma').style('cursor', 'default');
                        }
                    });
                }
            })
            .call(wrap, $('.embedded_route_' + routeId)[0].getBoundingClientRect().width - 50, 50, 0)
            .style('visibility', 'hidden');

            d3.selectAll('.embedded_route_text').call(wrap, $('.embedded_route_' + routeId)[0].getBoundingClientRect().width - 40, 40, 1);

            $('#route_' + routeId + '_line_' + (route_data.length - 1)).remove();
            route_svg.style('height', route_data.length * 25 + 10 + 'px');
    } else {
        // si la route n'est pas utilisée dans le PIF

        //création des lignes entre chaque point
        var lAttr = lines
            .attr('class', 'embedded_route_line route_' + routeId )
            .attr('x1', function(yearData, i) { return ((i * 40) + 10); })
            .attr('y1', function(yearData) { return 10 })
            .attr('x2', function(yearData, i) { return ((i * 40) + 10); })
            .attr('y2', function(yearData) { return 10 })
            .attr('stroke', function(yearData){ return yearData.color; })
            .attr('stroke-width', 3)
            .attr('i', function(yearData, i) {return i;})
            .attr('year', function(yearData){ return yearData.yearId; })
            .attr('id', function(yearData, i) { return 'route_' + routeId + '_line_' + i ;});

        //création des cercles
        var cAttr = circles
            .attr('id', function(yearData){
                if ('pif_year' == yearData.type) {
                    return 'embedded_route_' + routeId + '_circle_year_' + yearData.yearId;
                }
                return 'embedded_route_' + routeId + '_circle_year_' + yearData.yearId + '_diploma';
            })
            .attr('class', 'embedded_route_circle route_' + routeId)
            .attr('cx', function(yearData, i) {return (i * 40) + 10; })
            .attr('cy', function(yearData) {return 10; })
            .attr('i', function(yearData, i) {return i;})
            .attr('year', function(yearData){ return yearData.yearId; })
            .attr('fill', function(yearData) { return yearData.color; })
            .attr('r', 0)
            .attr('route', routeId)
            .on('click' , function() {
                var routeId = $(this).attr('route'),
                routeNumber = $(this).attr('i');

                if (animation_count >= route_data.length && d3.select('.description_' + routeNumber + '.route_' + routeId).text()) {
                    var all_lines = d3.selectAll('.embedded_route_line.route_' + routeId);
                    var all_texts = d3.selectAll('.embedded_route_text.route_' + routeId);
                    var all_rects = d3.selectAll('.desc_bg_rect.route_' + routeId);
                    var all_desc_lines = d3.selectAll('.desc_line.route_' + routeId);
                    all_descriptions = d3.selectAll('.embedded_route_description.route_' + routeId);
                    all_circles = d3.selectAll('.embedded_route_circle.route_' + routeId);

                    if (!d3.select(this).classed('active')) {
                        all_rects.style('visibility', 'hidden').style('opacity', 0);
                        all_descriptions.style('visibility', 'hidden').style('opacity', 0);
                        all_desc_lines.style('visibility', 'hidden').attr('y2', 10);
                        all_circles.classed('active', false);
                        all_texts.classed('active', false);

                        d3.select(all_rects[0][routeNumber]).style('visibility', 'visible')
                        .transition()
                        .duration(150)
                        .ease('quad')
                        .style('opacity', 1);

                        d3.select(all_descriptions[0][routeNumber]).style('visibility', 'visible')
                        .transition()
                        .duration(150)
                        .ease('quad')
                        .style('opacity', 1);

                        d3.select(all_desc_lines[0][routeNumber]).style('visibility', 'visible')
                        .transition()
                        .duration(150)
                        .ease('quad')
                        .attr('y2', 85);

                        d3.select(this).classed('active', true);

                        d3.select(all_circles[0][routeNumber]).classed('active', true);
                    } else {
                        all_rects.style('visibility', 'hidden');
                        all_descriptions.style('visibility', 'hidden');
                        all_desc_lines.style('visibility', 'hidden');
                        all_circles.classed('active', false);
                        all_texts.classed('active', false);
                    }
                }
            });

        //création des descriptions des années
        var dAttr = description.attr('class', function(yearData, i) {return 'embedded_route_description description_' + i + ' route_' + routeId;})
            .attr('id', function(yearData){return 'embedded_route_' + routeId + '_description_year_' + yearData.yearId;})
            .attr('year', function(yearData){return yearData.yearId;})
            .attr('i', function(yearData, i){return i;})
            .attr('y', function(yearData){return 100;})
            .attr('route', routeId)
            dAttr.text(function(yearData) {
                if (yearData.description) {
                    return jQuery(yearData.description).text();
                } else {
                    $(document).ready(function() {
                        if ('pif_year' == yearData.type) {
                            d3.select('#embedded_route_' + routeId + '_text_year_' + yearData.yearId).style('cursor', 'default');
                            d3.select('#embedded_route_' + routeId + '_circle_year_' + yearData.yearId).style('cursor', 'default');
                            d3.select('#desc_bg_route_' + routeId + '_year_' + yearData.yearId).style('display', 'none');
                            d3.select('#desc_line_route_' + routeId + '_year_' + yearData.yearId).style('display', 'none');
                        } else {
                            d3.select('#embedded_route_' + routeId + '_text_year_' + yearData.yearId + '_diploma').style('cursor', 'default');
                            d3.select('#embedded_route_' + routeId + '_circle_year_' + yearData.yearId+ '_diploma').style('cursor', 'default');
                            d3.select('#desc_bg_route_' + routeId + '_year_' + yearData.yearId + '_diploma').style('display', 'none');
                            d3.select('#desc_line_route_' + routeId + '_year_' + yearData.yearId + '_diploma').style('display', 'none');
                        }
                    });
                }
            })
            .call(wrap, $('.embedded_route_' + routeId)[0].getBoundingClientRect().width - 50, 0 , 0)
            .style('visibility', 'hidden')
            .on('click', function() {
                var routeId = $(this).attr('route');

                var all_rects = d3.selectAll('.desc_bg_rect.route_' + routeId);
                var all_circles = d3.selectAll('.embedded_route_circle.route_' + routeId);
                var all_texts = d3.selectAll('.embedded_route_text.route_' + routeId);
                var all_descriptions = d3.selectAll('.embedded_route_description.route_' + routeId);
                var all_desc_lines = d3.selectAll('.desc_line.route_' + routeId);

                all_rects.style('visibility', 'hidden');
                all_descriptions.style('visibility', 'hidden');
                all_desc_lines.style('visibility', 'hidden');
                all_circles.classed('active', false);
                all_texts.classed('active', false);
            });

        //permet d'avoir la bonne position des descriptions en fonction de la bounding box
        dAttr.attr('x', function(yearData, i) {
            var descBB = d3.select(this).node().getBBox();
            var pos = ((i * 40) + 10) - descBB.width / 2;
            if (10 > pos) {
                pos = 10;
            }
            var text_childs = d3.selectAll(this.childNodes);
            text_childs.each(function() {
                d3.select(this).attr('x', pos);
            });
            return pos;
        });

        //positionne toutes les descriptions
        var all_descriptions = d3.selectAll('.embedded_route_description.route_' + routeId);
        var all_circles = d3.selectAll('.embedded_route_circle.route_' + routeId);

        all_descriptions.each(function(yearData, i){
            var actual_desc = d3.select(this),
            textBB = actual_desc.node().getBBox();

            actual_desc.style('visibility', 'hidden');
            var childs = d3.selectAll(actual_desc[0][0].childNodes);

            //lignes pour descripitions
            route_text_group.insert('line', '#embedded_route_' + routeId + '_description_year_' + yearData.yearId + '.description_' + i)
            .attr('id', function (){
                if ('pif_year' == yearData.type) {
                    return 'desc_line_route_' + routeId + '_year_' + yearData.yearId;
                }
                return 'desc_line_route_' + routeId + '_year_' + yearData.yearId + '_diploma';
            })
            .attr('class', 'desc_line route_' + routeId)
            .attr('x1', (i * 40) + 10)
            .attr('y1', 10)
            .attr('x2', (i * 40) + 10)
            .attr('y2', 10)
            .attr('stroke', yearData.color)
            .attr('stroke-width', 2)
            .attr('i', i)
            .attr('year', yearData.yearId);

            //bg des descriptions
            route_text_group.insert('rect', '#embedded_route_' + routeId + '_description_year_' + yearData.yearId + '.description_' + i)
            .attr('id', function (){
                if ('pif_year' == yearData.type) {
                    return 'desc_bg_route_' + routeId + '_year_' + yearData.yearId;
                }
                return 'desc_bg_route_' + routeId + '_year_' + yearData.yearId + '_diploma';
            })
            .attr('class', 'desc_bg_rect route_' + routeId)
            .attr('width', textBB.width + 10)
            .attr('height', textBB.height + 10)
            .attr('i', i)
            .attr('year', yearData.yearId)
            .attr('x', function() {
                var descBB = d3.select(this).node().getBBox();
                var pos = ((i * 40) + 5) - (descBB.width - 10) / 2;
                if (10 > pos) {
                    pos = 5;
                }
                return pos;
            })
            .attr('y', 85)
            .attr('fill', 'white')
            .style('stroke', yearData.color);
        });


        //création des titres des années
        var tAttr = text
            .attr('id', function(yearData){
                if ('pif_year' == yearData.type) {
                    return 'embedded_route_' + routeId + '_text_year_' + yearData.yearId;
                }
                return 'embedded_route_' + routeId + '_text_year_' + yearData.yearId + '_diploma';
            })
            .attr('class', 'embedded_route_text route_' + routeId)
            .text( function (yearData) {
                if ('diploma' == yearData.type) {
                    return yearData.name.toUpperCase();
                }
                return yearData.name;
            })
            .attr('i', function(yearData, i) {return i;})
            .attr('year', function(yearData){ return yearData.yearId; })
            .attr('transform', function(yearData,i){
                return 'translate(' + ((i * 40) + 10) + ', 25) rotate(45)';
            })
            .attr('font-size', '15px')
            .attr('fill', 'black')
            .attr('fill-opacity', 1)
            .attr('route', routeId)
            .on('click', function() {
                var routeId = $(this).attr('route'),
                routeNumber = $(this).attr('i');

                if (animation_count >= route_data.length && d3.select('.description_' + routeNumber + '.route_' + routeId).text()) {
                    var all_lines = d3.selectAll('.embedded_route_line.route_' + routeId);
                    var all_texts = d3.selectAll('.embedded_route_text.route_' + routeId);
                    var all_rects = d3.selectAll('.desc_bg_rect.route_' + routeId);
                    var all_desc_lines = d3.selectAll('.desc_line.route_' + routeId);
                    all_descriptions = d3.selectAll('.embedded_route_description.route_' + routeId);
                    all_circles = d3.selectAll('.embedded_route_circle.route_' + routeId);

                    var description_height = d3.select(all_descriptions[0][routeNumber]).node().getBBox().height;

                    if (!d3.select(this).classed('active')) {
                        all_rects.style('visibility', 'hidden').style('opacity', 0);
                        all_descriptions.style('visibility', 'hidden').style('opacity', 0);
                        all_desc_lines.style('visibility', 'hidden').attr('y2', 10);
                        all_circles.classed('active', false);
                        all_texts.classed('active', false);

                        d3.select(all_rects[0][routeNumber]).style('visibility', 'visible')
                        .transition()
                        .duration(150)
                        .ease('quad')
                        .style('opacity', 1);

                        d3.select(all_descriptions[0][routeNumber]).style('visibility', 'visible')
                        .transition()
                        .duration(150)
                        .ease('quad')
                        .style('opacity', 1);

                        d3.select(all_desc_lines[0][routeNumber]).style('visibility', 'visible')
                        .transition()
                        .duration(150)
                        .ease('quad')
                        .attr('y2', 85);

                        d3.select(this).classed('active', true);

                        d3.select(all_circles[0][routeNumber]).classed('active', true);
                    } else {
                        all_rects.style('visibility', 'hidden');
                        all_descriptions.style('visibility', 'hidden');
                        all_desc_lines.style('visibility', 'hidden');
                        all_circles.classed('active', false);
                        all_texts.classed('active', false);
                    }
                }
            });

        //création de la zone qui va accueillir le texte (nom prénom du portrait + description)
        var text_container = d3.select('#route_' + routeId + '_text');

        text_container.append('div')
            .attr('class', 'route_title')
            .text(route.firstname + ' ' + route.name);

        text_container.append('div')
            .attr('class', 'route_text')
            .text(jQuery(route.route_content).text());

        $('#route_' + routeId + '_line_' + (route_data.length - 1)).remove();
        route_svg.style('height', (8 + $('#route_' + routeId + '_text_group')[0].getBoundingClientRect().height + 5) + 'px')
            .style('width', $('#movable_area_' + routeId)[0].getBoundingClientRect().width + 15 + 'px')
            .style('max-width', $('#route_' + routeId)[0].getBoundingClientRect().width + 'px');

        tAttr.attr('fill-opacity', 0);

        var left_half = d3.select('#route_' + routeId).append('div')
            .attr('class', 'half-circle-left')
            .attr('id', 'half-circle-left_route_' + routeId)
            .attr('route', routeId)
            .style('top', ($('#route_' + routeId)[0].getBoundingClientRect().height / 2) - 15 + 'px')
            .style('visibility', 'hidden')
            .on('click', function() {
                var routeId = $(this).attr('route');

                d3.select('#movable_area_' + routeId)
                .transition()
                .duration(500)
                .ease('quad')
                .attr('transform', 'translate(10,0)');
                route_zoom[routeId].translate([10, 0]);
                $('#left_arrow_route_' + routeId).css('visibility', 'hidden');
                $('#right_arrow_route_' + routeId).css('visibility', 'visible');
                $('#half-circle-left_route_' + routeId).css('visibility', 'hidden');
                $('#half-circle-right_route_' + routeId).css('visibility', 'visible');
            });

        var right_half = d3.select('#route_' + routeId).append('div')
            .attr('class', 'half-circle-right')
            .attr('id', 'half-circle-right_route_' + routeId)
            .attr('route', routeId)
            .style('top', ($('#route_' + routeId)[0].getBoundingClientRect().height / 2) - 15  + 'px')
            .on('click', function() {
                var routeId = $(this).attr('route');

                var route_width = $('#movable_area_' + routeId)[0].getBoundingClientRect().width;
                var route_container_width = $('#route_' + routeId)[0].getBoundingClientRect().width;
                d3.select('#movable_area_' + routeId)
                .transition()
                .duration(500)
                .ease('quad')
                .attr('transform', 'translate(' + (-(route_width + 20) + route_container_width ) + ', 0)');
                route_zoom[routeId].translate([(-(route_width + 20) + route_container_width ), 0]);
                $('#left_arrow_route_' + routeId).css('visibility', 'visible');
                $('#right_arrow_route_' + routeId).css('visibility', 'hidden');
                $('#half-circle-left_route_' + routeId).css('visibility', 'visible');
                $('#half-circle-right_route_' + routeId).css('visibility', 'hidden');
            })
            .style('visibility', function() {
                var route_width = $('#movable_area_' + routeId)[0].getBoundingClientRect().width;
                var route_container_width = $('#route_' + routeId)[0].getBoundingClientRect().width;
                if (route_width > route_container_width) {
                    return 'visible';
                }
                return 'hidden';
            });

        var left_arrow = d3.select('#route_' + routeId)
            .append('div')
            .attr('id', 'left_arrow_route_' + routeId)
            .attr('class', 'oni-ico-fleche4 route_left_arrow')
            .attr('route', routeId)
            .style('visibility', 'hidden')
            .style('top', ($('#route_' + routeId)[0].getBoundingClientRect().height / 2) + 'px')
            .on('click', function() {
                var routeId = $(this).attr('route');

                d3.select('#movable_area_' + routeId)
                .transition()
                .duration(500)
                .ease('quad')
                .attr('transform', 'translate(10,0)');
                route_zoom[routeId].translate([10, 0]);
                $('#left_arrow_route_' + routeId).css('visibility', 'hidden');
                $('#right_arrow_route_' + routeId).css('visibility', 'visible');
                $('#half-circle-left_route_' + routeId).css('visibility', 'hidden');
                $('#half-circle-right_route_' + routeId).css('visibility', 'visible');
            });

        var right_arrow = d3.select('#route_' + routeId)
            .append('div')
            .attr('id', 'right_arrow_route_' + routeId)
            .attr('class', 'oni-ico-fleche4 route_right_arrow')
            .attr('route', routeId)
            .style('top', ($('#route_' + routeId)[0].getBoundingClientRect().height / 2) + 'px')
            .on('click', function() {
                var routeId = $(this).attr('route');

                var route_width = $('#movable_area_' + routeId)[0].getBoundingClientRect().width;
                var route_container_width = $('#route_' + routeId)[0].getBoundingClientRect().width;
                d3.select('#movable_area_' + routeId)
                .transition()
                .duration(500)
                .ease('quad')
                .attr('transform', 'translate(' + (-(route_width + 20) + route_container_width ) + ', 0)');
                route_zoom[routeId].translate([(-(route_width + 20) + route_container_width ), 0]);
                $('#left_arrow_route_' + routeId).css('visibility', 'visible');
                $('#right_arrow_route_' + routeId).css('visibility', 'hidden');
                $('#half-circle-left_route_' + routeId).css('visibility', 'visible');
                $('#half-circle-right_route_' + routeId).css('visibility', 'hidden');
            })
            .style('visibility', function() {
                var route_width = $('#movable_area_' + routeId)[0].getBoundingClientRect().width;
                var route_container_width = $('#route_' + routeId)[0].getBoundingClientRect().width;
                if (route_width > route_container_width) {
                    return 'visible';
                }
                return 'hidden';
            });


        if (screen_limit > screen.width) {
            scale_value = 0.8;

            $('.route_left_arrow').css('font-size', '20px');
            $('.route_right_arrow').css('font-size', '20px');
            $('.half-circle-left')
            .css('height', '48px')
            .css('width', '24px');

            $('.half-circle-right')
            .css('height', '48px')
            .css('width', '24px');
        }
        movable_area.attr('transform', 'translate(10,0) scale(' + scale_value + ')');
    }

    var active = 0;
    //l'animation se lance lorsque la route est visible
    $(document).ready(function() {
        if (isInViewport($('#route_' + routeId)) && 1 != active) {
            active = 1;
            if ('undefined' == typeof embedded_route_view) { // si la route est utilisée dans le pif
                lAttr
                .transition()
                .duration(duration)
                .delay(function(yearData, i){ return duration * i; })
                .ease('linear')
                .attr('x2', function(yearData, i) { return 20; })
                .attr('y2', function(yearData, i) { return (((i + 1) * 25) + 10); });
            } else {
                lAttr
                .transition()
                .duration(duration)
                .delay(function(yearData,i){ return duration * i })
                .ease('linear')
                .attr('x2', function(yearData, i) { return (((i + 1) * 40) + 10); })
                .attr('y2', function(yearData, i) { return 10; });
            }

            cAttr.transition()
            .duration(duration + 200)
            .delay(function(yearData, i){ return duration * i})
            .ease('bounce')
            .attr('r', function(yearData){
                if ('diploma' == yearData.type) {
                    return 8;
                }
                return 5;
            })
            .each('end', function() {
                animation_count++;
            });

            tAttr.transition()
            .duration(duration)
            .delay(function(yearData, i){ return duration * i })
            .attr('fill-opacity', 1);
        }
    });


    //si la route n'est pas visible dès le chargement de la page, on test si elle l'est au scroll
    $(window).on('scroll', function() {
        if (isInViewport($('#route_' + routeId)) && 1 != active) {
            active = 1;
            if ('undefined' == typeof embedded_route_view){ // si la route est utilisée dans le pif
                lAttr.transition()
                .duration(duration)
                .delay(function(yearData,i){ return duration * i })
                .ease('linear')
                .attr('x2', function(yearData, i) { return 20; })
                .attr('y2', function(yearData, i) { return (((i + 1) * 25) + 10); });
            } else {
                lAttr
                .transition()
                .duration(duration)
                .delay(function(yearData, i){ return duration * i })
                .ease('linear')
                .attr('x2', function(yearData, i) { return (((i + 1) * 40) + 10); })
                .attr('y2', function(yearData, i) { return 10; });
            }

            cAttr.transition()
            .duration(duration + 400)
            .delay(function(yearData,i){ return duration * i })
            .ease('bounce')
            .attr('r', function(yearData){
                if ('diploma' == yearData.type) {
                    return 8;
                }
                return 5;
            })
            .each('end', function() {
                    animation_count++;
            });

            tAttr.transition()
            .duration(duration)
            .delay(function(yearData, i){ return duration * i })
            .attr('fill-opacity', 1);
        }
    });
}


/****************************************************************************************************************************
 * Permet d'avoir des couleurs différentes pour les parcours isolés
 ****************************************************************************************************************************/

function getRandomColor(color_array) {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * 16)];
    }

    //permet de ne pas avoir les même couleurs dans un parcours ou la couleur des formations en dehors du PIF
    if (-1 < color_array.indexOf(color) || color == '#AFAFAF') {
        color = getRandomColor(color_array);
    }
    return color;
}

/****************************************************************************************************************************
 * Permet de savoir si l'élément est visible dans le viewport
 ****************************************************************************************************************************/

function isInViewport($element) {
    var elemH = $element.outerHeight(),
        windowH = $(window).height(),
        elementBB = $element[0].getBoundingClientRect(),
        elementTop = elementBB.top,
        elementBottom = elementBB.bottom;

    if (0 < elementTop && windowH > elementTop) {
        return true;
    }
    return false;
}


/****************************************************************************************************************************
 * Fait des retour à la ligne dans un texte svg s'il dépasse de la largeur passée en paramètre
 * 'resize' permet d'avoir une police plus petite (utilisé dans les titres des années pour la route isolée)
 ****************************************************************************************************************************/
function wrap(text, width, x, resize) {
    text.each(function() {
        var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = 1.3, // ems
            y = text.attr("y"),
            dy = 0;
            tspan = text.text(null).append('tspan').attr('class', 'child').attr('x', x).attr('y', y).attr('dy', dy + 'em');
        var count = 0;

        while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(' '));
            if (tspan.node().getComputedTextLength() > width) {
                count++;
                line.pop();
                tspan.text(line.join(' '));
                line = [word];

                if (resize) { //si on veut que le texte ait une police plus petite (utilisé pour les titres des années dans la route isolée)
                    lineHeight = 0.9;
                    tspan = text.append('tspan').attr('class', 'child').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
                    var tspans = d3.select(this.childNodes);
                    for(var i = 0 ; i < tspans[0][0].length ; i++) {
                        d3.select(tspans[0][0][i]).attr('y', y - count * 4);
                        d3.select(tspans[0][0][i].parentNode).attr('font-size', (13 - count) + 'px');
                    }
                } else {
                    tspan = text.append('tspan').attr('class', 'child').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
                }
            }
        }
    });
}
function wrapTitleDiploma(text, year_id) {
    text.each(function(year_id) {
        var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [];
        var count = 0;

        if ($('#pif_' + pif.id + '_area #pif_years_group_id' + pif.id ).attr( 'class' ).indexOf('double_column') > -1) {
            var width = (w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding) * 2;
        } else {
            var width = w_rect * pif.year_width(pif.years[year_id]) + (pif.year_width(pif.years[year_id]) - 1) * rect_padding;
        }

        if (words.length > 1 ) {
            var tspan = text.text(words[0]);
            var stock = text.text(words[0]);
            while (word = words.pop()) {
                line.push(word);
                tspan.text(line.join(' '));
                //console.log(width);
                if (tspan.node().getComputedTextLength() > width) {
                    count++;
                    line.pop();
                    tspan.text(line.join(' '));
                    line = [word];
                    tspan = text.append('tspan').attr('class', 'child').attr('x', 0).attr('dy', 10).text(word);
                    text.attr('y', -12);
                }
            }
        }
    });
}
